export default {
    "en": {
        "achievement": {
            "achievement": "Achievement",
            "achievements": "Achievements",
            "overview_description": "List of all the available achievements",
            "select_campaign": "Select Campaign",
            "go_to_achievements": "Go to achievements",
            "properties": {
                "name": "Name",
                "once": "Once",
                "score": "Score",
                "award": "Award"
            },
            "time": {
                "today": "today",
                "yesterday": "yesterday",
                "two_days_ago": "two days ago",
                "this_week": "this week",
                "last_week": "last week",
                "two_weeks_ago": "two weeks ago",
                "three_weeks_ago": "three weeks ago",
                "four_weeks_ago": "four weeks ago",
                "five_weeks_ago": "five weeks ago"
            },
            "status": {
                "status": "Status",
                "playing": "Playing",
                "completed": "Completed",
                "not_completed": "Collect all achievements!",
                "last_achievement": "Last achievement",
                "no_last_achievement": "You have not yet achieved any achievement"
            },
            "actions": {
                "grant": {
                    "failed": "Unable to grant the achievement"
                }
            },
            "validations": {
                "not_found": "Achievement not found"
            }
        },
        "answer": {
            "answer": "Answer",
            "answers": "Answers",
            "properties": {
                "correct": "Correct",
                "correct_answer": "Correct answer",
                "correct_answers": "Correct answers",
                "correct_answer_description": "This is the correct answer of to the question",
                "possible_answers": "Possible answers",
                "provided_answer": "Provided answer"
            },
            "actions": {
                "create": {
                    "action": "Add answer",
                    "success": "Answer created",
                    "failed": "Unable to save the answer"
                },
                "update": {
                    "action": "Edit answer",
                    "success": "Answer updated",
                    "failed": "Unable to update the answer"
                },
                "delete": {
                    "action": "Remove answer",
                    "confirm": "Remove the answer to the question. The answer will be removed immediately. Are you sure you want to continue?",
                    "success": "Answer removed",
                    "failed": "Unable to remove the answer"
                },
                "restore": {
                    "action": "Restore answer",
                    "confirm": "When restoring the answer, the answer will be visible immediately. Are you sure you want to continue?",
                    "success": "Answer restored",
                    "failed": "Unable to restore the answer"
                }
            },
            "validations": {
                "invalid_answer_provided": "Invalid answer provided"
            }
        },
        "api_token": {
            "api_tokens": "API tokens",
            "api_token": "API token",
            "overview_description": "Manage the API tokens of connected apps",
            "not_expiring": "No expiration date",
            "none_assigned": "There are no assigned API tokens.",
            "properties": {
                "name": "Name",
                "expires_at": "Expires at",
                "created_by": "Created by",
                "is_global": "Global token",
                "is_global_description": "A global token can be used to access the resources of all organisations.",
                "organisations": "Organisations"
            },
            "actions": {
                "create": {
                    "success": "API token created",
                    "failed": "Unable to create the API token"
                },
                "update": {
                    "action": "Edit API token",
                    "success": "API token updated",
                    "failed": "Unable to update the API token"
                },
                "delete": {
                    "action": "Remove API token",
                    "confirm": "When removing the API token, the application with this API token loses access immediately. Are you sure you want to remove this API token?",
                    "success": "API token removed",
                    "failed": "Unable to remove the API token"
                },
                "show": {
                    "failed": "Unable to show the API token"
                },
                "generate": {
                    "failed": "Unable to generate the API token"
                },
                "sync": {
                    "action": "Update organisations",
                    "success": "Organisations of the API tokens are updated",
                    "is_global": "Organisations of a global API token cannot be updated"
                }
            }
        },
        "app_score": {
            "actions": {
                "create": {
                    "failed": "Unable to update the app score"
                }
            },
            "scores_filled_in": "Both scores are already filled in",
            "score": "SCORE",
            "finished": {
                "start_again": "Start again",
                "finish": "Finish",
                "score_achieved": "SCORE ACHIEVED",
                "text": "Outstanding Effort! Ready for the next workout or aiming to beat your score?"
            },
            "battle": {
                "try_again": "Try Again",
                "submit_your_score": "Submit Your Score",
                "submit_and_see_who_won": "Submit and See Who Won",
                "text": "Outstanding Effort! Submit your score and see who won!"
            }
        },
        "auth": {
            "email": "E-mail address",
            "password_field": "Password",
            "register": {
                "register": "Register",
                "description": "Create an account for :app. By creating an account your progress will be tracked and available everywhere you log in.",
                "no_account": "No account?",
                "no_account_description": "When you haven't got an account, you can <a href=\":link\">here<\/a>.",
                "already_has_account": "Do you already have an account?",
                "not_allowed": "Registration not allowed",
                "not_allowed_description": "Sorry, but this organisation has disabled registration. Ask you instructor for an invite.",
                "register_not_allowed": "Registration not allowed",
                "register_not_allowed_description": "Sorry, but this organisation has turned off registration. Please ask your instructor for an invitation."
            },
            "phonenumber_field": "Phonenumber",
            "reseller": {
                "not_allowed": "Organisation isn't a reseller",
                "not_allowed_description": "Sorry, but this organisation has no reseller permissions. Contact your accountmanager for reseller permissions."
            },
            "demo": {
                "play": "Play as demo user",
                "description": "Instead of registering, you can also play as demo user. Progress will be tracked but on other devices or when clearing your browser history, you'll loose your progress. When playing as a demo user, you can still save your account.",
                "description_no_registration": "Instead of registering, you can also play as demo user. Progress will be tracked but on other devices or when clearing your browser history, you'll loose your progress."
            },
            "login": {
                "login": "Login",
                "remember_me": "Remember me",
                "required": "You need to be logged in to perform this action"
            },
            "logout": {
                "logout": "Logout"
            },
            "forgotten": {
                "password_instructions": "Enter the data to change your password.",
                "change_password": "Change password",
                "reset_link_sent": "When your e-mail address is found, the instructions are sent. Check your e-mail and click the link in the e-mail to reset your password.",
                "reset_link_not_sent": "Unfortunately we're unable to send the e-mail with the instructions. Contact your instructor for help.",
                "send_instructions": "Send instructions",
                "confirm_password": "Confirm password",
                "confirm_password_description": "Confirm your password to continue.",
                "forgot_password": "Forgot password",
                "forgot_password_description": "In the case you forgot your password, fill in your e-mail address. After that you will receive an e-mail with instructions how to reset your password.",
                "forgot_your_password": "Forgot your password?",
                "check_spam_folder": "If you do not see the email in a few minutes, check your \u201cjunk mail\u201d folder or \u201cspam\u201d folder."
            },
            "verify": {
                "verify": "Verify your e-mail address",
                "click_below": "Please click the button below to verify your email address.",
                "check_email": "A verification link has been sent to your email address with a link to complete your registration.",
                "resent": "A fresh verification link has been sent to your email address.",
                "before": "Before proceeding, please check your email for a verification link.",
                "not_received": "If you did not receive the email",
                "request": "Click here to request another",
                "not_requested": "If you did not create an account, no further action is required."
            },
            "account_exists": {
                "exists": "You tried to register but you already have an account.",
                "forgot_password": "If you have forgotten your password, you can reset it via \"Forgot your password\"."
            },
            "device_flow": {
                "start": {
                    "failed": "Unable to start the authentication request"
                },
                "invalid": {
                    "title": "Invalid request",
                    "description": "The authentication request is invalid. Scan the QR-code or use the proper link to start the authentication"
                },
                "expired": {
                    "title": "Request expired",
                    "description": "The authentication request is valid for a limited amount of time. Start the authentication again on your other device"
                },
                "organisations": {
                    "select": "Select organisation",
                    "none": "This account is not a member of any organisation. Ask your instructor to add you to an organisation."
                },
                "finish": {
                    "title": "Logged in",
                    "description": "Your are now logged in successfully and can start playing on your other device"
                },
                "no_organisations": {
                    "title": "No organisations found",
                    "description": "The application you're trying to login to, has no access to organisations you have access to."
                }
            },
            "delete": {
                "verify": "Verify account deletion",
                "click_below": "Please click the button below to verify you want to delete your account.",
                "not_requested": "If you did not ask for account deletion, no further action is required.",
                "mail_sent": "If this email address exists, you will receive an email, click on the link in the email to confirm that you want to delete your account.",
                "confirm": "I know the consequences, and I'm sure that I want to delete my account"
            },
            "sso": {
                "generic": "Sorry, something went wrong logging you in using single sign-on. Please try again.",
                "no_id": ":configuration: no unique identifier provided by provider.",
                "no_email": ":configuration: no email address provided by provider.",
                "prohibited": "Login via SSO is prohibited for this user.",
                "not_a_member": "You must be invited to this organisation before you can sign in.",
                "user_data_request_error": ":configuration: provider responded with error code :code. Please try again and contact support if the error persists."
            },
            "failed": "These credentials do not match our records.",
            "password": "The provided password is incorrect.",
            "throttle": "Too many login attempts. Please try again in :seconds seconds.",
            "pending_invitation": "Please accept your invitation before signing in.",
            "get_mobile_app": {
                "title": "Install the mobile app",
                "description": "Please install our mobile app for a better experience.",
                "download_app_store": "Download on the App Store",
                "download_play_store": "Get it on Google Play"
            }
        },
        "battle": {
            "battle": "Battle",
            "battles": "Battles",
            "battle_leaderboard": "Battle scoreboard",
            "battle_arena": "Battle Arena",
            "properties": {
                "name": "Name",
                "description": "Description",
                "win_score": "Win bonus (50% for losing)",
                "score_factor": "Score factor for winning against a higher ranked player",
                "response_time": "Response time",
                "daily_limit": "Daily limit",
                "available": "Available",
                "available_from": "Available from",
                "available_till": "Available till",
                "no_limit": "no limit",
                "hours": "hours",
                "simultaneous_open_sessions": "Simultaneous open sessions",
                "simultaneous_open_sessions_unlimited": "Unlimited"
            },
            "insights": {
                "wins": "Wins",
                "count_completed_sessions": "# completed sessions",
                "count_unaccepted_sessions": "# unaccepted sessions",
                "average_score": "Average score",
                "count_unique_initiators": "# unique initiators",
                "count_unique_opponents": "# unique opponents",
                "percentage_of_sessions_where_opponent_wins": "% of completed sessions where opponent won",
                "average_time_to_complete_micro_game": "Average time to complete micro game",
                "average_time_to_accept_invitation": "Average time an invitation is open",
                "average_time_to_complete_session": "Average time for session to be completed"
            },
            "actions": {
                "create": {
                    "action": "Create battle",
                    "success": "Battle created",
                    "failed": "Unable to create the battle"
                },
                "update": {
                    "action": "Edit battle",
                    "success": "Battle updated",
                    "failed": "Unable to update the battle"
                },
                "delete": {
                    "action": "Remove battle",
                    "confirm": "When removing a battle, the battle is directly removed for all players. Are you sure you want to continue?",
                    "success": "Battle removed",
                    "failed": "Unable to remove the battle"
                },
                "stop": {
                    "action": "Stop battle",
                    "confirm": "When stopping a battle, the battle is directly removed for all players. Are you sure you want to continue?",
                    "success": "Battle stopped",
                    "failed": "Unable to stop the battle"
                }
            },
            "filter": {
                "select_campaign": "Select campaign"
            },
            "validations": {
                "not_owned": "The battle doesn't belong to your organisation",
                "already_played": "This battle has already been played by some users.",
                "overlaps": "Battle cannot overlap with other battles.",
                "no_micro_games": "This campaign has no micro game modules.",
                "outside_tournament": "This value is outside the times of the tournament."
            },
            "session": {
                "sessions": "Sessions",
                "date": "Date",
                "initiator": "Initiator",
                "opponent": "Opponent",
                "bonus": "Bonus",
                "not_found": "Battle session not found"
            },
            "profile": {
                "select_friend_to_challenge": "Select Friend To Challenge",
                "text": "Select the user that you want to challenge for this game",
                "battle_against_friends": "Battle Against Friends"
            },
            "score": {
                "text": "Outstanding Effort! Submit your score and see who won!"
            },
            "picked_randomly": "picked randomly",
            "pick_random_microgame": "Pick random micro game from campaign",
            "expired": "Battle is expired",
            "not_found": "Battle not found",
            "no_active": "There is no active battle right now.",
            "not_allowed": "You are not allowed to start another battle today try again tomorrow",
            "did_not_lose": "You cannot revenge a battle that you did not lose.",
            "already_completed": "You have already completed this battle.",
            "win": "{1} win|[0,2,*] wins",
            "wins": "{1} :count win|[0,2,*] :count wins",
            "challenge": "Challenge",
            "revanche": "Revanche",
            "challenges_you": ":name challenges you",
            "start": "Start battle",
            "battle_masters": "Battle masters",
            "battle_masters_popup": "Choose an opponent",
            "search_opponent": "Search Opponent",
            "challengers": "Challengers",
            "yourself": "You cannot challenge yourself",
            "wait_for_initiator": "Wait for a score to be placed by the challenger",
            "no_invitations": "You have not yet been challenged by a fellow player.",
            "no_history": "You haven't played any battles yet.",
            "too_many": "You already have too many active battles.",
            "campaign_is_tournament": "This campaign is in tournament mode, and can only be played between :dates. The battle must also be within that timeframe.",
            "game_anonymous": "Campaign is only accessible to anonymous users",
            "summary": {
                "header": {
                    "winner": "Winner",
                    "loser": "Lost",
                    "tied": "Tied"
                },
                "text": {
                    "score": "Score"
                },
                "battle_score": "Battle score",
                "score": {
                    "win": "Battle win",
                    "lost": "Battle lost",
                    "tied": "Battle tied"
                },
                "earned": "Total battle earned",
                "waiting_for_the_opponent": "Waiting for the opponent",
                "battle_again": "Battle Again"
            }
        },
        "battleground": {
            "battleground": "Battleground",
            "challenges": "Challenges",
            "start_new_battle": "Start New Battle",
            "active_battles": "Active Battles",
            "past_battles": "Past Battles",
            "you_won": "You Won",
            "you_lost": "You Lost",
            "tied": "Tied",
            "no_active_battles": "No active battles",
            "no_past_battles": "No past battles",
            "text": "To start battles go to games or challenges detail screen and start a battle with your friends.",
            "text_down": "You`ll be able to follow the progress of the battle here",
            "waiting_for_opponent": "Waiting for opponent",
            "waiting_for_you": "Waiting for you",
            "challenged_by": "Challenged By",
            "challenged": "Challenged",
            "hours_left": "hours left",
            "you": "You"
        },
        "campaign": {
            "campaign": "Program",
            "campaigns": "Programs",
            "programs": "Programs",
            "program": "Program",
            "new_campaign": "New program",
            "view_campaign": "View program",
            "management": {
                "description": "A program contains a collection of challenges and could be compared to a book where the challenges are chapters."
            },
            "insights": "Insights",
            "to_campaign": "To program",
            "already_played": "This program is already played by :amount players. Editing this program will result in changing their progress.",
            "transfer_requests": "Transfer requests",
            "copy_title": "Copy program",
            "copy": "Copy program to another organisation",
            "copy_button": "Send copy request",
            "copy_description": "The receiving organisation will get a request to copy the program. When they have accepted the request, the program will be copied.",
            "copyable_campaigns": "Programs that can be copied",
            "copy_howto": "To copy a camprogrampaign, open the program page and click the copy button next to it.",
            "copy_accept": "Copy the program",
            "copy_accept_confirmation": "Copy the program to your organisation. After that you are able to change the program to your requirements. Are you sure you want to copy the program?",
            "copy_deny": "Remove request",
            "copy_deny_confirmation": "Deny the request to copy the program to your organisation. After that you will no longer be able to copy the program to your organisation. Are you sure you want to continue?",
            "duplicate": "Duplicate program within own organisation",
            "duplicate_button": "Duplicate program",
            "duplicate_description": "The program along with all its challenges and modules will be duplicated within your organisation.",
            "outgoing_requests": "Programs that could be copied",
            "copy_revoke": "Revoke permission to copy",
            "copy_revoke_description": "When revoking the permission to copy the program, the receiving organisation is no longer allowed to copy the game. Are you sure you want to continue?",
            "copy_to_subdomain_description": "Enter the subdomain of the organisation you would like to copy the game to.",
            "leaderboard": "Leaderboard",
            "no_player": "No player",
            "completed": "Completed!",
            "percentage_completed": "of program completed",
            "progress": "Progress",
            "available_modules": "Available",
            "completed_modules": "Completed",
            "stars": "Stars",
            "battle_xp": "Battle :xp",
            "total_xp": "Total :xp",
            "status": {
                "scheduled": "Scheduled",
                "in_progress": "In progress",
                "done": "Done",
                "archived": "Archived"
            },
            "properties": {
                "name": "Name",
                "title": "Title",
                "finished_by": "Finished by",
                "finish_date": "Finish date",
                "run_time": "Run time",
                "description": "Description",
                "image": "Image",
                "image_select": "Select image",
                "icon": "Icon",
                "icon_select": "Select icon",
                "score": "Score",
                "bonus": "Bonus",
                "modules_completed": "modules completed",
                "owned_by": "Owned by",
                "shared_with": "Shared with",
                "hide_leaderboard": "Hide leaderboard",
                "access": "Access",
                "access_tags": "Only users with a tag",
                "access_tags_placeholder": "All registered users",
                "tournament": "Tournament",
                "enable_tournament": "Enable tournament mode",
                "tournament_start_at": "Tournament starts at",
                "tournament_duration": "Tournament duration",
                "tournament_status": "Tournament status",
                "tournament_end_at": "Tournament ends at",
                "leagues": "Leagues",
                "leagues_description": "When leagues are enabled, the leaderboard will be based on poules with promotion and relegation.",
                "league_enabled": "Enable leagues",
                "league_ideal_poule_size": "Ideal poule size",
                "league_switch_day": "Weekday",
                "league_switch_time": "Time",
                "league_promote_from_bronze": "Promote from Bronze to Silver",
                "league_relegate_from_silver": "Relegate from Silver to Bronze",
                "league_promote_from_silver": "Promote from Silver to Gold",
                "league_relegate_from_gold": "Relegate from Gold to Silver"
            },
            "access_options": {
                "all": "Everyone",
                "anonymous": "Anonymous users",
                "registered": "Registered users"
            },
            "actions": {
                "create": {
                    "action": "Create program",
                    "success": "Program created",
                    "failed": "Unable to create the program"
                },
                "update": {
                    "action": "Edit program",
                    "success": "Program updated",
                    "failed": "Unable to update the program"
                },
                "delete": {
                    "action": "Remove program",
                    "confirm": "When removing a program, the program is directly removed for all players. Are you sure you want to continue?",
                    "success": "Program removed",
                    "failed": "Unable to remove the program"
                },
                "restore": {
                    "action": "Restore program",
                    "confirm": "When restoring a program, the program is directly accessible. Are you sure you want to continue?",
                    "success": "Program restored",
                    "failed": "Unable to restore the program"
                },
                "order": {
                    "action": "Order programs",
                    "success": "Updated the order of the programs",
                    "error": "Could not update the order of the programs"
                },
                "transfer_request_create": {
                    "create": "Create transfer",
                    "success": "Transfer request sent",
                    "failed": "Unable to send the transfer request"
                },
                "transfer_request_delete": {
                    "success": "Transfer request removed",
                    "failed": "Unable to remove the transfer request"
                },
                "transfer": {
                    "success": "Transfer request processed",
                    "failed": "Unable to process the transfer request",
                    "skip_missing_microgames": "Skip inaccessible micro games"
                },
                "duplicate": {
                    "success": "Program duplicated"
                }
            },
            "validations": {
                "not_owned": "The program doesn't belong to your organisation",
                "no_access": "The organisation has no access to the program",
                "no_longer_available": "The program or requested part of the program is no longer available",
                "not_accessible": "You do not have access to this program",
                "transfer_already_sent": "Transfer request already sent to the organisation",
                "transfer_no_access": "The organisation has no rights to process the request",
                "no_access_to_microgames": "The organisation does not have access to one or more micro games. Contact your account manager for access. The program can still be copied but the module(s) with the following micro game(s) will be skipped:",
                "tournament_has_ended": "This program's tournament has ended and can no longer be played",
                "battle_outside_tournament": "This program has battles that fall entirely outside the tournament. Please delete these before configuring the tournament mode."
            },
            "tournament": {
                "warn_existing_battles": "This program has active or upcoming battles. In case a battle only partially overlaps with the tournament, its times will be adjusted."
            }
        },
        "challenge": {
            "challenge": "Day",
            "challenges": "Days",
            "challenge_description": "A day contains a collection of modules and can be compared to a chapter of a book.",
            "challenge_completed_at": "Day completed at",
            "challenge_play": "Play the day and achieve the high score",
            "challenge_not_playable": "The day can't be played",
            "challenge_not_playable_no_modules": "The day has 0 modules and therefor can't be played. Contact your instructor.",
            "challenge_completed": "Day completed",
            "challenge_completed_name": "Completed day :challenge",
            "challenge_completed_description": "Great work! You've completed the day!",
            "challenge_not_completed": "Day not completed",
            "challenge_not_completed_description": "Unfortunately the day is not completed. But... no problem! Just try it again!",
            "try_again": "Try again",
            "back_to_campaign": "Back to campaign",
            "next_challenge": "Start next day",
            "progress": "Progress",
            "start": "Start",
            "properties": {
                "name": "Name",
                "description": "Description",
                "image": "Image",
                "image_select": "Select image"
            },
            "actions": {
                "create": {
                    "action": "Add day",
                    "success": "Day created",
                    "failed": "Unable to create the day"
                },
                "update": {
                    "action": "Edit day",
                    "success": "Day updated",
                    "failed": "Unable to update the day"
                },
                "delete": {
                    "action": "Remove day",
                    "confirm": "The day will be removed from the campaign. This will result in players not being able to play or view this day. Are you sure you want to continue?",
                    "success": "Day removed",
                    "failed": "Unable to remove the day"
                },
                "restore": {
                    "action": "Restore day",
                    "confirm": "When restoring a day, the day is directly accessible. Are you sure you want to continue?",
                    "success": "Day restored",
                    "failed": "Unable to restore the day"
                },
                "order": {
                    "success": "Updated the order of the days",
                    "error": "Unable to update the order of the days"
                }
            },
            "validations": {
                "not_owned": "The day doesn't belong to your organisation",
                "must_be_part_of_organisation": "The day must belong to the organisation",
                "no_modules": "The day has 0 modules so it can't be played."
            }
        },
        "challenge_session": {
            "actions": {
                "update": {
                    "failed": "Unable to update the module session"
                }
            },
            "validations": {
                "must_be_part_of_organisation": "The challenge session must belong to a challenge of the organisation",
                "not_owned": "This challenge session isn't yours. Start the challenge from your own account",
                "too_old": "This challenge session is older then 8 hours. Please start the challenge again"
            }
        },
        "custom_tiles": {
            "custom_tile": "Custom tile",
            "custom_tiles": "Custom tiles",
            "yes": "Yes",
            "no": "No",
            "properties": {
                "name": "Name",
                "title": "Title",
                "image": "Image",
                "url": "Url",
                "identifier": "Identifier ",
                "image_select": "Select image",
                "enabled": "Enabled "
            },
            "filter": {
                "identifier": "Select identifier"
            },
            "actions": {
                "create": {
                    "action": "New custom tile",
                    "success": "Custom tile created",
                    "failed": "Unable to create the custom tile"
                },
                "update": {
                    "title": "Edit :type custom tile",
                    "success": "Custom tile updated",
                    "failed": "Unable to update the custom tile"
                }
            }
        },
        "dashboard": {
            "switch_account": "Switch account",
            "current_program": "current program",
            "personal-progress": "Personal Progress",
            "to-receive-certificate": "To receive Certificate",
            "highscores": "Highscores",
            "retry_last_performance": "Retry last performance",
            "no_last_performance": "You haven't participate in any campaigns",
            "to_fittar_app": "Fittar",
            "to_fittar_app_description": "Games & Exercises",
            "battle_mode": "Battle Mode",
            "battleground": "Battleground",
            "programs": "Programs",
            "exergames": "Exergames",
            "interactive_workouts": "Interactive Workouts",
            "fitness_video": "Fitness Video's",
            "leaderboard": "Leaderboard",
            "community": "Community",
            "support": "Support",
            "interactive_challenges": "Challenges",
            "videos": "Videos",
            "privacy_policy": "Privacy Policy",
            "faq": "FAQ",
            "user_tips": "User Tips",
            "terms_and_conditions": "Terms and Conditions",
            "tournament": "Tournament",
            "challenges": "Challenges",
            "battle_await": "Battles Await"
        },
        "direct_play_micro_game": {
            "micro_games": "Direct-play micro games",
            "explanation": "The campaigns shown here are only for context, as they may differ for each user depending on the campaigns they have access to. The micro games will always be shown at the position in this list.",
            "properties": {
                "name": "Name",
                "description": "Description",
                "image": "Image",
                "image_select": "Select image",
                "type": "Type",
                "hide_high_score": "Hide high score"
            },
            "actions": {
                "create": {
                    "action": "Create direct-play micro game",
                    "success": "Direct-play micro game created",
                    "failed": "Unable to create the direct-play micro game"
                },
                "update": {
                    "action": "Update direct-play micro game",
                    "success": "Direct-play micro game updated",
                    "failed": "Unable to update the direct-play micro game"
                },
                "order": {
                    "success": "Updated the order of the direct-play micro games"
                },
                "delete": {
                    "action": "Remove direct-play micro game",
                    "confirm": "When removing a direct-play micro game, it is directly removed for all players. Are you sure you want to continue?",
                    "success": "Direct-play micro game removed",
                    "failed": "Unable to remove the direct-play micro game"
                }
            },
            "validations": {
                "not_owned": "The direct-play micro game doesn't belong to your organisation"
            }
        },
        "domains": {
            "domains": "Domains",
            "domain": "Domain",
            "properties": {
                "domain": "Domain"
            },
            "actions": {
                "create": {
                    "action": "Add domain",
                    "success": "Domain created",
                    "failed": "Unable to create the domain"
                },
                "update": {
                    "action": "Edit domain",
                    "success": "Domain updated",
                    "failed": "Unable to update the domain"
                },
                "delete": {
                    "action": "Remove domain",
                    "confirm": "Are you sure you want to continue?",
                    "success": "Domain removed",
                    "failed": "Unable to remove the domain"
                }
            }
        },
        "exception": {
            "one_time_login_token_invalid": "Invalid one-time login token",
            "one_time_login_token_expired": "One-time login token is expired",
            "one_time_login_token_not_yet_valid": "One-time login token not yet valid",
            "one_time_login_token_consumed": "One-time login token already used",
            "one_time_login_token_not_for_organisation": "One-time login token not valid for this organisation",
            "route_not_found": "No route found for this request",
            "feature_only_available_playground_landscape": "This feature is only available on PlayGround theme",
            "feature_only_available_fittar": "This feature is only available on Fittar theme"
        },
        "gamified_video": {
            "gamified_video": "Gamified video",
            "gamified_videos": "Gamified videos",
            "overview_description": "Overview of all imported Gamified videos",
            "description": "A gamified video is an interactive video from HiHaHo. The available videos will be automatically retrieved from HiHaHo.",
            "select_available_video": "Select an available video",
            "preview": "preview",
            "properties": {
                "name": "Name",
                "folder": "Folder",
                "link": "Link",
                "external_id": "External ID",
                "embed_url": "Embed URL",
                "total": "Total",
                "created": "Created",
                "existing": "Existing"
            },
            "actions": {
                "play": {
                    "action": "Play the video below and then proceed."
                },
                "import": {
                    "action": "Import Gamified videos",
                    "description": "This will import the available Gamified videos from HiHaHo. This may take some time and should be run when some videos are missing. Are you sure you want to continue?",
                    "results": "Import results"
                }
            },
            "play_first": "Play the video first",
            "play_first_description": "Play the video before to proceed",
            "unable_to_retrieve_progress": "Unable to store the video progress, that means we're unable to store the progress. The developers are notified!"
        },
        "gamified_video_folder": {
            "gamified_video_folders": "Gamified video folders",
            "overview_description": "Overview of all the folders of the Gamified videos",
            "select_placeholder": "Select gamified video folder(s)",
            "none_assigned": "There are no assigned gamified video folders.",
            "properties": {
                "name": "Name",
                "external_id": "External ID"
            },
            "actions": {
                "update": {
                    "success": "Access to the gamified video folders is updated"
                }
            },
            "filter": {
                "folder": "Folder",
                "all_folders": "All folders"
            }
        },
        "general": {
            "start": "Start playing",
            "start_workout": "Start workout",
            "start_video": "Start video",
            "play_now": "Quick play",
            "quit": "Quit",
            "data": "Data",
            "data_tools": "Data & Tools",
            "dashboard": "Dashboard",
            "home": "Home",
            "welcome": "Welcome",
            "welcome_description": "Start playing by logging in",
            "required": "Required",
            "toggle_navigation": "Toggle navigation",
            "insights": "Insights",
            "back_to_dashboard": "Back to dashboard",
            "back_to_campaigns": "Back to campaigns",
            "back_to_exergames": "Back to exergames",
            "back_to_interactive_workouts": "Back to interactive workouts",
            "back_to_leaderboards": "Back to leaderboards",
            "control_panel": "Control panel",
            "no_avatar": "No avatar",
            "search": "Search",
            "search_placeholder": "Search...",
            "status": "Status",
            "active": "Active",
            "inactive": "Inactive",
            "archived": "Archived",
            "clear_filter": "Clear filter",
            "filter_results": "<strong>:start<\/strong> to <strong>:end<\/strong> of <strong>:total<\/strong> results",
            "results": "results",
            "access_denied": "Access denied",
            "access_denied_description": "Sorry, but you haven't got the proper permissions to access this functionality.",
            "unable_to_store_file": "Unable to store the file",
            "unable_to_process_file": "Unable to process the file",
            "upload_error": "Something went wrong during the upload",
            "invalid_file": "Invalid file provided",
            "file_too_large": "The file size of the selected file should ba a maximum of :size Mb. Reduce the file size to use this file",
            "import": "Import",
            "add": "Add",
            "create": "Create",
            "edit": "Edit",
            "filter": "Filter",
            "update": "Update",
            "manage": "Manage",
            "delete": "Delete",
            "restore": "Restore",
            "remove": "Remove",
            "assign": "Assign",
            "revoke": "Revoke",
            "failed": "Failed",
            "order": "Order",
            "save": "Save",
            "save_order": "Save order",
            "properties": "Properties",
            "export": "Export",
            "oops": "Oops...",
            "text": "Text",
            "header": "Header",
            "confirm": "Confirm",
            "send": "Send",
            "cancel": "Cancel",
            "minute": "minute",
            "minutes": "minutes",
            "minutes_short": "mins",
            "back": "Back",
            "finish": "Finish",
            "next": "Next",
            "summary": "Summary",
            "play_again": "Play again",
            "qr_code": "QR code",
            "qr_code_description": "Use this QR code to let player immediately start playing.",
            "qr_code_start": "Play immediately",
            "download": "Download",
            "download_svg": "Download SVG",
            "download_png": "Download PNG",
            "or_go_to": "or go to",
            "logout": "Logout",
            "profile": "Profile",
            "add_field": "Add field",
            "select_file": "Select file",
            "settings": "Settings",
            "no_results": "No results found",
            "loading": "Loading...",
            "close": "Close",
            "optional": "Optional",
            "is": "is",
            "seconds": "seconds",
            "selected": "selected",
            "language_unavailable_in_organisation": "not available for :organisation",
            "points": "Points",
            "score": "Score",
            "read_more": "Read more",
            "high_score": "High score",
            "everything": "Everything",
            "this_field": "This field",
            "reset": "Reset",
            "tournament": "TOURNAMENT",
            "score_not_set": "Score not set",
            "image_cannot_be_loaded": "The image cannot be loaded"
        },
        "interactive_workouts": {
            "no_available_interactive_workouts_in_category": "No available interactive Workouts in this category",
            "tailored_workout_plans": "Tailored workout plans"
        },
        "leaderboard": {
            "leaderboard": "Leaderboard",
            "tournament": "Tournament",
            "challenges": "Challenges",
            "games": "Games",
            "properties": {
                "rank": "Rank",
                "total": "Total",
                "player": "Player",
                "score": "Score",
                "bonus": "Bonus"
            },
            "league": {
                "levels": {
                    "bronze": "Bronze league",
                    "silver": "Silver league",
                    "gold": "Gold league"
                },
                "poule": "Poule",
                "promotion_zone": "Promotion zone",
                "relegation_zone": "Relegation zone",
                "user_promotion_zone": "You are in the promotion zone",
                "user_relegation_zone": "You are in the relegation zone",
                "xp_ahead": ":value :xp ahead to go to the next league",
                "xp_to_maintain": ":value :xp needed to be safe"
            }
        },
        "micro_game": {
            "micro_game": "Micro game",
            "micro_games": "Micro games",
            "your_latest_highscore": "Your Latest Highscore",
            "play": "Play",
            "management": {
                "title": "Micro games",
                "description": "Manage the available micro games.",
                "groups": {
                    "group": "Micro game group",
                    "groups": "Micro game groups",
                    "overview": "Manage the available micro game groups."
                }
            },
            "properties": {
                "name": "Name",
                "identifier": "Identifier",
                "description": "Description",
                "image": "Image",
                "image_select": "Select image",
                "group": "Group",
                "is_global": "Global Micro Game",
                "is_global_description": "A global micro game can be used by all organisations.",
                "organisations": "Organisations",
                "points": "Points",
                "stars": "Stars",
                "stars_threshold": "Stars threshold",
                "custom_data": "Custom data",
                "key": "Key",
                "value": "Value",
                "webgl_location": "WebGL location",
                "build": "Build",
                "categories": "Categories",
                "category": "Category"
            },
            "actions": {
                "bulk": {
                    "update": {
                        "success": "Micro games updated",
                        "failed": "Unable to update the micro games"
                    }
                },
                "create": {
                    "action": "Add micro game",
                    "success": "Micro game added",
                    "failed": "Unable to add the micro game"
                },
                "update": {
                    "action": "Edit micro game",
                    "success": "Micro game updated",
                    "failed": "Unable to update the micro game"
                },
                "delete": {
                    "action": "Remove micro game",
                    "confirm": "When removing the micro game, the players won't be able to play this anymore. Are you sure you want to continue?",
                    "success": "Micro game removed",
                    "failed": "Unable to remove the micro game"
                },
                "sync": {
                    "action": "Update organisations",
                    "success": "Organisations of the micro game are updated",
                    "is_global": "Organisations of a global micro game cannot be updated"
                }
            },
            "filter": {
                "all_groups": "All groups",
                "all_categories": "All categories",
                "select_micro_game": "Select micro game",
                "select_micro_game_of_group": "Select :group",
                "select_micro_game_group": "Select group"
            },
            "validations": {
                "organisation_must_have_access": "The organisation does not have access to this micro game."
            },
            "done_with_playing": "Done with playing",
            "ends": "Ends"
        },
        "micro_game_group": {
            "group": "Micro game group",
            "groups": "Micro game groups",
            "management": {
                "title": "Micro game groups",
                "description": "Manage the available micro game groups."
            },
            "properties": {
                "name": "Name",
                "identifier": "Identifier",
                "image": "Image",
                "image_select": "Select image",
                "build": "Build",
                "custom_data": "Custom data",
                "webgl_location": "WebGL location",
                "type": "Type",
                "categories": "Categories"
            },
            "types": {
                "micro_game": "Micro game",
                "fitness_content": "Fitness content",
                "exergame": "Exergame",
                "interactive_workout": "Interactive workout",
                "challenges": "Challenges"
            },
            "interactive_workout": {
                "categories": {
                    "upper_body": "Upper Body",
                    "lower_body": "Lower Body",
                    "full_body": "Full Body",
                    "cardio": "Cardio"
                },
                "exercise_time": "Exercise Time (minutes)"
            },
            "videos": {
                "categories": {
                    "office": "Office",
                    "endurance": "Endurance",
                    "strength": "Strength",
                    "dance": "Dance",
                    "yoga": "Yoga"
                },
                "exercise_time": "Video Exercise Time (minutes)",
                "no_available_video_in_category": "No available video in this category"
            },
            "filter": {
                "all_types": "All types",
                "select_type": "Select type",
                "select_category": "Select Category"
            },
            "actions": {
                "create": {
                    "action": "Add micro game group",
                    "success": "Micro game group added",
                    "failed": "Unable to add the micro game group"
                },
                "update": {
                    "action": "Edit micro game group",
                    "success": "Micro game group updated",
                    "failed": "Unable to update the micro game group"
                },
                "delete": {
                    "action": "Remove micro game group",
                    "confirm": "Are you sure you want to continue?",
                    "success": "Micro game group removed",
                    "failed": "Unable to remove the micro game group",
                    "prohibited": "Not allowed to remove a micro game group with micro games assigned to it"
                }
            }
        },
        "module": {
            "module": "Module",
            "module_type": "Type",
            "module_skills": "Skills",
            "modules": "Modules",
            "modules_completed": "Modules completed",
            "module_completed_at": "Module completed at",
            "module_play": "Play the module and achieve the high score",
            "proceed_with_challenge": "Click next to proceed with the challenge.",
            "properties": {
                "name": "Name",
                "description": "Description",
                "threshold": "Threshold",
                "threshold_description": "The threshold determines if the participant succeeded or failed.",
                "threshold_description_value": "The threshold is a percentage of the amount of correct answered questions. For example when the threshold is 75 and there are 4 questions, the participant needs to at least answqers 3 questions correctly.",
                "reading_time": "Read time",
                "viewed_video": "I have watched the video or watched it before.",
                "factor": "Factor",
                "factor_description": "The factor determines how many points are awarded. By default the player gains :default_score points for completing a module. By adjusting the factor you are able to increase or decrease the score.",
                "image": "Image",
                "image_select": "Select image",
                "content": "Content",
                "video": "Video",
                "video_url": "Video URL",
                "video_description": "Use the link to the video (from the address bar of your browser). This doesn't have to be a special link, the app will take care of that for you.",
                "text": "Text",
                "text_description": "A text module contains a short explanation or introduction and an image that accompanies the text when you play the module.",
                "question_time": "Time per question",
                "question_time_description": "The maximum amount of time available per question.",
                "total_questions_used": "Number of questions to display",
                "total_questions_used_description": "The number of questions shown to the players (empty = all questions). A random selection is used there are more questions than the provided number."
            },
            "actions": {
                "create": {
                    "title": "New :type module",
                    "success": "Module created",
                    "failed": "Unable to create the module"
                },
                "update": {
                    "title": "Edit :type module",
                    "success": "Module updated",
                    "failed": "Unable to update the module"
                },
                "delete": {
                    "action": "Remove module",
                    "confirm": "Remove the module from the challenge will result in nobody being able to play the module. Are you sure you want to continue?",
                    "success": "Module removed",
                    "failed": "Unable to remove the module",
                    "failed_battle": "Unable to remove the module because there is a battle that randomly picks a micro game from this campaign, and this is the last micro game in this campaign."
                },
                "restore": {
                    "action": "Restore module",
                    "confirm": "When restoring a module, the module is directly accessible. Are you sure you want to continue?",
                    "success": "Module restored",
                    "failed": "Unable to restore the module"
                },
                "order": {
                    "success": "Updated the order of the modules",
                    "failed": "Unable to update the order of the modules"
                }
            },
            "filter": {
                "all_types": "All types"
            },
            "validations": {
                "must_be_part_of_organisation": "The module must belong to the organisation",
                "invalid_properties": "The module type requires a configuration that's missing, for example when a related object is removed. Please edit or delete this module."
            },
            "already_played": "You have already played this module. Click on 'Next' to continue with the challenge."
        },
        "module_session": {
            "actions": {
                "create": {
                    "failed": "Unable to update the module session"
                },
                "update": {
                    "failed": "Unable to update the module session"
                }
            },
            "validations": {
                "not_owned": "Only edit your own module sessions"
            }
        },
        "organisation": {
            "organisation": "Organisation",
            "organisations": "Organisations",
            "crud_description": "The subdomain of the organisation must be unique and should consist of letters (a-z), numbers (0-9) and a dash (-)",
            "logo": "Logo",
            "select_placeholder": "Select organisation(s)",
            "universal_authentication_enabled": "Universal authentication enabled",
            "universal_authentication_enabled_description": "When enabled, the organisation uses the universal authentication flow",
            "validations": {
                "not_found": "Organisation not found",
                "not_a_member": "No access to the organisation"
            },
            "properties": {
                "customer": "Customer",
                "name": "Name",
                "subdomain": "Subdomain",
                "url": "Url",
                "languages": "Languages settings",
                "default_language": "Default language",
                "available_languages": "Supported languages",
                "available_languages_warning": "When removing a supported language, you will lose data for the removed language when editing an item.",
                "manage_translations": "Manage custom translations",
                "reseller": "Reseller",
                "gamified_video_folders": "Gamified video folders",
                "gamified_video_folders_description": "Select the gamified video folders that can be used by the organisation.",
                "social": "Social",
                "social_description": "Add an <a href=\"https:\/\/www.freecodecamp.org\/news\/what-is-open-graph-and-how-can-i-use-it-for-my-website\" target=\"_blank\">open graph<\/a> image and description.",
                "customization": "Customization",
                "customization_description": "The application can be customized for the organisation to have a matching look and feel",
                "logo": "Logo",
                "logo_requirements": "Max 4Mb",
                "logo_select": "Select logo",
                "open_graph_image": "Open graph image",
                "open_graph_image_requirements": "At least 640\u00d7320px, max 4Mb",
                "open_graph_image_select": "Select image",
                "open_graph_description": "Open graph description",
                "theme_setup": "Theme setup",
                "theme_look_and_feel": "Look and feel",
                "theme_select": "Select theme",
                "manage_theme": "Manage custom theme",
                "background": "Background",
                "background_mobile": "Background (mobile)",
                "background_tablet": "Background (tablet)",
                "background_desktop": "Background (desktop)",
                "background_requirements": "Max 4Mb",
                "background_select": "Select background",
                "primary_color": "Primary color",
                "secondary_color": "Secondary color",
                "accent_color": "Accent color",
                "card_backdrop": "Card backdrop",
                "background_color": "Background color",
                "background_gradient_bottom": "Background gradient bottom",
                "background_gradient_top": "Background gradient top",
                "card_background_color": "Card background color",
                "module_shadow_color": "Module shadow color",
                "primary_font_color": "Primary font color",
                "secondary_font_color": "Secondary font color",
                "primary_font_family": "Primary font family",
                "primary_font_family_select": "Select primary font...",
                "secondary_font_family": "Secondary font family",
                "secondary_font_family_select": "Select secondary font...",
                "preview_fonts": "Fonts can be previewed here: :url",
                "card_border_radius": "Card border radius",
                "welcome_text": "Welcome text",
                "welcome_text_description": "Defines the text shown on the login screen",
                "configuration": "Configuration",
                "configuration_description": "Determine which features are enabled for this organisation",
                "registration_allowed": "Registration allowed",
                "registration_allowed_header": "Registration<br>allowed",
                "registration_description": "Allow users to register without invitation",
                "global_content": "Global content",
                "global_content_description": "Allow orgonisation to use global content",
                "demo_user_allowed": "Playing as demo user allowed",
                "demo_user_allowed_header": "Demo users<br>allowed",
                "demo_user_description": "Allow users to play without an account. Be aware, <strong>no progress<\/strong> is being tracked",
                "allow_upgrade_to_registered_user": "Allow upgrade to registered user",
                "allow_upgrade_to_registered_user_description": "Allow demo users to upgrade to a registered user by adding and confirming their email address.",
                "reseller_allowed": "Organisation is reseller",
                "reseller_allowed_header": "Organisation<br>reseller",
                "reseller_description": "A reseller is able to create additional organisations as their customers",
                "webhook_url": "Webhook URL",
                "webhook_url_description": "There is the option to let the Gamification Player call a <a href=\":url\" target=\"_blank\">webhook<\/a> in certain events. The gamification player will <code>POST<\/code> several events to the webhook.",
                "webhook_secret": "Webhook secret",
                "webhook_secret_description": "As the gamification player is hosted on a cluster, there's no fixed IP-address available. You need to provide a <a href=\":url\" target=\"_blank\">secret\/token<\/a> in addition to the webhook URL to ensure its safety. The secret\/token can be everything you want and is provided in the <code>X-Webhook-Token<\/code> header.",
                "webhook_events": "Webhook events",
                "webhook_events_description": "Select all webhook events you want to receive to prevent receiving unnecessary webhook events.",
                "webhook_events_select": "Receive all events",
                "ios_app_url": "iOS app URL",
                "android_app_url": "Android app URL",
                "branchio_url": "Branch.io URL",
                "sso_configurations": ":count configuration|:count configurations",
                "domains": ":count domain|:count domains",
                "permissions": "Permissions",
                "timezone": "Time zone",
                "default_avatar": "Default profile photo",
                "default_avatar_select": "Select default profile photo",
                "default_avatar_requirements": "Max 4Mb"
            },
            "actions": {
                "create": {
                    "success": "Organisation created",
                    "failed": "Unable to create the organisation"
                },
                "update": {
                    "success": "Organisation updated",
                    "failed": "Unable to update the organisation"
                },
                "delete": {
                    "action": "Remove organisation",
                    "confirm": "When removing an organisation, the organisation loses access immediately. Are you sure you want to remove the organisation?",
                    "success": "Organisation removed",
                    "failed": "Unable to remove the organisation"
                },
                "restore": {
                    "action": "Restore organisation",
                    "confirm": "When restoring an organisation, the organisation gets access immediately. Are you sure you want to restore the organisation?",
                    "success": "Organisation restored",
                    "failed": "Unable to restore the organisation"
                }
            },
            "customer_of": "Customer of :organisation",
            "embed_code": "Embed code",
            "embed_width": "Width",
            "embed_height": "Height"
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "passwords": {
            "reset": "Your password has been reset!",
            "sent": "We have emailed your password reset link!",
            "throttled": "Please wait before retrying.",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that email address."
        },
        "profile": {
            "profile": "Profile",
            "your_profile": "Your profile",
            "back_to_dashboard": "Back to dashboard",
            "update_profile": "Update profile",
            "edit_profile": "Edit profile",
            "delete_profile": "Delete profile",
            "properties": {
                "name": "Name",
                "email": "Email address",
                "password": "Password",
                "password_confirmation": "Confirm password",
                "password_requirements": "Password must contain:",
                "password_minimal_characters": "At least 8 characters",
                "password_minimal_uppercase": "At least 1 uppercase character",
                "password_minimal_lowercase": "At least 1 lowercase character",
                "password_minimal_number": "At least 1 number",
                "password_weak": "Too weak",
                "password_not_bad": "Not bad",
                "password_almost": "Almost there",
                "username": "Username",
                "no_username": "No username",
                "country": "Country",
                "avatar": "Avatar",
                "choose_avatar": "Choose avatar",
                "upload_own_avatar": "Upload own avatar",
                "edit_profile_photo": "Edit profile photo",
                "photo": "Photo",
                "choose_photo": "Choose photo",
                "upload_photo": "Upload photo",
                "choose_language": "Choose language",
                "change_language": "Edit language",
                "change_password": "Change password",
                "phonenumber": "Phone number"
            },
            "demo": {
                "not_allowed": "As a demo user, you are not allowed to edit your profile."
            },
            "actions": {
                "update": {
                    "action": "Save profile",
                    "success": "Profile updated",
                    "failed": "Unable to update the profile"
                },
                "update_password": {
                    "action": "Update password"
                }
            },
            "filter": {
                "select_country": "Select country",
                "select_avatar": "Select Avatar"
            }
        },
        "question": {
            "question": "Question",
            "questions": "Questions",
            "question_description": "The player will be asked this question while playing. The question in a quiz are in order, so might be in increasing difficulty.",
            "no_answers": "No answers",
            "template": "Template",
            "type": {
                "single": "Single choice",
                "multiple": "Multiple choice"
            },
            "properties": {
                "type": "Type",
                "feedback_correct": "Feedback correct",
                "feedback_wrong": "Feedback wrong",
                "feedback_correct_answer": "Feedback correct answered",
                "feedback_wrong_answer": "Feedback wrong answered",
                "content": "Content",
                "image": "Image",
                "image_select": "Select image",
                "feedback": "Feedback",
                "feedback_edit": "Edit feedback",
                "feedback_description": "After answering the question, the player could be provided some valuable feedback. Depending on the correct or wrong answer given, the player gets different feedback. Feedback is not required, but is recommended to improve the experience.",
                "excel_file": "Excel file",
                "file_select": "Select file",
                "file": "File"
            },
            "actions": {
                "create": {
                    "import": "Import questions",
                    "action": "Add question",
                    "success": "Question created",
                    "failed": "Unable to create the question"
                },
                "update": {
                    "action": "Edit question",
                    "success": "Question updated",
                    "failed": "Unable to update the question"
                },
                "delete": {
                    "action": "Remove question",
                    "confirm": "When removing the question from the quiz the participants will no longer see the question. Are you sure you want to continue?",
                    "success": "Question removed",
                    "failed": "Unable to remove the question"
                },
                "restore": {
                    "action": "Restore question",
                    "confirm": "When restoring the question, the participants will have to answers this question. Are your sure you want to continue?",
                    "success": "Question restored",
                    "failed": "Unable to restore the question"
                },
                "order": {
                    "success": "Update the order of the questions"
                },
                "template": {
                    "download": "Download template"
                },
                "import": {
                    "store": "Cannot perform an import when questions already exist",
                    "success": "Questions created"
                }
            },
            "validations": {
                "check_answer_first": "Check the answer before proceeding to the next question",
                "unable_check_answer": "Unable to check the answers",
                "provide_at_least_one_answer": "Provide at least one answer",
                "no_correct_answers": "No correct answers or all answers are correct"
            }
        },
        "quiz": {
            "quiz": "Quiz",
            "properties": {
                "question_image": "Image for question"
            },
            "done": "The quiz is fully answered in this session. Play the challenge again to perform the quiz again.",
            "check_answer": "Check answer",
            "next_question": "Next question",
            "time_left": "Time left",
            "could_not_be_loaded": "The quiz could not be loaded."
        },
        "reseller": {
            "customer": "Customer",
            "customers": "Customers",
            "actions": {
                "create": {
                    "action": "Add customer",
                    "success": "Customer created",
                    "failed": "Unable to create the customer"
                },
                "update": {
                    "action": "Edit customer",
                    "success": "Customer updated",
                    "failed": "Unable to update the customer"
                },
                "delete": {
                    "action": "Remove customer",
                    "confirm": "When removing a customer, the customer loses access immediately. Are you sure you want to continue?",
                    "success": "Customer removed",
                    "failed": "Unable to remove the customer"
                },
                "restore": {
                    "action": "Restore customer",
                    "confirm": "When restoring a customer, the customer has access immediately. Are you sure you want to continue?",
                    "success": "Customer restored",
                    "failed": "Unable to restore the customer"
                }
            },
            "validations": {
                "no_access": "Your organisation isn't the reseller of this customer"
            }
        },
        "skill": {
            "skill": "Skill",
            "skills": "Skills",
            "select_placeholder": "Select skills",
            "management": {
                "description": "A skill can be added to a module."
            },
            "properties": {
                "name": "Name",
                "description": "Description",
                "show_on_graph": "Show on graph"
            },
            "actions": {
                "create": {
                    "action": "Create skill",
                    "success": "Skill created",
                    "failed": "Unable to create the skill"
                },
                "update": {
                    "action": "Edit skill",
                    "success": "Skill updated",
                    "failed": "Unable to update the skill"
                },
                "delete": {
                    "action": "Remove skill",
                    "confirm": "When removing a skill, the skill is directly removed for all players. Are you sure you want to continue?",
                    "success": "Skill removed",
                    "failed": "Unable to remove the skill"
                },
                "restore": {
                    "action": "Restore skill",
                    "confirm": "When restoring a skill, the skill is directly accessible. Are you sure you want to continue?",
                    "success": "Skill restored",
                    "failed": "Unable to restore the skill"
                }
            },
            "user_distribution": "User distribution",
            "validations": {
                "not_owned": "The skill doesn't belong to your organisation",
                "unique": "The skill needs to be unique"
            }
        },
        "sso": {
            "sso": "Single Sign On",
            "properties": {
                "name": "Button text",
                "provider": "Provider",
                "login_url": "Login URL"
            },
            "sections": {
                "appearance": {
                    "title": "Appearance",
                    "description": "Configure how this Single Sign On option is shown to your users on the login page."
                },
                "configuration": {
                    "title": "Configuration"
                }
            },
            "providers": {
                "google": {
                    "driver": "Google Workspace",
                    "properties": {
                        "client_id": "App ID",
                        "client_secret": "Client secret",
                        "domain": "Google Workspace domain"
                    },
                    "placeholders": {
                        "client_id": "*****.apps.googleusercontent.com",
                        "client_secret": "********"
                    }
                },
                "azure": {
                    "driver": "Azure AD",
                    "properties": {
                        "client_id": "Application (client) ID",
                        "client_secret": "Application secret",
                        "tenant": "Directory (tenant) ID"
                    },
                    "placeholders": {
                        "client_id": "00000000-0000-0000-0000-000000000000",
                        "client_secret": "********"
                    }
                },
                "oidc": {
                    "driver": "Generic OIDC",
                    "description": "The <strong>:authorization_endpoint<\/strong>, <strong>:token_endpoint<\/strong> and <strong>:userinfo_endpoint<\/strong> are required if <strong>:discovery_endpoint<\/strong> is not provided. When both are provided, the explicitly defined endpoints take precedence.",
                    "properties": {
                        "client_id": "App ID",
                        "client_secret": "Client secret",
                        "discovery_endpoint": "Configuration discovery URL",
                        "authorization_endpoint": "Authorization endpoint",
                        "token_endpoint": "Token endpoint",
                        "userinfo_endpoint": "User info endpoint",
                        "id_key": "Unique identifier attribute on user object"
                    },
                    "placeholders": {
                        "client_id": "",
                        "client_secret": ""
                    }
                },
                "adfs": {
                    "driver": "Active Directory Federation Services",
                    "description": "The <strong>:authorization_endpoint<\/strong>, <strong>:token_endpoint<\/strong> and <strong>:jwks_uri<\/strong> are required if <strong>:discovery_endpoint<\/strong> is not provided. When both are provided, the explicitly defined endpoints take precedence.",
                    "properties": {
                        "client_id": "Client Identifier",
                        "client_secret": "Shared secret",
                        "discovery_endpoint": "OpenID Connect metadata URI",
                        "authorization_endpoint": "Authorization endpoint",
                        "token_endpoint": "Token endpoint",
                        "jwks_uri": "JSON Web Key Sets (JWKS) URI"
                    },
                    "placeholders": {
                        "client_id": "",
                        "client_secret": ""
                    }
                }
            },
            "actions": {
                "create": {
                    "action": "Add SSO configuration",
                    "success": "SSO configuration created",
                    "failed": "Unable to create the SSO configuration"
                },
                "update": {
                    "action": "Edit SSO configuration",
                    "success": "SSO configuration updated",
                    "failed": "Unable to update the SSO configuration"
                },
                "delete": {
                    "action": "Remove SSO configuration",
                    "confirm": "When removing an SSO configuration, it cannot be used to login anymore with immediate effect. Are you sure you want to continue?",
                    "success": "SSO configuration removed",
                    "failed": "Unable to remove the SSO configuration"
                }
            }
        },
        "stats": {
            "status": "Status",
            "playing": "Playing",
            "completed": "Completed",
            "you": "You",
            "average_player": "Average player",
            "hours_play_time": "Hours play time",
            "modules_played": "Modules played",
            "experience": "Experience",
            "xp": "XP",
            "rewards": "Rewards",
            "achievements": "Achievements",
            "badges": "Badges",
            "certificates": "Certificates",
            "campaign_stats": "Campaign stats",
            "personal_stats": "Personal stats",
            "overal_stats": "Overal statistics",
            "average_score": "Average score",
            "not_enough_data": "not enough data",
            "xp_per_month": ":xp per month",
            "xp_per_week": ":xp per week",
            "weekly": "Weekly",
            "monthly": "Monthly",
            "experience_points": "Experience points",
            "weeks": "Weeks",
            "stats": "Stats",
            "xp_graph": "XP Graph",
            "active_days": "Active days",
            "total_time_spent": "Total time spent",
            "challenges": "Challenges",
            "workouts": "Workouts",
            "games": "Games",
            "videos": "Videos"
        },
        "survey": {
            "survey": "Survey",
            "surveys": "Surveys",
            "view_survey": "View survey",
            "insight_description": "Here you can view the answers per survey entry. Next to that is the count of times an answer is provided. The data can be exported with the button above.",
            "part_of_challenge": "Part of challenge",
            "part_of_campaign": "Part of campaign",
            "sessions": "Sessions",
            "type_descriptive": "Question\/Assignment\/Statement",
            "options": "Options",
            "provide_answer": "Provide your answer or reaction below",
            "order": "Order",
            "type": "Type",
            "question": "Question",
            "provided_answer": "Provided answer",
            "provided_amount": "Times provided",
            "no_data": "No data could be found for this survey.",
            "properties": {
                "reaction": "Reaction",
                "reactions": "Reactions",
                "totally_disagree": "Totally disagree",
                "disagree": "Disagree",
                "agree": "Agree",
                "totally_agree": "Totally agree",
                "pdf_text": "PDF text",
                "pdf_text_description": "This text will be shown on the PDF export of the survey results."
            },
            "validations": {
                "ensure_single_choice": "At least one options is required",
                "ensure_multiple_choice": "At least two options are required"
            }
        },
        "survey_entry": {
            "survey_entry": "Survey entry",
            "survey_entries": "Survey entries",
            "survey_entry_description": "The player will see this survey entry as a part of the survey.",
            "statement": "Statement",
            "question_or_assignment": "Question\/Assignment",
            "reaction_or_answer": "Response\/Answer",
            "specification": "Specification",
            "single_choice_description": "The player can provide a single answer\/response to the question\/assignment. There must be at least 1 option.",
            "multiple_choice_description": "The player can provide a multiple answers\/responses to the question\/assignment. There must be at least 2 options.",
            "slider_description": "For a slider there's a minimum and maximum valuation. The slider always has a step size of 1. The bigger the difference the more precise a user is able to answer.",
            "statement_description": "A player can react to a statement. The minimal valuation means that the player strongly disagrees, the maximum valuation means the player strongly agrees. The bigger the difference the more precise a user is able to answer.",
            "optional_description": "If the question is marked optional, the player can leave the answer empty.",
            "properties": {
                "minimal_valuation": "Minimal valuation",
                "maximal_valuation": "Maximal valuation",
                "min_text": "Min text",
                "max_text": "Max text"
            },
            "actions": {
                "create": {
                    "action": "Add survey entry",
                    "success": "Survey entry created",
                    "failed": "Unable to create the survey entry"
                },
                "update": {
                    "action": "Edit survey entry",
                    "success": "Survey entry updated",
                    "failed": "Unable to update the survey entry"
                },
                "delete": {
                    "action": "Remove survey entry",
                    "confirm": "When removing a survey entry, it will be removed from the survey immediately. Are you sure you want to continue?",
                    "success": "Survey entry removed",
                    "failed": "Unable to remove the survey entry"
                },
                "restore": {
                    "action": "Restore survey entry",
                    "confirm": "When restoring a survey entry, it will be part of the survey immediately. Are you sure you want to continue?",
                    "success": "Survey entry restored",
                    "failed": "Unable to restore the survey entry"
                },
                "order": {
                    "success": "Updated the order of the survey entries",
                    "failed": "Unable to update the order of the survey entries"
                }
            }
        },
        "tag": {
            "tag": "Tag",
            "tags": "Tags",
            "edit_tags": "Edit tags",
            "select_placeholder": "Select tags",
            "select_all": "All tags",
            "management": {
                "description": "A tag can be added to a user."
            },
            "properties": {
                "name": "Name",
                "description": "Description"
            },
            "actions": {
                "create": {
                    "action": "Create tag",
                    "success": "Tag created",
                    "failed": "Unable to create the tag"
                },
                "update": {
                    "action": "Edit tag",
                    "success": "Tag updated",
                    "failed": "Unable to update the tag"
                },
                "delete": {
                    "action": "Remove tag",
                    "confirm": "When removing a tag, the tag is directly removed for all users. Are you sure you want to continue?",
                    "success": "Tag removed",
                    "failed": "Unable to remove the tag"
                },
                "restore": {
                    "action": "Restore tag",
                    "confirm": "When restoring a tag, the tag is directly accessible. Are you sure you want to continue?",
                    "success": "Tag restored",
                    "failed": "Unable to restore the tag"
                },
                "bulk": {
                    "action": "Bulk tag users",
                    "success_assign": "Tag assigned to users.",
                    "success_revoke": "Tag revoked from users."
                }
            },
            "validations": {
                "not_owned": "The tag doesn't belong to your organisation"
            }
        },
        "theme": {
            "themes": "Themes",
            "manage": "Manage",
            "manage_organisation_theme": "Manage organisation theme",
            "fonts": "Fonts",
            "font_description": "This will give the theme the client's preferred fonts.",
            "primary_font": "Primary font",
            "secondary_font": "Secondary font",
            "colors": "Colors",
            "color_description": "This will give the theme the client's preferred colors.",
            "primary_color": "Primary color",
            "secondary_color": "Secondary color",
            "accent_color": "Accent color",
            "card_style": "Card style",
            "card_style_description": "This will give the theme the client's preferred cardstyle.",
            "border_radius": "Border Radius",
            "edit_save_button": "Save changes"
        },
        "translation": {
            "translations": "Translations",
            "translation": "Translation",
            "properties": {
                "key": "System key",
                "message": "Text"
            },
            "filter": {
                "all_locales": "All locales",
                "locale": "Locale"
            },
            "actions": {
                "update": {
                    "success": "Translation updated",
                    "failed": "Unable to update the translations"
                }
            }
        },
        "user": {
            "user": "User",
            "users": "Users",
            "user_count": ":count user|:count users",
            "demo_user": "Demo user",
            "demo_user_not_allowed": "Playing as a demo user isn't enabled",
            "demo_user_not_possible": "Playing as a demo user isn't possible at the moment",
            "demo_user_notice": "You're playing as a demo user. Go to your \"Account\" to change your profile if you want to have store your progress.",
            "demo_user_notice_no_upgrade": "You're playing as a demo user. Ask your instructor for an account to keep track of your progress.",
            "administrator": "Administrator",
            "administrator_description": "An administrator is allowed to manage the whole app. Make sure you only assign this rights when required!",
            "manager": "Manager",
            "manager_description": "A manager is allowed to manage the users of the organisation.",
            "name": "Name",
            "email": "E-mail address",
            "password": "Password",
            "password_create": "Leave the password empty to automatically generate one.",
            "password_edit": "Leave the password empty if you don't want to change it.",
            "password_confirm": "Confirm password",
            "expires_at": "Expires at",
            "language": "Language",
            "language_description": "Add your languages and sort them by preference. Should an organisation you are a member of not support any of these languages, the site will be displayed in the organisation's default language.",
            "add_preferred_language": "Add preferred language",
            "tags": "Tags",
            "permissions": "Permissions",
            "edit_user_roles": "Edit user roles",
            "select_placeholder": "Select users",
            "is_manager": "Is manager",
            "is_administrator": "Is administrator",
            "is_anonymous": "Is demo user",
            "added_at": "Added at",
            "modified_at": "Modified at",
            "user_added": "User added",
            "last_modified": "Last modified",
            "unable_to_create": "Unable to create the user",
            "unable_to_create_membership": "Unable to create the membership for user to the organisation",
            "invite_sent": "Invite sent",
            "unable_to_sent_invite": "Unable to sent the invite",
            "invite_sent_again": "Invite sent again",
            "invite_accepted": "Invite accepted. Welcome to the :app",
            "invite_removed": "Invite removed",
            "unable_to_remove_invite": "Unable to remove the invite",
            "create": "Create user",
            "created": "User created",
            "created_without_rights": "User created but unable to set the rights",
            "created_without_membership": "User created but unable to join the current organisation",
            "created_with_password": "User created with the password <code>:password<\/code>",
            "updated": "User updated",
            "updated_without_rights": "User updated but unable to update the rights",
            "unable_to_update": "Unable to update the user",
            "remove": "Remove user",
            "remove_confirmation": "The user will be removed from this organisation and will lose access immediately. Are you sure you want to continue?",
            "removed": "User removed",
            "unable_to_remove": "Unable to remove the user",
            "invalid_email_address": "Invalid e-mail address",
            "invalid_password": "Password doesn't match the requirements",
            "invalid_language": "Language is invalid",
            "tag_does_not_exist": "The label \":tag\" cannot be added because it does not exist",
            "email_or_name_required": "At least an e-mail address or name is required",
            "invites": "Invites",
            "invite": "Invite",
            "accept_invite": "Accept invite",
            "accept_invite_description": "To finish your registration, we need some more information.",
            "invalid_invite": "Invalid invite",
            "invalid_invite_description": "Sorry, but the token is invalid or the invitation has expired. Ask your instructor for a new invite.",
            "revoke_invite": "Revoke invite",
            "revoke_invite_description": "By revoking the invite, the recipient is no longer able to accept the invite. Are you sure you want to revoke the invite?",
            "send_invite": "Send invite",
            "invite_description": "The provided e-mail address will receive an invite per mail for this organisation.",
            "invite_email_exists": "The provided e-mail address shouldn't already have an existing user.",
            "import": "Import",
            "import_file": "Source file",
            "import_file_select": "Select source file",
            "import_file_description": "The file must be a CSV or Excel file and its not required to have a specific structure. In the next steps you will be able to determine the columns.",
            "import_file_description_existing_user": "When a user already has an account for the :app, the account will be added to this organisation.",
            "import_users": "Import users",
            "imported_users": "Users imported",
            "import_determine_columns": "Determine columns",
            "import_results": "Results",
            "import_select_file": "Select file",
            "import_existing_user": "Existing user",
            "import_message": "Message",
            "import_column": "Column",
            "import_ignore_column": "Ignore column",
            "import_skip_first_row": "Skip first row",
            "import_skip_first_row_description": "Useful when the first row contains a header.",
            "import_preview_stats": "There are <code>:rows<\/code> rows found and there are <code>:preview<\/code> rows shown as preview.",
            "import_user_not_imported": "User not imported",
            "import_user_imported_with_warnings": "User imported with warnings",
            "import_user_imported": "User imported",
            "import_only_existing_tags": "Only <a href=\":manage_labels\">labels<\/a> that exist will be added to users. Please make sure all the labels you want to import exist before importing.",
            "user_profile": "User profile",
            "add_user": "Add user",
            "edit_user": "Edit user",
            "user_role": "User role",
            "user_roles": "User roles",
            "account_settings": "Account settings",
            "personal_details": "Personal details",
            "phonenumber": "Phone number",
            "validations": {
                "must_be_part_of_organisation": "The user must be a member of the organisation",
                "must_not_be_part_of_organisation": "The user must not be a member of the organisation"
            },
            "invitation": {
                "subject": "Your Invitation to Join the Fittar App",
                "intro": "Join Fittar Today!",
                "text": "We're excited to invite you to register for the Fittar app! Accept the invitation, sign up, and start right away.",
                "valid_until": "<b>Note:<\/b> This invitation is valid until :expires_at.",
                "tip": "<b>Tip!<\/b> For the best tracking experience: Make sure your phone is positioned as upright as possible. Check out our <a href=\"https:\/\/www.betaalbarehoesjes.nl\/standaard-speciaal-ontworpen-voor-fittar-zwart-cop.html\" target=\"_blank\">Recommended phone holder<\/a> for the best experience!",
                "need_help": "Need help?",
                "need_help_bullet_1": "Watch our <a href=\"https:\/\/www.youtube.com\/watch?v=tz0BEvsfbzM\" target=\"_blank\">Walkthrough video<\/a> for a quick intro.",
                "need_help_bullet_2": "Visit our website for our <a href=\"https:\/\/fittar.eu\/user-tips\/\" target=\"_blank\">User Tips<\/a> and <a href=\"https:\/\/fittar.eu\/faq\/\" target=\"_blank\">FAQ<\/a>.",
                "need_help_bullet_3": "<a href=\"https:\/\/outlook.office.com\/bookwithme\/user\/7fccc4c542224f75813993b7b3da121e@fittar.eu\/meetingtype\/gIW6zZ-tkEWXBojJN8CY2g2?anonymous&ep=mCardFromTile\" target=\"_blank\">Request a free 30-minute demo<\/a>.",
                "enjoy": "We look forward to seeing you at Fittar!",
                "accept": "Accept invitation",
                "copy_link": "Should you have a problem with the button, copy the following link into a browser:"
            },
            "actions": {
                "delete": {
                    "action": "Remove profile",
                    "confirm": "When you remove your profile you won't be able to play anymore. In case you logged in with your company account, the next time you log in you won't have any progress anymore. Are you sure you want to continue?",
                    "success": "Profile removed",
                    "failed": "Unable to remove your profile",
                    "warning": "Deleting your account is irreversible"
                }
            },
            "not_visible_by_demo_user": "Not visible for demo users",
            "cannot_be_admin_because_sso": "This user has connected SSO identities and cannot be an administrator for security reasons.",
            "sso_user": "SSO user",
            "password_change_not_possible": "It is not possible to change the password of this user.",
            "roles_change_not_possible": "It is not possible to change the roles of this user."
        },
        "validation": {
            "accepted": "The :attribute must be accepted.",
            "accepted_if": "The :attribute must be accepted when :other is :value.",
            "active_url": "The :attribute is not a valid URL.",
            "after": "The :attribute must be a date after :date.",
            "after_or_equal": "The :attribute must be a date after or equal to :date.",
            "alpha": "The :attribute must only contain letters.",
            "alpha_dash": "The :attribute must only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The :attribute must only contain letters and numbers.",
            "array": "The :attribute must be an array.",
            "ascii": "The :attribute must only contain single-byte alphanumeric characters and symbols.",
            "before": "The :attribute must be a date before :date.",
            "before_or_equal": "The :attribute must be a date before or equal to :date.",
            "between": {
                "array": "The :attribute must have between :min and :max items.",
                "file": "The :attribute must be between :min and :max kilobytes.",
                "numeric": "The :attribute must be between :min and :max.",
                "string": "The :attribute must be between :min and :max characters."
            },
            "boolean": "The :attribute field must be true or false.",
            "can": "The :attribute field contains an unauthorized value.",
            "confirmed": "The :attribute confirmation does not match.",
            "current_password": "The password is incorrect.",
            "date": "The :attribute is not a valid date.",
            "date_equals": "The :attribute must be a date equal to :date.",
            "date_format": "The :attribute does not match the format :format.",
            "decimal": "The :attribute must have :decimal decimal places.",
            "declined": "The :attribute must be declined.",
            "declined_if": "The :attribute must be declined when :other is :value.",
            "different": "The :attribute and :other must be different.",
            "digits": "The :attribute must be :digits digits.",
            "digits_between": "The :attribute must be between :min and :max digits.",
            "dimensions": "The :attribute has invalid image dimensions.",
            "distinct": "The :attribute field has a duplicate value.",
            "doesnt_end_with": "The :attribute may not end with one of the following: :values.",
            "doesnt_start_with": "The :attribute may not start with one of the following: :values.",
            "email": "The :attribute must be a valid email address.",
            "ends_with": "The :attribute must end with one of the following: :values.",
            "enum": "The selected :attribute is invalid.",
            "exists": "The selected :attribute is invalid.",
            "file": "The :attribute must be a file.",
            "filled": "The :attribute field must have a value.",
            "gt": {
                "array": "The :attribute must have more than :value items.",
                "file": "The :attribute must be greater than :value kilobytes.",
                "numeric": "The :attribute must be greater than :value.",
                "string": "The :attribute must be greater than :value characters."
            },
            "gte": {
                "array": "The :attribute must have :value items or more.",
                "file": "The :attribute must be greater than or equal to :value kilobytes.",
                "numeric": "The :attribute must be greater than or equal to :value.",
                "string": "The :attribute must be greater than or equal to :value characters."
            },
            "image": "The :attribute must be an image.",
            "in": "The selected :attribute is invalid.",
            "in_array": "The :attribute field does not exist in :other.",
            "integer": "The :attribute must be an integer.",
            "ip": "The :attribute must be a valid IP address.",
            "ipv4": "The :attribute must be a valid IPv4 address.",
            "ipv6": "The :attribute must be a valid IPv6 address.",
            "json": "The :attribute must be a valid JSON string.",
            "lowercase": "The :attribute must be lowercase.",
            "lt": {
                "array": "The :attribute must have less than :value items.",
                "file": "The :attribute must be less than :value kilobytes.",
                "numeric": "The :attribute must be less than :value.",
                "string": "The :attribute must be less than :value characters."
            },
            "lte": {
                "array": "The :attribute must not have more than :value items.",
                "file": "The :attribute must be less than or equal to :value kilobytes.",
                "numeric": "The :attribute must be less than or equal to :value.",
                "string": "The :attribute must be less than or equal to :value characters."
            },
            "mac_address": "The :attribute must be a valid MAC address.",
            "max": {
                "array": "The :attribute must not have more than :max items.",
                "file": "The :attribute must not be greater than :max kilobytes.",
                "numeric": "The :attribute must not be greater than :max.",
                "string": "The :attribute must not be greater than :max characters."
            },
            "max_digits": "The :attribute must not have more than :max digits.",
            "mimes": "The :attribute must be a file of type: :values.",
            "mimetypes": "The :attribute must be a file of type: :values.",
            "min": {
                "array": "The :attribute must have at least :min items.",
                "file": "The :attribute must be at least :min kilobytes.",
                "numeric": "The :attribute must be at least :min.",
                "string": "The :attribute must be at least :min characters."
            },
            "min_digits": "The :attribute must have at least :min digits.",
            "missing": "The :attribute field must be missing.",
            "missing_if": "The :attribute field must be missing when :other is :value.",
            "missing_unless": "The :attribute field must be missing unless :other is :value.",
            "missing_with": "The :attribute field must be missing when :values is present.",
            "missing_with_all": "The :attribute field must be missing when :values are present.",
            "multiple_of": "The :attribute must be a multiple of :value.",
            "not_in": "The selected :attribute is invalid.",
            "not_regex": "The :attribute format is invalid.",
            "numeric": "The :attribute must be a number.",
            "password": {
                "letters": "The :attribute must contain at least one letter.",
                "mixed": "The :attribute must contain at least one uppercase and one lowercase letter.",
                "numbers": "The :attribute must contain at least one number.",
                "symbols": "The :attribute must contain at least one symbol.",
                "uncompromised": "The given :attribute has appeared in a data leak. Please choose a different :attribute."
            },
            "present": "The :attribute field must be present.",
            "prohibited": "The :attribute field is prohibited.",
            "prohibited_if": "The :attribute field is prohibited when :other is :value.",
            "prohibited_unless": "The :attribute field is prohibited unless :other is in :values.",
            "prohibits": "The :attribute field prohibits :other from being present.",
            "regex": "The :attribute format is invalid.",
            "required": "The :attribute field is required.",
            "required_array_keys": "The :attribute field must contain entries for: :values.",
            "required_field": "This field is required.",
            "required_if": "The :attribute field is required when :other is :value.",
            "required_if_accepted": "The :attribute field is required when :other is accepted.",
            "required_unless": "The :attribute field is required unless :other is in :values.",
            "required_with": "The :attribute field is required when :values is present.",
            "required_with_all": "The :attribute field is required when :values are present.",
            "required_without": "The :attribute field is required when :values is not present.",
            "required_without_all": "The :attribute field is required when none of :values are present.",
            "rgba_color": "The :attribute field must contain a valid Rgba color",
            "rgba_color_white": "The :attribute field may not be white",
            "same": "The :attribute and :other must match.",
            "size": {
                "array": "The :attribute must contain :size items.",
                "file": "The :attribute must be :size kilobytes.",
                "numeric": "The :attribute must be :size.",
                "string": "The :attribute must be :size characters."
            },
            "starts_with": "The :attribute must start with one of the following: :values.",
            "string": "The :attribute must be a string.",
            "timezone": "The :attribute must be a valid timezone.",
            "unique": "The :attribute has already been taken.",
            "uploaded": "The :attribute failed to upload.",
            "uppercase": "The :attribute must be uppercase.",
            "url": "The :attribute must be a valid URL.",
            "ulid": "The :attribute must be a valid ULID.",
            "uuid": "The :attribute must be a valid UUID.",
            "youtube_video_url": "The :attribute must contains a valid YouTube video URL.",
            "vimeo_video_url": "The :attribute must contains a valid Vimeo video URL.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": {
                "primary_color": "Primary color",
                "secondary_color": "Secondary color",
                "primary_font_color": "Primary font color",
                "secondary_font_color": "Secondary font color",
                "primary_font_family": "Primary font family",
                "secondary_font_family": "Secondary font family",
                "available_languages": "Available languages",
                "is_global": "Is global",
                "organisations": "Organisations",
                "start_date": "Start date",
                "end_date": "End date",
                "confirm": "Confirm",
                "total_questions_used": "Total questions to show",
                "file": "File"
            }
        },
        "webhook": {
            "webhooks": "Webhooks",
            "description": "Send webhooks for past events.",
            "trigger": "Trigger webhook",
            "events": "Events",
            "select": {
                "organisation": "Select organisation",
                "event": "Select event"
            },
            "properties": {
                "start_date": "Start date",
                "end_date": "End date"
            },
            "events_sent_successfully": "Webhook events sent between :startDate and :endDate are sent again",
            "amount_of_calls": "Amount of webhook calls"
        }
    },
    "fr": {
        "achievement": {
            "achievement": "R\u00e9alisations",
            "achievements": "R\u00e9alisations",
            "overview_description": "Liste de toutes les r\u00e9alisations disponibles",
            "select_campaign": "S\u00e9lectionnez une campagne",
            "go_to_achievements": "Aller aux r\u00e9alisations",
            "properties": {
                "name": "Nom",
                "once": "Une fois",
                "score": "Score",
                "award": "R\u00e9compense"
            },
            "time": {
                "today": "aujourd'hui",
                "yesterday": "hier",
                "two_days_ago": "avant-hier",
                "this_week": "cette semaine",
                "last_week": "la semaine derni\u00e8re",
                "two_weeks_ago": "il y a deux semaines",
                "three_weeks_ago": "il y a trois semaines",
                "four_weeks_ago": "il y a quatre semaines",
                "five_weeks_ago": "il y a cinq semaines"
            },
            "status": {
                "status": "Statut",
                "playing": "Jouer \u00e0",
                "completed": "Termin\u00e9",
                "not_completed": "Collectionnez toutes les r\u00e9alisations!",
                "last_achievement": "Derni\u00e8re r\u00e9alisation",
                "no_last_achievement": "Vous n'avez pas encore r\u00e9alis\u00e9 d'exploit"
            },
            "actions": {
                "grant": {
                    "failed": "Impossible d'accorder la r\u00e9alisation"
                }
            },
            "validations": {
                "not_found": "R\u00e9ussite non trouv\u00e9e"
            }
        },
        "answer": {
            "answer": "R\u00e9ponse",
            "answers": "R\u00e9ponses",
            "properties": {
                "correct": "Correct",
                "correct_answer": "R\u00e9ponse correcte",
                "correct_answers": "R\u00e9ponses correctes",
                "correct_answer_description": "C'est la r\u00e9ponse correcte \u00e0 la question",
                "possible_answers": "R\u00e9ponses possibles",
                "provided_answer": "R\u00e9ponse fournie"
            },
            "actions": {
                "create": {
                    "action": "Ajouter la r\u00e9ponse",
                    "success": "R\u00e9ponse cr\u00e9\u00e9e",
                    "failed": "Impossible de sauvegarder la r\u00e9ponse"
                },
                "update": {
                    "action": "Modifier la r\u00e9ponse",
                    "success": "R\u00e9ponse mise \u00e0 jour",
                    "failed": "Impossible de mettre \u00e0 jour la r\u00e9ponse"
                },
                "delete": {
                    "action": "Supprimer la r\u00e9ponse",
                    "confirm": "Supprimez la r\u00e9ponse \u00e0 la question. La r\u00e9ponse sera supprim\u00e9e imm\u00e9diatement. \u00cates-vous s\u00fbr de vouloir continuer ?",
                    "success": "R\u00e9ponse supprim\u00e9e",
                    "failed": "Impossible de supprimer la r\u00e9ponse"
                },
                "restore": {
                    "action": "Restaurer la r\u00e9ponse",
                    "confirm": "Lors de la restauration de la r\u00e9ponse, la r\u00e9ponse sera visible imm\u00e9diatement. \u00cates-vous s\u00fbr de vouloir continuer ?",
                    "success": "R\u00e9ponse restaur\u00e9e",
                    "failed": "Impossible de restaurer la r\u00e9ponse"
                }
            },
            "validations": {
                "invalid_answer_provided": "R\u00e9ponse non valide fournie"
            }
        },
        "api_token": {
            "api_tokens": "Jetons d'API",
            "api_token": "Jeton d'API",
            "overview_description": "G\u00e9rez les jetons d'API des applications connect\u00e9es.",
            "not_expiring": "Pas de date d'expiration",
            "none_assigned": "Il n'y a pas de jetons d'API attribu\u00e9s.",
            "properties": {
                "name": "Nom",
                "expires_at": "Expire \u00e0",
                "created_by": "Cr\u00e9\u00e9 par",
                "is_global": "Jeton global",
                "is_global_description": "Un jeton global peut \u00eatre utilis\u00e9 pour acc\u00e9der aux ressources de toutes les organisations",
                "organisations": "Organisations"
            },
            "actions": {
                "create": {
                    "success": "Jeton d'API cr\u00e9\u00e9",
                    "failed": "Impossible de cr\u00e9er le jeton API"
                },
                "update": {
                    "action": "Editer le jeton d'API",
                    "success": "Jeton d'API mis \u00e0 jour",
                    "failed": "Impossible de mettre \u00e0 jour le jeton d'API"
                },
                "delete": {
                    "action": "Suppression de l'jeton d'API",
                    "confirm": "Lorsque vous supprimez le jeton d'API, l'application poss\u00e9dant ce jeton d'API perd imm\u00e9diatement l'acc\u00e8s. \u00cates-vous s\u00fbr de vouloir supprimer ce jeton d'API ?",
                    "success": "Jeton d'API supprim\u00e9",
                    "failed": "Impossible de supprimer l'identifiant de l'API"
                },
                "show": {
                    "failed": "Impossible d'afficher le jeton d'API"
                },
                "generate": {
                    "failed": "Impossible de g\u00e9n\u00e9rer le jeton API"
                },
                "sync": {
                    "action": "Mise \u00e0 jour des organisations",
                    "success": "Les organisations des jetons d'API sont mises \u00e0 jour.",
                    "is_global": "Les organisations ayant un jeton d'API global ne peuvent pas \u00eatre mises \u00e0 jour"
                }
            }
        },
        "app_score": {
            "actions": {
                "create": {
                    "failed": "Impossible de mettre \u00e0 jour le score de l'application"
                }
            },
            "scores_filled_in": "Les deux scores sont d\u00e9j\u00e0 remplis",
            "score": "SCORE",
            "finished": {
                "start_again": "Recommencer",
                "finish": "Finite",
                "score_achieved": "Score atteint",
                "text": "Effort exceptionnel ! Vous \u00eates pr\u00eat pour la prochaine s\u00e9ance d'entra\u00eenement ou vous voulez battre votre score ?"
            },
            "battle": {
                "try_again": "Essayer \u00e0 nouveau",
                "submit_your_score": "Soumettez votre score",
                "submit_and_see_who_won": "Soumettez et voyez qui a gagn\u00e9",
                "text": "Effort exceptionnel ! Soumettez votre score et voyez qui a gagn\u00e9!"
            }
        },
        "auth": {
            "email": "Adresse e-mail",
            "password_field": "Mot de passe",
            "register": {
                "register": "Enregistrer",
                "description": "Cr\u00e9ez un compte pour :app. En cr\u00e9ant un compte, vos progr\u00e8s seront suivis et disponibles partout o\u00f9 vous vous connecterez.",
                "no_account": "Pas de compte?",
                "no_account_description": "Si vous n'avez pas de compte, vous pouvez <a href=\":link\">ici<\/a>.",
                "already_has_account": "Avez-vous d\u00e9j\u00e0 un compte ?",
                "not_allowed": "Inscription non autoris\u00e9e",
                "not_allowed_description": "D\u00e9sol\u00e9, mais cette organisation a d\u00e9sactiv\u00e9 l'inscription. Demandez une invitation \u00e0 votre instructeur.",
                "register_not_allowed": "Enregistrement non autoris\u00e9",
                "register_not_allowed_description": "D\u00e9sol\u00e9, mais cette organisation a d\u00e9sactiv\u00e9 l'enregistrement. Veuillez demander une invitation \u00e0 votre instructeur."
            },
            "phonenumber_field": "T\u00e9l\u00e9phone",
            "reseller": {
                "not_allowed": "L'organisation n'est pas un revendeur",
                "not_allowed_description": "D\u00e9sol\u00e9, mais cette organisation n'a pas de droits de revendeur. Contactez votre gestionnaire de compte pour obtenir les droits de revendeur."
            },
            "demo": {
                "play": "Jouer en tant qu'utilisateur d\u00e9mo",
                "description": "Au lieu de vous inscrire, vous pouvez \u00e9galement jouer en tant qu'utilisateur d\u00e9mo. La progression sera suivie, mais sur d'autres appareils ou lorsque vous effacerez l'historique de votre navigateur, vous perdrez votre progression. Lorsque vous jouez en tant qu'utilisateur d\u00e9mo, vous pouvez toujours sauvegarder votre compte.",
                "description_no_registration": "Au lieu de vous inscrire, vous pouvez \u00e9galement jouer en tant qu'utilisateur d\u00e9mo. La progression sera suivie, mais sur d'autres appareils ou lorsque vous effacerez l'historique de votre navigateur, vous perdrez votre progression."
            },
            "login": {
                "login": "Connexion",
                "remember_me": "Se souvenir de moi",
                "required": "Vous devez \u00eatre connect\u00e9 pour effectuer cette action."
            },
            "logout": {
                "logout": "D\u00e9connexion"
            },
            "forgotten": {
                "password_instructions": "Entrez les donn\u00e9es pour changer votre mot de passe.",
                "change_password": "Changer le mot de passe",
                "reset_link_sent": "Lorsque votre adresse \u00e9lectronique est trouv\u00e9e, les instructions sont envoy\u00e9es. V\u00e9rifiez votre e-mail et cliquez sur le lien contenu dans l'e-mail pour r\u00e9initialiser votre mot de passe.",
                "reset_link_not_sent": "Malheureusement, nous ne sommes pas en mesure d'envoyer l'e-mail contenant les instructions. Contactez votre instructeur pour obtenir de l'aide.",
                "send_instructions": "Envoyer les instructions",
                "confirm_password": "Confirmer le mot de passe",
                "confirm_password_description": "Confirmez votre mot de passe pour continuer.",
                "forgot_password": "Mot de passe oubli\u00e9",
                "forgot_password_description": "Si vous avez oubli\u00e9 votre mot de passe, indiquez votre adresse \u00e9lectronique. Vous recevrez ensuite un e-mail contenant les instructions pour r\u00e9initialiser votre mot de passe.",
                "forgot_your_password": "Vous avez oubli\u00e9 votre mot de passe ?",
                "check_spam_folder": "Si vous ne voyez pas l'e-mail dans quelques minutes, v\u00e9rifiez votre dossier \"courrier ind\u00e9sirable\" ou votre dossier \"spam\"."
            },
            "verify": {
                "verify": "V\u00e9rifier votre adresse e-mail",
                "click_below": "Veuillez cliquer sur le bouton ci-dessous pour v\u00e9rifier votre adresse e-mail.",
                "check_email": "Un lien de v\u00e9rification a \u00e9t\u00e9 envoy\u00e9 \u00e0 votre adresse e-mail avec un lien pour terminer votre inscription.",
                "resent": "Un nouveau lien de v\u00e9rification a \u00e9t\u00e9 envoy\u00e9 \u00e0 votre adresse \u00e9lectronique.",
                "before": "Avant de poursuivre, veuillez v\u00e9rifier si vous avez re\u00e7u un lien de v\u00e9rification dans votre courrier \u00e9lectronique.",
                "not_received": "Si vous n'avez pas re\u00e7u l'e-mail",
                "request": "Cliquez ici pour en demander un autre",
                "not_requested": "Si vous n'avez pas cr\u00e9\u00e9 de compte, aucune autre action n'est requise."
            },
            "account_exists": {
                "exists": "Vous avez essay\u00e9 de vous inscrire mais vous avez d\u00e9j\u00e0 un compte.",
                "forgot_password": "Si vous avez oubli\u00e9 votre mot de passe, vous pouvez le r\u00e9initialiser via \"Mot de passe oubli\u00e9\"."
            },
            "device_flow": {
                "start": {
                    "failed": "Impossible de lancer la demande d'authentification"
                },
                "invalid": {
                    "title": "Demande invalide",
                    "description": "La demande d'authentification est invalide. Scannez le code QR ou utilisez le lien appropri\u00e9 pour commencer l'authentification."
                },
                "expired": {
                    "title": "Demande expir\u00e9e",
                    "description": "La demande d'authentification est valable pour une dur\u00e9e limit\u00e9e. Recommencez l'authentification sur votre autre appareil"
                },
                "organisations": {
                    "select": "S\u00e9lectionnez l'organisation",
                    "none": "Ce compte n'est membre d'aucune organisation. Demandez \u00e0 votre instructeur de vous ajouter \u00e0 une organisation."
                },
                "finish": {
                    "title": "Connect\u00e9",
                    "description": "Vous \u00eates maintenant connect\u00e9 avec succ\u00e8s et vous pouvez commencer \u00e0 jouer sur votre autre appareil."
                },
                "no_organisations": {
                    "title": "Aucune organisation trouv\u00e9e",
                    "description": "L'application \u00e0 laquelle vous essayez de vous connecter n'a pas acc\u00e8s aux organisations auxquelles vous avez acc\u00e8s."
                }
            },
            "delete": {
                "verify": "V\u00e9rifier la suppression du compte",
                "click_below": "Veuillez cliquer sur le bouton ci-dessous pour v\u00e9rifier que vous souhaitez supprimer votre compte.",
                "not_requested": "Si vous n'avez pas demand\u00e9 la suppression de votre compte, aucune autre action n'est requise.",
                "mail_sent": "Si cette adresse e-mail existe, vous recevrez un e-mail, cliquez sur le lien pr\u00e9sent dans l'e-mail pour confirmer que vous souhaitez supprimer votre compte.",
                "confirm": "Je connais les cons\u00e9quences et je suis s\u00fbr de vouloir supprimer mon compte"
            },
            "sso": {
                "generic": "D\u00e9sol\u00e9, un probl\u00e8me s'est produit lors de la connexion SSO. Veuillez r\u00e9essayer.",
                "no_id": ":configuration: pas d'identifiant unique fourni par le fournisseur.",
                "no_email": ":configuration: pas d'adresse \u00e9lectronique fournie par le fournisseur.",
                "prohibited": "La connexion via SSO est interdite pour cet utilisateur.",
                "not_a_member": "Vous devez \u00eatre invit\u00e9 dans cette organisation avant de pouvoir vous connecter.",
                "user_data_request_error": ":configuration: a r\u00e9pondu avec le code d'erreur :code. Veuillez r\u00e9essayer et contacter le support si l'erreur persiste."
            },
            "failed": "Ces informations d'identification ne correspondent pas \u00e0 nos dossiers.",
            "password": "Le mot de passe fourni est incorrect.",
            "throttle": "Trop de tentatives de connexion. Veuillez r\u00e9essayer dans :secondes secondes.",
            "pending_invitation": "Veuillez accepter votre invitation avant de vous inscrire.",
            "get_mobile_app": {
                "title": "Installez l'application mobile",
                "description": "Veuillez installer notre application mobile pour une meilleure exp\u00e9rience.",
                "download_app_store": "T\u00e9l\u00e9charger sur l'App Store",
                "download_play_store": "Disponible sur Google Play"
            }
        },
        "battle": {
            "battle": "Bataille",
            "battles": "Batailles",
            "battle_leaderboard": "Tableau des leaders de bataille",
            "battle_arena": "Ar\u00e8ne de bataille",
            "properties": {
                "name": "Nom",
                "description": "Description",
                "win_score": "Bonus de victoire (50% en cas de d\u00e9faite)",
                "score_factor": "Facteur de notation en cas de victoire contre un joueur mieux class\u00e9",
                "response_time": "Temps de r\u00e9ponse",
                "daily_limit": "Limite journali\u00e8re",
                "available": "Disponible",
                "available_from": "Disponible \u00e0 partir de",
                "available_till": "Disponible jusqu'\u00e0",
                "no_limit": "aucune limite",
                "hours": "heures",
                "simultaneous_open_sessions": "Sessions ouvertes simultan\u00e9es",
                "simultaneous_open_sessions_unlimited": "Illimit\u00e9"
            },
            "insights": {
                "wins": "Victoires",
                "count_completed_sessions": "# sessions termin\u00e9es",
                "count_unaccepted_sessions": "# sessions non accept\u00e9es",
                "average_score": "Score moyen",
                "count_unique_initiators": "# initiateurs uniques",
                "count_unique_opponents": "# adversaires uniques",
                "percentage_of_sessions_where_opponent_wins": "% de sessions termin\u00e9es o\u00f9 l'adversaire a gagn\u00e9",
                "average_time_to_complete_micro_game": "Temps moyen pour terminer un micro-jeu",
                "average_time_to_accept_invitation": "Temps moyen d'ouverture d'une invitation",
                "average_time_to_complete_session": "Temps moyen pour terminer une session"
            },
            "actions": {
                "create": {
                    "action": "Cr\u00e9er une bataille",
                    "success": "Bataille cr\u00e9\u00e9e",
                    "failed": "Impossible de cr\u00e9er la bataille"
                },
                "update": {
                    "action": "Modifier la bataille",
                    "success": "Bataille mise \u00e0 jour",
                    "failed": "Impossible de mettre \u00e0 jour la bataille"
                },
                "delete": {
                    "action": "Supprimer une bataille",
                    "confirm": "Lorsque vous supprimez une bataille, celle-ci est directement supprim\u00e9e pour tous les joueurs. \u00cates-vous s\u00fbr de vouloir continuer ?",
                    "success": "Bataille supprim\u00e9e",
                    "failed": "Impossible de supprimer la bataille"
                },
                "stop": {
                    "action": "Arr\u00eater la bataille",
                    "confirm": "Lorsque vous arr\u00eatez une bataille, celle-ci est directement supprim\u00e9e pour tous les joueurs. \u00cates-vous s\u00fbr de vouloir continuer ?",
                    "success": "Bataille arr\u00eat\u00e9e",
                    "failed": "Impossible d'arr\u00eater la bataille"
                }
            },
            "filter": {
                "select_campaign": "S\u00e9lectionner campagne"
            },
            "validations": {
                "not_owned": "La bataille n'appartient pas \u00e0 votre organisation",
                "already_played": "Cette bataille a d\u00e9j\u00e0 \u00e9t\u00e9 jou\u00e9e par certains utilisateurs.",
                "overlaps": "La bataille ne peut pas se chevaucher avec d'autres batailles.",
                "no_micro_games": "La campagne doit avoir au module un micro-jeu.",
                "outside_tournament": "Cette valeur est en dehors des horaires du tournoi."
            },
            "session": {
                "sessions": "Sessions",
                "date": "Date",
                "initiator": "Initiateur",
                "opponent": "Adversaire",
                "bonus": "Bonus",
                "not_found": "Session de bataille introuvable"
            },
            "profile": {
                "select_friend_to_challenge": "S\u00e9lectionnez un ami \u00e0 d\u00e9fier",
                "text": "S\u00e9lectionnez l`utilisateur que vous souhaitez d\u00e9fier pour ce jeu",
                "battle_against_friends": "Bataille Contre Des Amis"
            },
            "score": {
                "text": "Effort exceptionnel ! Soumettez votre score et voyez qui a gagn\u00e9 !"
            },
            "picked_randomly": "choisi au hasard",
            "pick_random_microgame": "Choisir un micro jeu au hasard dans la campagne",
            "expired": "La bataille est expir\u00e9e",
            "not_found": "Bataille introuvable",
            "no_active": "Il n'y a pas de bataille active en ce moment.",
            "not_allowed": "Vous n'\u00eates pas autoris\u00e9 \u00e0 lancer une autre bataille aujourd'hui, r\u00e9essayez demain",
            "did_not_lose": "Vous ne pouvez pas vous venger d'une bataille que vous n'avez pas perdue.",
            "already_completed": "Vous avez d\u00e9j\u00e0 termin\u00e9 cette bataille.",
            "win": "{1} victoire|[0,2,*] victoires",
            "wins": "{1} :count victoire|[0,2,*] :count victoires",
            "challenge": "D\u00e9fi",
            "revanche": "Revanche",
            "challenges_you": ":name vous d\u00e9fie",
            "start": "Lancer la bataille",
            "battle_masters": "Ma\u00eetres de bataille",
            "battle_masters_popup": "Rechercher un adversaire",
            "search_opponent": "Rechercher un adversaire",
            "challengers": "Challengers",
            "yourself": "Vous ne pouvez pas vous d\u00e9fier vous-m\u00eame",
            "wait_for_initiator": "Attendez qu'un score soit plac\u00e9 par le challenger",
            "no_invitations": "Vous n'avez pas encore \u00e9t\u00e9 d\u00e9fi\u00e9 par un autre joueur.",
            "no_history": "Vous n'avez pas encore jou\u00e9 de batailles.",
            "too_many": "Vous avez d\u00e9j\u00e0 trop de batailles actives.",
            "campaign_is_tournament": "Cette campagne se d\u00e9roule en mode tournoi et ne peut \u00eatre jou\u00e9e qu'entre le :dates. La bataille doit \u00e9galement se d\u00e9rouler pendant cette p\u00e9riode.",
            "game_anonymous": "La campagne n'est accessible qu'aux utilisateurs anonymes",
            "summary": {
                "header": {
                    "winner": "Gagnant",
                    "loser": "Perdu",
                    "tied": "Dessiner"
                },
                "text": {
                    "score": "Score"
                },
                "battle_score": "Score de la bataille",
                "score": {
                    "win": "Bataille gagn\u00e9e",
                    "lost": "Bataille perdue",
                    "tied": "Bataille termin\u00e9e"
                },
                "earned": "Total gagn\u00e9",
                "waiting_for_the_opponent": "En attendant l`adversaire",
                "battle_again": "Combattez \u00e0 nouveau"
            }
        },
        "battleground": {
            "battleground": "Champ de bataille",
            "challenges": "D\u00e9fis",
            "start_new_battle": "Commencer une nouvelle bataille",
            "active_battles": "Batailles Actives",
            "past_battles": "Batailles pass\u00e9es",
            "you_won": "Tu as gagn\u00e9",
            "you_lost": "Tu as perdu",
            "tied": "Li\u00e9",
            "no_active_battles": "Aucune bataille active",
            "no_past_battles": "Aucune bataille pass\u00e9e",
            "text": "Pour commencer des batailles, acc\u00e9dez \u00e0 l`\u00e9cran de d\u00e9tail des jeux ou des d\u00e9fis et d\u00e9marrez une bataille avec vos amis.",
            "text_down": "Vous pourrez suivre l`avanc\u00e9e de la bataille ici",
            "waiting_for_opponent": "En attendant l`adversaire",
            "waiting_for_you": "Dans votre attente",
            "challenged_by": "D\u00e9fi\u00e9 par",
            "challenged": "D\u00e9fi\u00e9",
            "hours_left": "heures restantes",
            "you": "Vous"
        },
        "campaign": {
            "campaign": "Programme",
            "campaigns": "Programmes",
            "programs": "Programmes",
            "program": "Programme",
            "new_campaign": "Nouvelle program",
            "view_campaign": "Voir la programme",
            "management": {
                "description": "Une programme contient une collection de d\u00e9fis et pourrait \u00eatre compar\u00e9e \u00e0 un livre o\u00f9 les d\u00e9fis sont des chapitres."
            },
            "insights": "Aper\u00e7us",
            "to_campaign": "Vers la programme",
            "already_played": "Cette programme est d\u00e9j\u00e0 jou\u00e9e par :nombre de joueurs. Modifier cette programme aura pour effet de modifier leur progression.",
            "transfer_requests": "Demandes de transfert",
            "copy_title": "Copier la programme",
            "copy": "Copier la programme dans une autre organisation",
            "copy_button": "Envoyer une demande de copie",
            "copy_description": "L'organisation destinataire recevra une demande de copie de la programme. Lorsqu'elle aura accept\u00e9 la demande, la programme sera copi\u00e9e.",
            "copyable_campaigns": "Programmes qui peuvent \u00eatre copi\u00e9es",
            "copy_howto": "Pour copier une programme, ouvrez la page des programmes et cliquez sur le bouton \"Copier\" situ\u00e9 \u00e0 c\u00f4t\u00e9.",
            "copy_accept": "Copier la programme",
            "copy_accept_confirmation": "Copiez la programme dans votre organisation. Vous pourrez ensuite modifier la programme en fonction de vos besoins. \u00cates-vous s\u00fbr de vouloir copier la programme ?",
            "copy_deny": "Supprimer la demande",
            "copy_deny_confirmation": "Refusez la demande de copie de la programme \u00e0 votre organisation. Apr\u00e8s cela, vous ne pourrez plus copier la programme dans votre organisation. \u00cates-vous s\u00fbr de vouloir continuer ?",
            "duplicate": "Dupliquer programme au sein de sa propre organisation",
            "duplicate_button": "Dupliquer la programme",
            "duplicate_description": "La programme, avec tous ses d\u00e9fis et modules, sera reproduite au sein de votre organisation.",
            "outgoing_requests": "Programme qui pourraient \u00eatre copi\u00e9es",
            "copy_revoke": "R\u00e9voquer l'autorisation de copier",
            "copy_revoke_description": "Lorsque vous r\u00e9voquez l'autorisation de copier la programme, l'organisation destinataire n'est plus autoris\u00e9e \u00e0 copier le jeu. \u00cates-vous s\u00fbr de vouloir continuer ?",
            "copy_to_subdomain_description": "Saisissez le sous-domaine de l'organisation \u00e0 laquelle vous souhaitez copier le jeu.",
            "leaderboard": "Tableau des leaders",
            "no_player": "Aucun joueur",
            "completed": "Compl\u00e9t\u00e9!",
            "percentage_completed": "de programme termin\u00e9e",
            "progress": "Progr\u00e8s",
            "available_modules": "Disponible",
            "completed_modules": "Compl\u00e9t\u00e9",
            "stars": "\u00c9toiles",
            "battle_xp": "Bataille :xp",
            "total_xp": "Total :xp",
            "status": {
                "scheduled": "Planifi\u00e9",
                "in_progress": "En cours",
                "done": "Fait",
                "archived": "Archiv\u00e9"
            },
            "properties": {
                "name": "Nom",
                "title": "Titre",
                "finished_by": "Termin\u00e9 par",
                "finish_date": "Date de fin",
                "run_time": "Dur\u00e9e",
                "description": "Description",
                "image": "Image",
                "image_select": "S\u00e9lectionnez l'image",
                "icon": "Ic\u00f4ne",
                "icon_select": "S\u00e9lectionner l'ic\u00f4ne",
                "score": "Score",
                "bonus": "Bonus",
                "modules_completed": "modules compl\u00e9t\u00e9s",
                "owned_by": "D\u00e9tenu par",
                "shared_with": "Partag\u00e9 avec",
                "hide_leaderboard": "Masquer le tableau des leaders",
                "access": "Acc\u00e9der",
                "access_tags": "Uniquement les utilisateurs avec un tag",
                "access_tags_placeholder": "Tous les utilisateurs enregistr\u00e9s",
                "tournament": "Tournoi",
                "enable_tournament": "Activer le mode tournoi",
                "tournament_start_at": "Le tournoi commence \u00e0",
                "tournament_duration": "Le tournoi duration",
                "tournament_status": "Le tournoi statut",
                "tournament_end_at": "Le tournoi se termine \u00e0",
                "leagues": "Ligues",
                "leagues_description": "Lorsque les ligues sont activ\u00e9es, le classement sera bas\u00e9 sur les poules avec promotion et rel\u00e9gation.",
                "league_enabled": "Activer les ligues",
                "league_ideal_poule_size": "Taille id\u00e9ale de la poule",
                "league_switch_day": "Jour de la semaine",
                "league_switch_time": "Temps",
                "league_promote_from_bronze": "Passer du Bronze \u00e0 l'Argent",
                "league_relegate_from_silver": "Rel\u00e9guer de l'Argent au Bronze",
                "league_promote_from_silver": "Passer de l'Argent \u00e0 l'Or",
                "league_relegate_from_gold": "Rel\u00e9guer de l'Or \u00e0 l'Argent"
            },
            "access_options": {
                "all": "Tout le monde",
                "anonymous": "Utilisateurs anonymes",
                "registered": "Utilisateurs enregistr\u00e9s"
            },
            "actions": {
                "create": {
                    "action": "Cr\u00e9er une programme",
                    "success": "Programme cr\u00e9\u00e9e",
                    "failed": "Impossible de cr\u00e9er la programme"
                },
                "update": {
                    "action": "Modifier la programme",
                    "success": "Programme mise \u00e0 jour",
                    "failed": "Impossible de mettre \u00e0 jour la programme"
                },
                "delete": {
                    "action": "Supprimer une programme",
                    "confirm": "Lorsque vous supprimez une programme, celle-ci est directement supprim\u00e9e pour tous les joueurs. \u00cates-vous s\u00fbr de vouloir continuer ?",
                    "success": "Programme supprim\u00e9e",
                    "failed": "Impossible de supprimer la programme"
                },
                "restore": {
                    "action": "Restaurer la programme",
                    "confirm": "Lors de la restauration d'une programme, la programme est directement accessible. \u00cates-vous s\u00fbr de vouloir continuer ?",
                    "success": "Programme restaur\u00e9e",
                    "failed": "Impossible de restaurer la programme"
                },
                "order": {
                    "action": "Ordre des programmes",
                    "success": "Mise \u00e0 jour de l'ordre des programmes",
                    "error": "Impossible de mettre \u00e0 jour l'ordre des programmes"
                },
                "transfer_request_create": {
                    "create": "Cr\u00e9er un transfert de copie",
                    "success": "Demande de transfert envoy\u00e9e",
                    "failed": "Impossible d'envoyer la demande de transfert"
                },
                "transfer_request_delete": {
                    "success": "Demande de transfert supprim\u00e9e",
                    "failed": "Impossible de supprimer la demande de transfert"
                },
                "transfer": {
                    "success": "Demande de transfert trait\u00e9e",
                    "failed": "Impossible de traiter la demande de transfert",
                    "skip_missing_microgames": "Sauter les micro-jeux inaccessibles"
                },
                "duplicate": {
                    "success": "Programme dupliqu\u00e9e"
                }
            },
            "validations": {
                "not_owned": "La programme n'appartient pas \u00e0 votre organisation",
                "no_access": "L'organisation n'a pas acc\u00e8s \u00e0 la programme",
                "no_longer_available": "La programme ou la partie demand\u00e9e de la programme n'est plus disponible.",
                "not_accessible": "Vous n'avez pas acc\u00e8s \u00e0 cette programme",
                "transfer_already_sent": "La demande de transfert a d\u00e9j\u00e0 \u00e9t\u00e9 envoy\u00e9e \u00e0 l'organisation",
                "transfer_no_access": "L'organisation n'a pas le droit de traiter la demande",
                "no_access_to_microgames": "L'organisation n'a pas acc\u00e8s \u00e0 un ou plusieurs micro jeux. Contactez votre gestionnaire de compte pour y acc\u00e9der. La programme peut toujours \u00eatre copi\u00e9e mais le(s) module(s) avec le(s) micro-jeu(s) suivant(s) seront ignor\u00e9s:",
                "tournament_has_ended": "Le tournoi de cette programme est termin\u00e9 et ne peut plus \u00eatre jou\u00e9",
                "battle_outside_tournament": "Cette programme contient des batailles qui ne font pas partie du tournoi. Veuillez les supprimer avant de configurer le mode tournoi."
            },
            "tournament": {
                "warn_existing_battles": "Cette programme comporte des batailles actives ou \u00e0 venir. Si une bataille ne chevauche que partiellement le tournoi, ses horaires seront ajust\u00e9s."
            }
        },
        "challenge": {
            "challenge": "Jour",
            "challenges": "Jours",
            "challenge_description": "Un jour contient un ensemble de modules et peut \u00eatre compar\u00e9 au chapitre d'un livre.",
            "challenge_completed_at": "Jour termin\u00e9 \u00e0",
            "challenge_play": "Jouez le jour et obtenez le meilleur score",
            "challenge_not_playable": "Le jour ne peut pas \u00eatre jou\u00e9",
            "challenge_not_playable_no_modules": "Le jour ne contient aucun module et ne peut donc pas \u00eatre relev\u00e9. Contactez votre instructeur.",
            "challenge_completed": "Jour termin\u00e9",
            "challenge_completed_name": "Jour termin\u00e9 :challenge",
            "challenge_completed_description": "Excellent travail ! Vous avez relev\u00e9 le jour !",
            "challenge_not_completed": "Jour non termin\u00e9",
            "challenge_not_completed_description": "Malheureusement, le jour n'est pas termin\u00e9. Mais... pas de probl\u00e8me ! Essayez \u00e0 nouveau !",
            "try_again": "Essayez \u00e0 nouveau",
            "back_to_campaign": "Retour \u00e0 la campagne",
            "next_challenge": "Commencer le prochain jour",
            "progress": "Progr\u00e8s",
            "start": "Commencer",
            "properties": {
                "name": "Nom",
                "description": "Description",
                "image": "Image",
                "image_select": "S\u00e9lectionnez l'image"
            },
            "actions": {
                "create": {
                    "action": "Ajouter un jour",
                    "success": "Jour cr\u00e9\u00e9",
                    "failed": "Impossible de cr\u00e9er le jour"
                },
                "update": {
                    "action": "Modifier le jour",
                    "success": "Jour mis \u00e0 jour",
                    "failed": "Impossible de mettre \u00e0 jour le jour"
                },
                "delete": {
                    "action": "Supprimer le jour",
                    "confirm": "Le jour sera supprim\u00e9 de la campagne. Les joueurs ne pourront donc pas jouer ou consulter ce jour. \u00cates-vous s\u00fbr de vouloir continuer ?",
                    "success": "Jour supprim\u00e9",
                    "failed": "Impossible de supprimer le jour"
                },
                "restore": {
                    "action": "Restaurer le jour",
                    "confirm": "Lorsque vous restaurez un jour, celui-ci est directement accessible. \u00cates-vous s\u00fbr de vouloir continuer ?",
                    "success": "Jour restaur\u00e9",
                    "failed": "Impossible de restaurer le jour"
                },
                "order": {
                    "success": "Mise \u00e0 jour de l'ordre des jours",
                    "error": "Impossible de mettre \u00e0 jour l'ordre des jours"
                }
            },
            "validations": {
                "not_owned": "Le jour n'appartient pas \u00e0 votre organisation",
                "must_be_part_of_organisation": "Le jour doit appartenir \u00e0 l'organisation",
                "no_modules": "Le jour a 0 module donc il ne peut pas \u00eatre jou\u00e9."
            }
        },
        "challenge_session": {
            "actions": {
                "update": {
                    "failed": "Impossible de mettre \u00e0 jour la session du module"
                }
            },
            "validations": {
                "must_be_part_of_organisation": "La session de d\u00e9fi doit appartenir \u00e0 un d\u00e9fi de l'organisation",
                "not_owned": "Cette session de d\u00e9fi n'est pas la v\u00f4tre. D\u00e9marrez le d\u00e9fi \u00e0 partir de votre propre compte",
                "too_old": "Cette session de d\u00e9fi a plus de 8 heures. Veuillez recommencer le d\u00e9fi"
            }
        },
        "custom_tiles": {
            "custom_tile": "Tuile personnalis\u00e9e",
            "custom_tiles": "Tuiles personnalis\u00e9es",
            "yes": "Oui",
            "no": "Non",
            "properties": {
                "name": "Nom",
                "title": "Titre",
                "image": "Image",
                "url": "URL",
                "identifier": "Identifiant",
                "image_select": "S\u00e9lectionner une image",
                "enabled": "Activ\u00e9"
            },
            "filter": {
                "identifier": "S\u00e9lectionner un identifiant"
            },
            "actions": {
                "create": {
                    "action": "Nouvelle tuile personnalis\u00e9e",
                    "success": "Tuile personnalis\u00e9e cr\u00e9\u00e9",
                    "failed": "Impossible de cr\u00e9er le tuile personnalis\u00e9e"
                },
                "update": {
                    "title": "Modifier le tuile personnalis\u00e9e :type",
                    "success": "Tuile personnalis\u00e9e mis \u00e0 jour",
                    "failed": "Impossible de mettre \u00e0 jour le tuile personnalis\u00e9e"
                }
            }
        },
        "dashboard": {
            "switch_account": "Changer de compte",
            "current_program": "campagne en cours",
            "personal-progress": "Progr\u00e8s personnel",
            "to-receive-certificate": "Pour recevoir un certificat",
            "highscores": "Meilleurs scores",
            "retry_last_performance": "R\u00e9p\u00e9ter la derni\u00e8re performance",
            "no_last_performance": "Vous n'avez particip\u00e9 \u00e0 aucune campagne",
            "to_fittar_app": "Fittar",
            "to_fittar_app_description": "Jeux et exercices",
            "battle_mode": "Mode de combat",
            "battleground": "Champ de bataille",
            "programs": "Programmes",
            "exergames": "Jeux d`entra\u00eenement",
            "interactive_workouts": "Entra\u00eenements interactifs",
            "fitness_video": "Vid\u00e9o de remise en forme",
            "leaderboard": "Classement",
            "community": "Communaut\u00e9",
            "support": "Soutien",
            "interactive_challenges": "D\u00e9fis",
            "videos": "Vid\u00e9os",
            "privacy_policy": "Politique de confidentialit\u00e9",
            "faq": "FAQ",
            "user_tips": "Conseils d'utilisation",
            "terms_and_conditions": "Conditions g\u00e9n\u00e9rales d'utilisation",
            "tournament": "Tournoi",
            "challenges": "D\u00e9fis",
            "battle_await": "batailles vous attendent"
        },
        "direct_play_micro_game": {
            "micro_games": "Direct-play micro games",
            "explanation": "Les campagnes pr\u00e9sent\u00e9es ici ne le sont qu'\u00e0 titre indicatif, car elles peuvent diff\u00e9rer pour chaque utilisateur en fonction des campagnes auxquelles il a acc\u00e8s. Les micro-jeux seront toujours affich\u00e9s en position dans cette liste.",
            "properties": {
                "name": "Nom",
                "description": "Description",
                "image": "Image",
                "image_select": "S\u00e9lectionnez l'image",
                "type": "Type",
                "hide_high_score": "Masquer le meilleur score"
            },
            "actions": {
                "create": {
                    "action": "Cr\u00e9er un micro-jeu \u00e0 jeu direct",
                    "success": "Cr\u00e9ation d'un micro-jeu \u00e0 jeu direct",
                    "failed": "Impossible de cr\u00e9er le micro-jeu \u00e0 jeu direct"
                },
                "update": {
                    "action": "Mise \u00e0 jour du micro-jeu direct",
                    "success": "Mise \u00e0 jour du microjeu en jeu direct",
                    "failed": "Impossible de mettre \u00e0 jour le micro-jeu direct"
                },
                "order": {
                    "success": "Mise \u00e0 jour de l'ordre des micro-jeux \u00e0 participation directe"
                },
                "delete": {
                    "action": "Suppression du micro-jeu \u00e0 participation directe",
                    "confirm": "Lors de la suppression d'un micro-jeu en jeu direct, celui-ci est directement supprim\u00e9 pour tous les joueurs. \u00cates-vous s\u00fbr de vouloir continuer ?",
                    "success": "Suppression des micro-jeux \u00e0 jeu direct",
                    "failed": "Impossible de supprimer le micro-jeu direct"
                }
            },
            "validations": {
                "not_owned": "Le micro-jeu direct n'appartient pas \u00e0 votre organisation"
            }
        },
        "domains": {
            "domains": "Domaines",
            "domain": "Domaine",
            "properties": {
                "domain": "Domaine"
            },
            "actions": {
                "create": {
                    "action": "Ajouter un domaine",
                    "success": "Domaine cr\u00e9\u00e9",
                    "failed": "Impossible de cr\u00e9er le domaine"
                },
                "update": {
                    "action": "Modifier le domaine",
                    "success": "Domaine mis \u00e0 jour",
                    "failed": "Impossible de mettre \u00e0 jour le domaine"
                },
                "delete": {
                    "action": "Supprimer le domaine",
                    "confirm": "Es-tu sur de vouloir continuer?",
                    "success": "Domaine supprim\u00e9",
                    "failed": "Impossible de supprimer le domaine"
                }
            }
        },
        "exception": {
            "one_time_login_token_invalid": "Jeton de connexion \u00e0 usage unique invalide",
            "one_time_login_token_expired": "Le jeton de connexion \u00e0 usage unique a expir\u00e9",
            "one_time_login_token_not_yet_valid": "Le jeton de connexion \u00e0 usage unique n'est pas encore valide",
            "one_time_login_token_consumed": "Le jeton de connexion \u00e0 usage unique est d\u00e9j\u00e0 utilis\u00e9",
            "one_time_login_token_not_for_organisation": "Le jeton de connexion \u00e0 usage unique n'est pas valide pour cette organisation.",
            "route_not_found": "Aucun itin\u00e9raire trouv\u00e9 pour cette demande",
            "feature_only_available_playground_landscape": "Cette fonctionnalit\u00e9 est uniquement disponible sur le th\u00e8me PlayGround.",
            "feature_only_available_fittar": "Cette fonctionnalit\u00e9 est uniquement disponible sur le th\u00e8me Fittar."
        },
        "gamified_video": {
            "gamified_video": "Vid\u00e9o ludique",
            "gamified_videos": "Vid\u00e9os ludiques",
            "overview_description": "Aper\u00e7u de toutes les vid\u00e9os ludiques import\u00e9es",
            "description": "Une vid\u00e9o gamifi\u00e9e est une vid\u00e9o interactive de HiHaHo. Les vid\u00e9os disponibles seront automatiquement r\u00e9cup\u00e9r\u00e9es de HiHaHo.",
            "select_available_video": "S\u00e9lectionnez une vid\u00e9o disponible",
            "preview": "aper\u00e7u",
            "properties": {
                "name": "Nom",
                "folder": "Dossier",
                "link": "Lien",
                "external_id": "ID externe",
                "embed_url": "URL d'incorporation",
                "total": "Total",
                "created": "Cr\u00e9\u00e9",
                "existing": "Existant"
            },
            "actions": {
                "play": {
                    "action": "Lisez la vid\u00e9o ci-dessous, puis continuez."
                },
                "import": {
                    "action": "Importer les vid\u00e9os Gamified",
                    "description": "Cette op\u00e9ration va importer les vid\u00e9os de jeux disponibles sur HiHaHo. Cette op\u00e9ration peut prendre un certain temps et doit \u00eatre ex\u00e9cut\u00e9e lorsque certaines vid\u00e9os sont manquantes. \u00cates-vous s\u00fbr de vouloir continuer ?",
                    "results": "Importer les r\u00e9sultats"
                }
            },
            "play_first": "Lire la vid\u00e9o d'abord",
            "play_first_description": "Lisez la vid\u00e9o avant de continuer",
            "unable_to_retrieve_progress": "Impossible de stocker la progression de la vid\u00e9o, cela signifie que nous sommes incapables de stocker la progression. Les d\u00e9veloppeurs sont inform\u00e9s !"
        },
        "gamified_video_folder": {
            "gamified_video_folders": "Dossiers des vid\u00e9os Gamified",
            "overview_description": "Aper\u00e7u de tous les dossiers des vid\u00e9os Gamified",
            "select_placeholder": "S\u00e9lectionnez le(s) dossier(s) vid\u00e9o gamifi\u00e9(s)",
            "none_assigned": "Il n'y a pas de dossiers vid\u00e9o gamifi\u00e9s attribu\u00e9s.",
            "properties": {
                "name": "Nom",
                "external_id": "ID externe"
            },
            "actions": {
                "update": {
                    "success": "Access to the gamified video folders is updated"
                }
            },
            "filter": {
                "folder": "Dossier",
                "all_folders": "Tous les dossiers"
            }
        },
        "general": {
            "start": "D\u00e9marrer la lecture",
            "start_workout": "Commencer l'entra\u00eenement",
            "start_video": "D\u00e9marrer la vid\u00e9o",
            "play_now": "Jouer maintenant",
            "quit": "Quitter",
            "data": "Donn\u00e9es",
            "data_tools": "Donn\u00e9es et outils",
            "dashboard": "Tableau de bord",
            "home": "Home",
            "welcome": "Bienvenue",
            "welcome_description": "Commencez \u00e0 jouer en vous connectant",
            "required": "Requis",
            "toggle_navigation": "Basculer la navigation",
            "insights": "Aper\u00e7us",
            "back_to_dashboard": "Retour au tableau de bord",
            "back_to_campaigns": "Retour aux campagnes",
            "back_to_exergames": "Retour aux exergames",
            "back_to_interactive_workouts": "Retour aux entra\u00eenements interactifs",
            "back_to_leaderboards": "Retour aux classements",
            "control_panel": "Panneau de contr\u00f4le",
            "no_avatar": "Pas d'avatar",
            "search": "Recherche",
            "search_placeholder": "Rechercher...",
            "status": "Statut",
            "active": "Actif",
            "inactive": "Inactif",
            "archived": "Archiv\u00e9",
            "clear_filter": "Effacer le filtre",
            "filter_results": "<strong>:start<\/strong> till <strong>:end<\/strong> of <strong>:total<\/strong> results",
            "results": "r\u00e9sultats",
            "access_denied": "Acc\u00e8s refus\u00e9",
            "access_denied_description": "D\u00e9sol\u00e9, mais vous n'avez pas les autorisations n\u00e9cessaires pour acc\u00e9der \u00e0 cette fonctionnalit\u00e9.",
            "unable_to_store_file": "Impossible de stocker le fichier",
            "unable_to_process_file": "Impossible de traiter le fichier",
            "upload_error": "Une erreur s'est produite lors du t\u00e9l\u00e9chargement",
            "invalid_file": "Fichier non valide fourni",
            "file_too_large": "La taille du fichier s\u00e9lectionn\u00e9 doit \u00eatre au maximum de :size Mb. R\u00e9duisez la taille du fichier pour utiliser ce fichier",
            "import": "Importer",
            "add": "Ajouter",
            "create": "Cr\u00e9er",
            "edit": "Modifier",
            "update": "Mettre \u00e0 jour",
            "manage": "G\u00e9rer",
            "delete": "Supprimer",
            "restore": "Restaurer",
            "filter": "Filter",
            "remove": "Supprimer",
            "assign": "Affecter",
            "revoke": "R\u00e9voquer",
            "failed": "\u00c9chec",
            "order": "Commande",
            "save": "Sauvegarder",
            "save_order": "Sauvegarder la commande",
            "properties": "Propri\u00e9t\u00e9s",
            "export": "Exporter",
            "oops": "Oups...",
            "text": "Texte",
            "header": "En-t\u00eate",
            "confirm": "Confirmer",
            "send": "Envoyer",
            "cancel": "Annuler",
            "minute": "minute",
            "minutes": "minutes",
            "minutes_short": "mins",
            "back": "Retour",
            "finish": "Terminer",
            "next": "Suivant",
            "summary": "R\u00e9sum\u00e9",
            "play_again": "Rejouer",
            "qr_code": "Code QR",
            "qr_code_description": "Utilisez ce code QR pour permettre au joueur de commencer \u00e0 jouer imm\u00e9diatement.",
            "qr_code_start": "Joueur imm\u00e9diatement",
            "download": "T\u00e9l\u00e9charger",
            "download_svg": "T\u00e9l\u00e9charger SVG",
            "download_png": "T\u00e9l\u00e9charger PNG",
            "or_go_to": "ou aller au",
            "logout": "Se d\u00e9connecter",
            "profile": "Profil",
            "add_field": "Ajouter le champ",
            "select_file": "Choisir le dossier",
            "settings": "Param\u00e8tres",
            "no_results": "Aucun r\u00e9sultat trouv\u00e9",
            "loading": "Chargement...",
            "close": "Fermer",
            "optional": "Facultatif",
            "is": "est",
            "seconds": "secondes",
            "selected": "S\u00e9lectionn\u00e9",
            "language_unavailable_in_organisation": "non disponible pour :organisation",
            "points": "Points",
            "score": "Score",
            "read_more": "En savoir plus",
            "high_score": "Score \u00e9lev\u00e9",
            "everything": "Tout",
            "this_field": "Ce champ",
            "reset": "R\u00e9initialiser",
            "tournament": "TOURNOI",
            "score_not_set": "score non \u00e9tabli",
            "image_cannot_be_loaded": "L'image ne peut pas \u00eatre charg\u00e9e"
        },
        "interactive_workouts": {
            "no_available_interactive_workouts_in_category": "Aucun entra\u00eenement interactif disponible dans cette cat\u00e9gorie",
            "tailored_workout_plans": "Programmes d'entra\u00eenement personnalis\u00e9s"
        },
        "leaderboard": {
            "leaderboard": "Tableau des leaders",
            "tournament": "Tournoi",
            "challenges": "D\u00e9fi",
            "games": "Jeux d'exercises",
            "properties": {
                "rank": "Rang",
                "total": "Total",
                "player": "Joueur",
                "score": "Score",
                "bonus": "Bonus"
            },
            "league": {
                "levels": {
                    "bronze": "Ligue de bronze",
                    "silver": "Ligue d'argent",
                    "gold": "Ligue d'or"
                },
                "poule": "Poule",
                "promotion_zone": "Zone de promotion",
                "relegation_zone": "Zone de rel\u00e9gation",
                "user_promotion_zone": "Vous \u00eates dans la zone de promotion",
                "user_relegation_zone": "Vous \u00eates dans la zone de rel\u00e9gation",
                "xp_ahead": ":value :xp en avance pour passer \u00e0 la ligue suivante",
                "xp_to_maintain": ":value :xp devait \u00eatre en s\u00e9curit\u00e9"
            }
        },
        "micro_game": {
            "micro_game": "Micro jeu",
            "micro_games": "Micro jeu",
            "your_latest_highscore": "Votre dernier meilleur score",
            "play": "Jouer",
            "management": {
                "title": "Micro jeux",
                "description": "G\u00e9rez les microjeux disponibles.",
                "groups": {
                    "group": "Groupe de micro-jeux",
                    "groups": "Groupes de micro-jeux",
                    "overview": "G\u00e9rez les groupes de micro-jeux disponibles."
                }
            },
            "properties": {
                "name": "Nom",
                "identifier": "Identifiant",
                "description": "Description",
                "image": "Image",
                "image_select": "S\u00e9lectionnez l'image",
                "group": "Groupe",
                "is_global": "Micro-jeu mondial",
                "is_global_description": "Un micro-jeu global peut \u00eatre utilis\u00e9 par toutes les organisations.",
                "organisations": "Organisations",
                "points": "Points",
                "stars": "\u00c9toiles",
                "stars_threshold": "Seuil des \u00e9toiles",
                "build": "Construire",
                "webgl_location": "Emplacement de WebGL",
                "custom_data": "Donn\u00e9es personnalis\u00e9es",
                "key": "Cl\u00e9",
                "value": "Valeur",
                "categories": "Cat\u00e9gories",
                "category": "Cat\u00e9gorie"
            },
            "actions": {
                "bulk": {
                    "update": {
                        "success": "Micro jeux mis \u00e0 jour",
                        "failed": "Impossible de mettre \u00e0 jour les micro jeux"
                    }
                },
                "create": {
                    "action": "Ajouter un micro jeu",
                    "success": "Micro jeu ajout\u00e9",
                    "failed": "Impossible d'ajouter le micro jeu"
                },
                "update": {
                    "action": "Modifier le micro jeu",
                    "success": "Micro jeu mis \u00e0 jour",
                    "failed": "Impossible de mettre \u00e0 jour le micro jeu"
                },
                "delete": {
                    "action": "Contenu du micro jeu",
                    "confirm": "En supprimant le micro jeu, les joueurs ne pourront plus y jouer. \u00cates-vous s\u00fbr de vouloir continuer ?",
                    "success": "Micro jeu supprim\u00e9",
                    "failed": "Impossible de supprimer le micro-jeu"
                },
                "sync": {
                    "action": "Mettre \u00e0 jour les organisations",
                    "success": "Les organisations du micro jeu sont mises \u00e0 jour",
                    "is_global": "Les organisations d'un micro-jeu mondial ne peuvent pas \u00eatre mises \u00e0 jour"
                }
            },
            "filter": {
                "all_groups": "Tous les groupes",
                "all_categories": "Toutes les cat\u00e9gories",
                "select_micro_game": "S\u00e9lectionner le micro-jeu",
                "select_micro_game_of_group": "S\u00e9lectionner :group",
                "select_micro_game_group": "S\u00e9lectionner le groupe"
            },
            "validations": {
                "organisation_must_have_access": "The organisation does not have access to this micro game."
            },
            "done_with_playing": "Termin\u00e9 avec le jeu",
            "ends": "prend fin"
        },
        "micro_game_group": {
            "group": "Groupe de micro-jeux",
            "groups": "Groupes de micro-jeux",
            "management": {
                "title": "Groupes de micro-jeux",
                "description": "G\u00e9rez les groupes de micro-jeux disponibles."
            },
            "properties": {
                "name": "Nom",
                "identifier": "Identifiant",
                "image": "Image",
                "image_select": "S\u00e9lectionnez l'image",
                "build": "Construire",
                "custom_data": "Donn\u00e9es personnalis\u00e9es",
                "webgl_location": "Emplacement WebGL",
                "type": "Genre",
                "categories": "Cat\u00e9gories"
            },
            "types": {
                "micro_game": "Micro-jeux",
                "fitness_content": "Fitness content",
                "exergame": "Exergame",
                "interactive_workout": "Entra\u00eenements interactif",
                "challenges": "d\u00e9fis"
            },
            "interactive_workout": {
                "categories": {
                    "upper_body": "Haut du corps",
                    "lower_body": "Bas du corps",
                    "full_body": "Corps entier",
                    "cardio": "Cardio"
                },
                "exercise_time": "Dur\u00e9e de l'exercice (minutes)"
            },
            "videos": {
                "categories": {
                    "office": "Bureau",
                    "endurance": "Endurance",
                    "strength": "Force",
                    "dance": "Danse",
                    "yoga": "Yoga"
                },
                "exercise_time": "Video Exercise Time (minutes)",
                "no_available_video_in_category": "Aucune vid\u00e9o disponible dans cette cat\u00e9gorie"
            },
            "filter": {
                "all_types": "Tous les genres",
                "select_type": "S\u00e9lectionner le genre",
                "select_category": "selecteer categorie"
            },
            "actions": {
                "create": {
                    "action": "Ajouter un groupe de micro-jeux",
                    "success": "Groupe de micro-jeux ajout\u00e9",
                    "failed": "Impossible d'ajouter le groupe de micro-jeux"
                },
                "update": {
                    "action": "Modifier le groupe de micro-jeux",
                    "success": "Groupe de micro-jeux mis \u00e0 jour",
                    "failed": "Impossible de mettre \u00e0 jour le groupe de micro-jeux"
                },
                "delete": {
                    "action": "Supprimer le groupe de micro-jeux",
                    "confirm": "Es-tu sur de vouloir continuer?",
                    "success": "Groupe de micro-jeux supprim\u00e9",
                    "failed": "Impossible de supprimer le groupe de micro-jeux",
                    "prohibited": "Non autoris\u00e9 \u00e0 supprimer un groupe de micro-jeux avec des micro-jeux qui lui sont attribu\u00e9s"
                }
            }
        },
        "module": {
            "module": "Module",
            "module_type": "Type",
            "module_skills": "Comp\u00e9tences",
            "modules": "Modules",
            "modules_completed": "Modules termin\u00e9s",
            "module_completed_at": "Module termin\u00e9 \u00e0",
            "module_play": "Jouez le module et obtenez le meilleur score",
            "proceed_with_challenge": "Cliquez sur suivant pour poursuivre le d\u00e9fi.",
            "properties": {
                "name": "Nom",
                "description": "Description",
                "threshold": "Seuil",
                "threshold_description": "Le seuil d\u00e9termine si le participant a r\u00e9ussi ou \u00e9chou\u00e9.",
                "threshold_description_value": "Le seuil est un pourcentage du nombre de questions auxquelles il a \u00e9t\u00e9 r\u00e9pondu correctement. Par exemple, si le seuil est de 75 et qu'il y a 4 questions, le participant doit r\u00e9pondre correctement \u00e0 au moins 3 questions.",
                "reading_time": "Temps de lecture",
                "viewed_video": "J'ai regard\u00e9 la vid\u00e9o ou je l'ai d\u00e9j\u00e0 regard\u00e9e.",
                "factor": "Facteur",
                "factor_description": "Le facteur d\u00e9termine combien de points sont attribu\u00e9s. Par d\u00e9faut, le joueur gagne :default_score points pour avoir termin\u00e9 un module. En ajustant le facteur, vous pouvez augmenter ou diminuer le score.",
                "image": "Image",
                "image_select": "S\u00e9lectionnez l'image",
                "content": "Contenu",
                "video": "Vid\u00e9o",
                "video_url": "URL de la vid\u00e9o",
                "video_description": "Utilisez le lien vers la vid\u00e9o (dans la barre d'adresse de votre navigateur). Il n'est pas n\u00e9cessaire que ce soit un lien sp\u00e9cial, l'application s'en chargera pour vous.",
                "text": "Texte",
                "text_description": "Un module de texte contient une br\u00e8ve explication ou introduction et une image qui accompagne le texte lorsque vous jouez au module.",
                "question_time": "Temps par question",
                "question_time_description": "Le temps maximum disponible par question.",
                "total_questions_used": "Nombre de questions \u00e0 afficher",
                "total_questions_used_description": "Le nombre de questions pr\u00e9sent\u00e9es aux joueurs (vide = toutes les questions). S\u00e9lection al\u00e9atoire si plus de questions que le nombre indiqu\u00e9."
            },
            "actions": {
                "create": {
                    "title": "Cr\u00e9er un module :type",
                    "success": "Module cr\u00e9\u00e9",
                    "failed": "Impossible de cr\u00e9er le module"
                },
                "update": {
                    "title": "Modifier le module :type",
                    "success": "Module mis \u00e0 jour",
                    "failed": "Impossible de mettre \u00e0 jour le module"
                },
                "delete": {
                    "action": "Supprimer le module",
                    "confirm": "Supprimer le module du d\u00e9fi aura pour cons\u00e9quence que personne ne pourra jouer le module. \u00cates-vous s\u00fbr de vouloir continuer ?",
                    "success": "Module supprim\u00e9",
                    "failed": "Impossible de supprimer le module",
                    "failed_battle": "Impossible de supprimer le module car il y a une bataille qui choisit au hasard un micro-jeu de cette campagne, et c'est le dernier micro-jeu de cette campagne."
                },
                "restore": {
                    "action": "Restaurer le module",
                    "confirm": "Lors de la restauration d'un module, le module est directement accessible. \u00cates-vous s\u00fbr de vouloir continuer ?",
                    "success": "Module restaur\u00e9",
                    "failed": "Impossible de restaurer le module"
                },
                "order": {
                    "success": "Mise \u00e0 jour de l'ordre des modules",
                    "failed": "Impossible de mettre \u00e0 jour l'ordre des modules"
                }
            },
            "filter": {
                "all_types": "Tous les types"
            },
            "validations": {
                "must_be_part_of_organisation": "Le module doit appartenir \u00e0 l'organisation",
                "invalid_properties": "Le type de module n\u00e9cessite une configuration manquante, par exemple lorsqu'un objet associ\u00e9 est supprim\u00e9. Veuillez modifier ou supprimer ce module."
            },
            "already_played": "Vous avez d\u00e9j\u00e0 jou\u00e9 \u00e0 ce module. Cliquez sur 'Suivant' pour continuer avec le d\u00e9fi."
        },
        "module_session": {
            "actions": {
                "create": {
                    "failed": "Impossible de mettre \u00e0 jour la session du module"
                },
                "update": {
                    "failed": "Impossible de mettre \u00e0 jour la session du module"
                }
            },
            "validations": {
                "not_owned": "Modifiez uniquement vos propres sessions de module"
            }
        },
        "organisation": {
            "organisation": "Organisation",
            "organisations": "Organisations",
            "crud_description": "Le sous-domaine de l'organisation doit \u00eatre unique et se composer de lettres (a-z), de chiffres (0-9) et d'un tiret (-).",
            "select_placeholder": "S\u00e9lectionnez une ou des organisation(s)",
            "universal_authentication_enabled": "Authentification universelle activ\u00e9e",
            "universal_authentication_enabled_description": "Lorsqu'elle est activ\u00e9e, l'organisation utilise le flux d'authentification universel",
            "logo": "Logo",
            "validations": {
                "not_found": "Organisation non trouv\u00e9e",
                "not_a_member": "Pas d'acc\u00e8s \u00e0 l'organisation"
            },
            "properties": {
                "customer": "Client",
                "name": "Nom",
                "subdomain": "Sous-domaine",
                "url": "Url",
                "languages": "Param\u00e8tres de langue",
                "default_language": "Langue par d\u00e9faut",
                "available_languages": "Langues prises en charge",
                "available_languages_warning": "Lorsque vous supprimez une langue prise en charge, vous perdez les donn\u00e9es pour la langue supprim\u00e9e lorsque vous modifiez un \u00e9l\u00e9ment.",
                "manage_translations": "G\u00e9rer les traductions personnalis\u00e9es",
                "reseller": "Revendeur",
                "gamified_video_folders": "Dossiers vid\u00e9o gamifi\u00e9s",
                "gamified_video_folders_description": "S\u00e9lectionnez les dossiers vid\u00e9o gamifi\u00e9s pouvant \u00eatre utilis\u00e9s par l'organisation.",
                "social": "Social",
                "social_description": "Ajoutez une <a href=\"https:\/\/www.freecodecamp.org\/news\/what-is-open-graph-and-how-can-i-use-it-for-my-website\" target=\"_blank\">image de graphique<\/a> ouvert et une description.",
                "customization": "Personnalisation",
                "customization_description": "L'application peut \u00eatre personnalis\u00e9e pour l'organisation afin d'avoir un aspect et une sensation correspondants",
                "logo": "Logo",
                "logo_requirements": "Max 4Mb",
                "logo_select": "S\u00e9lectionnez le logo",
                "open_graph_image": "Image graphique ouverte",
                "open_graph_image_requirements": "Image graphique ouverte (minimum 640\u00d7320px, max 4Mb",
                "open_graph_image_select": "S\u00e9lectionner une image",
                "open_graph_description": "Ouvrir la description du graphique",
                "theme_setup": "Configuration des th\u00e8mes",
                "theme_look_and_feel": "Look and feel",
                "theme_select": "S\u00e9lectionner le th\u00e8me",
                "manage_theme": "G\u00e9rer le th\u00e8me personnalis\u00e9",
                "background": "Arri\u00e8re-plan",
                "background_mobile": "Arri\u00e8re-plan (mobile)",
                "background_tablet": "Arri\u00e8re-plan (tablette)",
                "background_desktop": "Arri\u00e8re-plan (desktop)",
                "background_requirements": "Max 4Mb)",
                "background_select": "S\u00e9lectionnez le fond",
                "primary_color": "Couleur primaire",
                "secondary_color": "Couleur secondaire",
                "accent_color": "Couleur accent",
                "card_backdrop": "Arri\u00e8re-plan de la carte",
                "background_color": "Couleur de l'arri\u00e8re plan",
                "background_gradient_bottom": "Fond d\u00e9grad\u00e9 en bas",
                "background_gradient_top": "Fond d\u00e9grad\u00e9 en haut",
                "card_background_color": "Couleur de fond de la carte",
                "module_shadow_color": "Couleur de l'ombre du module",
                "primary_font_color": "Couleur de police principale",
                "secondary_font_color": "Couleur de police secondaire",
                "primary_font_family": "Famille de police principale",
                "primary_font_family_select": "S\u00e9lectionnez la police principale...",
                "secondary_font_family": "Famille de police secondaire",
                "secondary_font_family_select": "S\u00e9lectionnez la police principale...",
                "preview_fonts": "Les polices peuvent \u00eatre pr\u00e9visualis\u00e9es ici: :url",
                "card_border_radius": "Rayon de la bordure de la carte",
                "welcome_text": "Texte de bienvenue",
                "welcome_text_description": "D\u00e9finit le texte affich\u00e9 sur l'\u00e9cran de connexion",
                "configuration": "Configuration",
                "configuration_description": "Determine which features are enabled for this organisation",
                "registration_allowed": "Enregistrement autoris\u00e9",
                "registration_allowed_header": "Enregistrement<br>autoris\u00e9",
                "registration_description": "Permettre aux utilisateurs de s'inscrire sans invitation",
                "global_content": "Contenu global",
                "global_content_description": "Autoriser l'organisation \u00e0 utiliser le contenu global",
                "demo_user_allowed": "Jouer en tant qu'utilisateur d\u00e9mo autoris\u00e9",
                "demo_user_allowed_header": "Utilisateur d\u00e9mo<br>autoris\u00e9",
                "demo_user_description": "Permettre aux utilisateurs de jouer sans compte. Attention, <strong>aucun progr\u00e8s<\/strong> n'est suivi.",
                "allow_upgrade_to_registered_user": "Autoriser la mise \u00e0 niveau pour les utilisateurs enregistr\u00e9s",
                "allow_upgrade_to_registered_user_description": "Permettre aux utilisateurs de d\u00e9monstrations de passer au statut d'utilisateur enregistr\u00e9 en ajoutant et en confirmant leur adresse \u00e9lectronique.",
                "reseller_allowed": "L'organisation est un revendeur",
                "reseller_allowed_header": "L'organisation<br>revendeur",
                "reseller_description": "Un revendeur peut cr\u00e9er des organisations suppl\u00e9mentaires en tant que clients.",
                "webhook_url": "Webhook URL",
                "webhook_url_description": "Il est possible de laisser le lecteur de gamification appeler un <a href=\":url\" target=\"_blank\">webhook<\/a> dans certains \u00e9v\u00e9nements. Le lecteur de gamification <code>POST<\/code> plusieurs \u00e9v\u00e9nements sur le webhook.",
                "webhook_secret": "Webhook secret",
                "webhook_secret_description": "Comme le lecteur de gamification est h\u00e9berg\u00e9 sur un cluster, aucune adresse IP fixe n'est disponible. Vous devez fournir un <a href=\":url\" target=\"_blank\">secret\/jeton<\/a> en plus de l'URL du webhook pour assurer sa s\u00e9curit\u00e9. Le secret\/jeton peut \u00eatre tout ce que vous voulez et est fourni dans l'en-t\u00eate <code>X-Webhook-Token<\/code>.",
                "webhook_events": "Webhook events",
                "webhook_events_description": "S\u00e9lectionnez tous les \u00e9v\u00e9nements webhook que vous souhaitez recevoir pour \u00e9viter les \u00e9v\u00e9nements webhook inutiles.",
                "webhook_events_select": "Recevoir tous les \u00e9v\u00e9nements",
                "ios_app_url": "URL de l'application iOS",
                "android_app_url": "URL de l'application Android",
                "branchio_url": "Branch.io URL",
                "sso_configurations": ":count configuration|:count configurations",
                "domains": ":count domaine|:count domaines",
                "permissions": "Autorisations",
                "timezone": "Fuseau horaire",
                "default_avatar": "Photo de profil par d\u00e9faut",
                "default_avatar_select": "S\u00e9lectionnez la photo de profil par d\u00e9faut",
                "default_avatar_requirements": "Max. 4Mb"
            },
            "actions": {
                "create": {
                    "success": "Organisation cr\u00e9\u00e9e",
                    "failed": "Impossible de cr\u00e9er l'organisation"
                },
                "update": {
                    "success": "Organisation mise \u00e0 jour",
                    "failed": "Impossible de mettre \u00e0 jour l'organisation"
                },
                "delete": {
                    "action": "Supprimer l'organisation",
                    "confirm": "Lorsque vous supprimez une organisation, celle-ci perd imm\u00e9diatement son acc\u00e8s. \u00cates-vous s\u00fbr de vouloir supprimer l'organisation ?",
                    "success": "Organisation supprim\u00e9e",
                    "failed": "Impossible de supprimer l'organisation"
                },
                "restore": {
                    "action": "Restaurer l'organisation",
                    "confirm": "Lorsque vous restaurez une organisation, l'acc\u00e8s \u00e0 l'organisation est imm\u00e9diatement r\u00e9tabli. \u00cates-vous s\u00fbr de vouloir restaurer l'organisation ?",
                    "success": "Organisation restaur\u00e9e",
                    "failed": "Impossible de restaurer l'organisation"
                }
            },
            "customer_of": "Client de :organisation",
            "embed_code": "Code d'incorporation",
            "embed_width": "Largeur",
            "embed_height": "Hauteur"
        },
        "pagination": {
            "previous": "&laquo; Pr\u00e9c\u00e9dent",
            "next": "Suivant &raquo;"
        },
        "passwords": {
            "reset": "Votre mot de passe a \u00e9t\u00e9 r\u00e9initialis\u00e9 !",
            "sent": "Nous vous avons envoy\u00e9 par e-mail le lien de r\u00e9initialisation de votre mot de passe.",
            "throttled": "Veuillez patienter avant de r\u00e9essayer.",
            "token": "Ce jeton de r\u00e9initialisation de mot de passe n'est pas valide.",
            "user": "Nous n'avons pas trouv\u00e9 d'utilisateur avec cette adresse e-mail."
        },
        "profile": {
            "profile": "Profil",
            "your_profile": "Votre profil",
            "back_to_dashboard": "Retour au tableau de bord",
            "update_profile": "Mise \u00e0 jour du profil",
            "edit_profile": "Modifier profil",
            "delete_profile": "Supprimer le profil",
            "properties": {
                "name": "Nom",
                "email": "Adresse e-mail",
                "password": "Mot de passe",
                "password_confirmation": "Confirmer le mot de passe",
                "password_requirements": "Fournissez un nouveau mot de passe. Le mot de passe doit \u00eatre conforme \u00e0 :",
                "password_minimal_characters": "Au moins 8 caract\u00e8res",
                "password_minimal_uppercase": "Au moins 1 caract\u00e8re majuscule",
                "password_minimal_lowercase": "Au moins 1 caract\u00e8re minuscule",
                "password_minimal_number": "Au moins 1 chiffre",
                "password_weak": "Too weak",
                "password_not_bad": "Not bad",
                "password_almost": "Almost there",
                "username": "Nom d'utilisateur",
                "no_username": "Pas de nom d'utilisateur",
                "country": "Pays",
                "avatar": "Avatar",
                "choose_avatar": "Choisissez un avatar",
                "upload_own_avatar": "T\u00e9l\u00e9chargez votre propre avatar",
                "edit_profile_photo": "Modifier la photo de profil",
                "photo": "Photo",
                "choose_photo": "Choisissez une photo",
                "upload_photo": "Envoyer la photo",
                "choose_language": "Choisissez la langue",
                "change_language": "Modifier la language",
                "change_password": "Changer le mot de passe",
                "phonenumber": "Num\u00e9ro de t\u00e9l\u00e9phone"
            },
            "demo": {
                "not_allowed": "En tant qu'utilisateur demo, vous n'\u00eates pas autoris\u00e9 \u00e0 modifier votre profil."
            },
            "actions": {
                "update": {
                    "action": "Sauvegarder le profil",
                    "success": "Profil mis \u00e0 jour",
                    "failed": "Impossible de mettre \u00e0 jour le profil"
                },
                "update_password": {
                    "action": "Mettre \u00e0 jour le mot de passe"
                }
            },
            "filter": {
                "select_country": "S\u00e9lectionner le pays",
                "select_avatar": "S\u00e9lectionner l'avatar"
            }
        },
        "question": {
            "question": "Question",
            "questions": "Questions",
            "question_description": "Cette question sera pos\u00e9e au joueur pendant le jeu. Les questions d'un quiz sont class\u00e9es dans l'ordre et peuvent donc pr\u00e9senter une difficult\u00e9 croissante.",
            "no_answers": "Aucune r\u00e9ponse",
            "type": {
                "single": "Choix unique",
                "multiple": "Choix multiple"
            },
            "properties": {
                "type": "Type",
                "feedback_correct": "commentaires corrects",
                "feedback_wrong": "r\u00e9troaction erron\u00e9e",
                "feedback_correct_answer": "R\u00e9ponse correcte",
                "feedback_wrong_answer": "Commentaires sur les mauvaises r\u00e9ponses",
                "content": "Contenu",
                "image": "Image",
                "image_select": "S\u00e9lectionner l'image",
                "feedback": "Commentaires",
                "feedback_edit": "Feedback modifier",
                "feedback_description": "Apr\u00e8s avoir r\u00e9pondu \u00e0 la question, le joueur peut recevoir des informations utiles. En fonction de la bonne ou de la mauvaise r\u00e9ponse donn\u00e9e, le joueur re\u00e7oit un retour diff\u00e9rent. Le retour d'information n'est pas obligatoire, mais il est recommand\u00e9 pour am\u00e9liorer l'exp\u00e9rience.",
                "excel_file": "Excel d\u00e9poser",
                "file_select": "Choisir le dossier",
                "file": "D\u00e9poser"
            },
            "template": "Mod\u00e8le",
            "actions": {
                "create": {
                    "import": "Importer des questions",
                    "action": "Ajouter une question",
                    "success": "Question cr\u00e9\u00e9e",
                    "failed": "Impossible de cr\u00e9er la question"
                },
                "update": {
                    "action": "Modifier la question",
                    "success": "Question mise \u00e0 jour",
                    "failed": "Impossible de mettre \u00e0 jour la question"
                },
                "delete": {
                    "action": "Suppression de la question",
                    "confirm": "Lorsque vous supprimez une question du quiz, les participants ne la verront plus. \u00cates-vous s\u00fbr de vouloir continuer ?",
                    "success": "Question supprim\u00e9e",
                    "failed": "Impossible de supprimer la question"
                },
                "restore": {
                    "action": "Restaurer la question",
                    "confirm": "Lorsque vous restaurez la question, les participants devront r\u00e9pondre \u00e0 cette question. \u00cates-vous s\u00fbr de vouloir continuer ?",
                    "success": "Question restaur\u00e9e",
                    "failed": "Impossible de restaurer la question"
                },
                "order": {
                    "success": "Mettre \u00e0 jour l'ordre des questions"
                },
                "template": {
                    "download": "T\u00e9l\u00e9charger le mod\u00e8le"
                },
                "import": {
                    "store": "Impossible d'effectuer une importation lorsque des questions existent d\u00e9j\u00e0",
                    "success": "Questions cr\u00e9\u00e9es"
                }
            },
            "validations": {
                "check_answer_first": "V\u00e9rifiez la r\u00e9ponse avant de passer \u00e0 la question suivante.",
                "unable_check_answer": "Impossible de v\u00e9rifier les r\u00e9ponses",
                "provide_at_least_one_answer": "Fournir au moins une r\u00e9ponse",
                "no_correct_answers": "Aucune r\u00e9ponse correcte ou toutes les r\u00e9ponses sont correctes"
            }
        },
        "quiz": {
            "quiz": "Quiz",
            "properties": {
                "question_image": "Image pour la question"
            },
            "done": "Le quiz est enti\u00e8rement r\u00e9pondu dans cette session. Rejouez le d\u00e9fi pour effectuer \u00e0 nouveau le quiz.",
            "check_answer": "V\u00e9rifier la r\u00e9ponse",
            "next_question": "Question suivante",
            "time_left": "Temps restant",
            "could_not_be_loaded": "Le quiz ne peut pas \u00eatre charg\u00e9. Veuillez r\u00e9essayer plus tard."
        },
        "reseller": {
            "customer": "Client",
            "customers": "Clients",
            "actions": {
                "create": {
                    "action": "Ajouter un client",
                    "success": "Client cr\u00e9\u00e9",
                    "failed": "Impossible de cr\u00e9er le client"
                },
                "update": {
                    "action": "Modifier le client",
                    "success": "Client mis \u00e0 jour",
                    "failed": "Impossible de mettre \u00e0 jour le client"
                },
                "delete": {
                    "action": "Supprimer un client",
                    "confirm": "Lorsque vous retirez un client, celui-ci perd imm\u00e9diatement son acc\u00e8s. \u00cates-vous s\u00fbr de vouloir continuer ?",
                    "success": "Client supprim\u00e9",
                    "failed": "Impossible de supprimer le client"
                },
                "restore": {
                    "action": "Restaurer le client",
                    "confirm": "Lors de la restauration d'un client, le client a imm\u00e9diatement acc\u00e8s au syst\u00e8me. \u00cates-vous s\u00fbr de vouloir continuer ?",
                    "success": "Client restaur\u00e9",
                    "failed": "Impossible de restaurer le client"
                }
            },
            "validations": {
                "no_access": "Votre organisation n'est pas le revendeur de ce client."
            }
        },
        "skill": {
            "skill": "Comp\u00e9tence",
            "skills": "Comp\u00e9tences",
            "select_placeholder": "S\u00e9lectionner les comp\u00e9tences",
            "management": {
                "description": "Une comp\u00e9tence peut \u00eatre ajout\u00e9e \u00e0 un module"
            },
            "properties": {
                "name": "Nom",
                "description": "Description",
                "show_on_graph": "Afficher sur le graphique"
            },
            "actions": {
                "create": {
                    "action": "Cr\u00e9er une comp\u00e9tence",
                    "success": "Comp\u00e9tence cr\u00e9\u00e9e",
                    "failed": "Impossible de cr\u00e9er la comp\u00e9tence"
                },
                "update": {
                    "action": "Modifier la comp\u00e9tence",
                    "success": "Comp\u00e9tence mise \u00e0 jour",
                    "failed": "Impossible de mettre \u00e0 jour la comp\u00e9tence"
                },
                "delete": {
                    "action": "Supprimer la comp\u00e9tence",
                    "confirm": "Lorsque vous supprimez une comp\u00e9tence, celle-ci est directement supprim\u00e9e pour tous les joueurs. Etes-vous s\u00fbr de vouloir continuer ?",
                    "success": "Comp\u00e9tence supprim\u00e9e",
                    "failed": "Impossible de supprimer la comp\u00e9tence"
                },
                "restore": {
                    "action": "Restaurer la comp\u00e9tence",
                    "confirm": "Lorsque vous restaurez une comp\u00e9tence, celle-ci est directement accessible. Etes-vous s\u00fbr de vouloir continuer ?",
                    "success": "Comp\u00e9tence restaur\u00e9e",
                    "failed": "Impossible de restaurer la comp\u00e9tence"
                }
            },
            "user_distribution": "R\u00e9partition des utilisateurs",
            "validations": {
                "not_owned": "La comp\u00e9tence n'appartient pas \u00e0 votre organisation",
                "unique": "La comp\u00e9tence doit \u00eatre unique"
            }
        },
        "sso": {
            "sso": "Authentification unique",
            "properties": {
                "name": "Texte du bouton",
                "provider": "Fournisseur",
                "login_url": "URL de connexion"
            },
            "sections": {
                "appearance": {
                    "title": "Apparition",
                    "description": "Configurez la mani\u00e8re dont cette option d'authentification unique est pr\u00e9sent\u00e9e \u00e0 vos utilisateurs sur la page de connexion."
                },
                "configuration": {
                    "title": "Configuration"
                }
            },
            "providers": {
                "google": {
                    "driver": "Google Workspace",
                    "properties": {
                        "client_id": "App ID",
                        "client_secret": "Secret du client",
                        "domain": "Domaine Google Workspace"
                    },
                    "placeholders": {
                        "client_id": "*****.apps.googleusercontent.com",
                        "client_secret": "********"
                    }
                },
                "azure": {
                    "driver": "Azure AD",
                    "properties": {
                        "client_id": "Application (client) ID",
                        "client_secret": "Application secret",
                        "tenant": "Directory (tenant) ID"
                    },
                    "placeholders": {
                        "client_id": "00000000-0000-0000-0000-000000000000",
                        "client_secret": "********"
                    }
                },
                "oidc": {
                    "driver": "G\u00e9n\u00e9rique OIDC",
                    "description": "Le point de :authorization_endpoint, le :token_endpoint et le :userinfo_endpoint sont requis si l':discovery_endpoint n'est pas fournie. Lorsque les deux sont fournis, les points de terminaison explicitement d\u00e9finis ont la priorit\u00e9.",
                    "properties": {
                        "client_id": "App ID",
                        "client_secret": "Secret du client",
                        "discovery_endpoint": "URL de d\u00e9couverte de la configuration",
                        "authorization_endpoint": "Point de terminaison d'autorisation",
                        "token_endpoint": "Point de terminaison du jeton",
                        "userinfo_endpoint": "Point d'acc\u00e8s aux informations sur l'utilisateur",
                        "id_key": "Attribut d'identifiant unique sur l'objet utilisateur"
                    },
                    "placeholders": {
                        "client_id": "",
                        "client_secret": ""
                    }
                },
                "adfs": {
                    "driver": "Active Directory Federation Services",
                    "description": "Le point de :authorization_endpoint, le :token_endpoint et le :jwks_uri sont requis si l':discovery_endpoint n'est pas fournie. Lorsque les deux sont fournis, les points de terminaison explicitement d\u00e9finis ont la priorit\u00e9.",
                    "properties": {
                        "client_id": "App ID",
                        "client_secret": "Secret partag\u00e9",
                        "discovery_endpoint": "URL de d\u00e9couverte de la configuration",
                        "authorization_endpoint": "Point de terminaison d'autorisation",
                        "token_endpoint": "Point de terminaison du jeton",
                        "jwks_uri": "URL de JSON Web Key Sets (JWKS)"
                    },
                    "placeholders": {
                        "client_id": "",
                        "client_secret": ""
                    }
                }
            },
            "actions": {
                "create": {
                    "action": "Ajouter une configuration SSO",
                    "success": "Configuration SSO cr\u00e9\u00e9e",
                    "failed": "Impossible de cr\u00e9er la configuration SSO"
                },
                "update": {
                    "action": "Modifier la configuration du SSO",
                    "success": "Mise \u00e0 jour de la configuration SSO",
                    "failed": "Impossible de mettre \u00e0 jour la configuration du SSO"
                },
                "delete": {
                    "action": "Supprimer la configuration du SSO",
                    "confirm": "Lorsque vous supprimez une configuration SSO, celle-ci ne peut plus \u00eatre utilis\u00e9e pour se connecter avec effet imm\u00e9diat. \u00cates-vous s\u00fbr de vouloir continuer ?",
                    "success": "Suppression de la configuration SSO",
                    "failed": "Impossible de supprimer la configuration SSO"
                }
            }
        },
        "stats": {
            "status": "Statut",
            "playing": "En cours :",
            "completed": "Termin\u00e9",
            "you": "Vous",
            "average_player": "Joueur moyen",
            "hours_play_time": "Heures de jeu",
            "modules_played": "Modules jou\u00e9s",
            "experience": "Exp\u00e9rience",
            "xp": "XP",
            "rewards": "R\u00e9compenses",
            "achievements": "R\u00e9alisations",
            "badges": "Badges",
            "certificates": "Certificats",
            "campaign_stats": "Statistiques de la campagne",
            "personal_stats": "Statistiques personnelles",
            "overal_stats": "Statistiques globales",
            "average_score": "Score moyen",
            "not_enough_data": "pas assez de donn\u00e9es",
            "xp_per_month": ":xp par mois",
            "xp_per_week": ":xp par semaine",
            "weekly": "Hebdomadaire",
            "monthly": "Mensuel",
            "experience_points": "Points d'exp\u00e9rience",
            "weeks": "Semaines",
            "stats": "Statistiques",
            "xp_graph": "Graphique XP",
            "active_days": "Jours actifs",
            "total_time_spent": "Temps total pass\u00e9",
            "challenges": "D\u00e9fis",
            "workouts": "Entra\u00eenements",
            "games": "Jeux",
            "videos": "Vid\u00e9os"
        },
        "survey": {
            "survey": "Enqu\u00eate",
            "surveys": "Enqu\u00eates",
            "view_survey": "Voir Enqu\u00eate",
            "insight_description": "Ici, vous pouvez voir les r\u00e9ponses par entr\u00e9e d'enqu\u00eate. \u00c0 c\u00f4t\u00e9, vous trouverez le nombre de fois o\u00f9 une r\u00e9ponse a \u00e9t\u00e9 fournie. Les donn\u00e9es peuvent \u00eatre export\u00e9es \u00e0 l'aide du bouton ci-dessus.",
            "part_of_challenge": "Partie du d\u00e9fi",
            "part_of_campaign": "Partie de la campagne",
            "sessions": "Sessions",
            "type_descriptive": "Question\/affectation\/d\u00e9claration",
            "options": "Options",
            "provide_answer": "Donnez votre r\u00e9ponse ou votre r\u00e9action ci-dessous",
            "order": "Ordre",
            "type": "Type",
            "question": "Question",
            "provided_answer": "R\u00e9ponse fournie",
            "provided_amount": "Temps fourni",
            "no_data": "Aucune donn\u00e9e n'a pu \u00eatre trouv\u00e9e pour cette enqu\u00eate.",
            "properties": {
                "reaction": "R\u00e9action",
                "reactions": "R\u00e9actions",
                "totally_disagree": "Totalement en d\u00e9saccord",
                "disagree": "Pas d'accord",
                "agree": "D'accord",
                "totally_agree": "Totalement d'accord",
                "pdf_text": "Texte PDF",
                "pdf_text_description": "Le texte qui sera affich\u00e9 sur le PDF g\u00e9n\u00e9r\u00e9 pour cette enqu\u00eate."
            },
            "validations": {
                "ensure_single_choice": "Au moins une option est n\u00e9cessaire",
                "ensure_multiple_choice": "Au moins deux options sont requises"
            }
        },
        "survey_entry": {
            "survey_entry": "Entr\u00e9e d'enqu\u00eate",
            "survey_entries": "Entr\u00e9es d'enqu\u00eate",
            "survey_entry_description": "Le joueur verra cette entr\u00e9e d'enqu\u00eate comme une partie de l'enqu\u00eate.",
            "statement": "D\u00e9claration",
            "question_or_assignment": "Question\/affectation",
            "reaction_or_answer": "R\u00e9ponse\/r\u00e9ponse",
            "specification": "Sp\u00e9cification",
            "single_choice_description": "Le joueur peut fournir une seule r\u00e9ponse \u00e0 la question\/affectation. Il doit y avoir au moins une option.",
            "multiple_choice_description": "Le joueur peut fournir plusieurs r\u00e9ponses \u00e0 la question ou \u00e0 l'exercice. Il doit y avoir au moins 2 options.",
            "slider_description": "Pour un curseur, il y a une \u00e9valuation minimale et maximale. Le curseur a toujours un pas de 1. Plus la diff\u00e9rence est grande, plus l'utilisateur est en mesure de r\u00e9pondre avec pr\u00e9cision.",
            "statement_description": "Un joueur peut r\u00e9agir \u00e0 une d\u00e9claration. L'\u00e9valuation minimale signifie que le joueur est fortement en d\u00e9saccord, l'\u00e9valuation maximale signifie que le joueur est fortement d'accord. Plus la diff\u00e9rence est grande, plus la r\u00e9ponse de l'utilisateur est pr\u00e9cise.",
            "optional_description": "Si la question est marqu\u00e9e facultative, le joueur peut laisser la r\u00e9ponse vide.",
            "properties": {
                "minimal_valuation": "\u00c9valuation minimale",
                "maximal_valuation": "\u00c9valuation maximale",
                "min_text": "Valeur minimale",
                "max_text": "Valeur maximale"
            },
            "actions": {
                "create": {
                    "action": "Ajouter une entr\u00e9e d'enqu\u00eate",
                    "success": "Entr\u00e9e d'enqu\u00eate cr\u00e9\u00e9e",
                    "failed": "Impossible de cr\u00e9er l'entr\u00e9e de l'enqu\u00eate"
                },
                "update": {
                    "action": "Modifier l'entr\u00e9e d'enqu\u00eate",
                    "success": "Mise \u00e0 jour de l'entr\u00e9e d'enqu\u00eate",
                    "failed": "Impossible de mettre \u00e0 jour l'entr\u00e9e de l'enqu\u00eate"
                },
                "delete": {
                    "action": "Supprimer une entr\u00e9e d'enqu\u00eate",
                    "confirm": "Lorsque vous supprimez une entr\u00e9e d'enqu\u00eate, elle est imm\u00e9diatement supprim\u00e9e de l'enqu\u00eate. \u00cates-vous s\u00fbr de vouloir continuer ?",
                    "success": "Entr\u00e9e de l'enqu\u00eate supprim\u00e9e",
                    "failed": "Impossible de supprimer l'entr\u00e9e de l'enqu\u00eate"
                },
                "restore": {
                    "action": "Restaurer une entr\u00e9e d'enqu\u00eate",
                    "confirm": "Lorsque vous restaurez une entr\u00e9e d'enqu\u00eate, elle fera imm\u00e9diatement partie de l'enqu\u00eate. \u00cates-vous s\u00fbr de vouloir continuer ?",
                    "success": "Entr\u00e9e de l'enqu\u00eate restaur\u00e9e",
                    "failed": "Impossible de restaurer l'entr\u00e9e de l'enqu\u00eate"
                },
                "order": {
                    "success": "Mise \u00e0 jour de l'ordre des entr\u00e9es de l'enqu\u00eate",
                    "failed": "Impossible de mettre \u00e0 jour l'ordre des entr\u00e9es de l'enqu\u00eate"
                }
            }
        },
        "tag": {
            "tag": "\u00c9tiquette",
            "tags": "\u00c9tiquettes",
            "edit_tags": "Modifier \u00e9tiquettes",
            "select_placeholder": "S\u00e9lectionner la balise",
            "select_all": "Tout s\u00e9lectionner",
            "management": {
                "description": "Un tag peut \u00eatre ajout\u00e9 \u00e0 un utilisateur."
            },
            "properties": {
                "name": "Nom",
                "description": "La description"
            },
            "actions": {
                "create": {
                    "action": "Cr\u00e9er une balise",
                    "success": "Balise cr\u00e9\u00e9e",
                    "failed": "Impossible de cr\u00e9er la balise"
                },
                "update": {
                    "action": "Modifier la balise",
                    "success": "Balise mise \u00e0 jour",
                    "failed": "Impossible de mettre \u00e0 jour la balise"
                },
                "delete": {
                    "action": "Enlever l'\u00e9tiquette",
                    "confirm": "Lors de la suppression d'une balise, la balise est directement supprim\u00e9e pour tous les utilisateurs. Es-tu sur de vouloir continuer?",
                    "success": "Balise supprim\u00e9e",
                    "failed": "Impossible de supprimer la balise"
                },
                "restore": {
                    "action": "Restaurer la balise",
                    "confirm": "Lors de la restauration d'un balise, le balise est directement accessible. Es-tu sur de vouloir continuer?",
                    "success": "Balise restaur\u00e9e",
                    "failed": "Impossible de restaurer la balise"
                },
                "bulk": {
                    "action": "Des balises en masse",
                    "success_assign": "Balise attribu\u00e9e aux utilisateurs",
                    "success_revoke": "Balise retir\u00e9e des utilisateurs"
                }
            },
            "validations": {
                "not_owned": "Le balise n'appartient pas \u00e0 votre organisation"
            }
        },
        "theme": {
            "themes": "Th\u00e8mes",
            "manage": "G\u00e9rer",
            "manage_organisation_theme": "G\u00e9rer le th\u00e8me de l'organisation",
            "fonts": "Polices",
            "font_description": "Ceci donnera au th\u00e8me les polices pr\u00e9f\u00e9r\u00e9es du client.",
            "primary_font": "Police principale",
            "secondary_font": "Police secondaire",
            "colors": "Couleurs",
            "color_description": "Cette option donne au th\u00e8me les couleurs pr\u00e9f\u00e9r\u00e9es du client.",
            "primary_color": "Couleur primaire",
            "secondary_color": "Couleur secondaire",
            "accent_color": "Couleur d'accentuation",
            "card_style": "Style de carte",
            "card_style_description": "Cette option donne au th\u00e8me le style de carte pr\u00e9f\u00e9r\u00e9 du client.",
            "border_radius": "Rayon de la bordure",
            "edit_save_button": "Enregistrer les modifications"
        },
        "translation": {
            "translations": "Traductions",
            "translation": "Traduction",
            "properties": {
                "key": "Cl\u00e9 du syst\u00e8me",
                "message": "Texte"
            },
            "filter": {
                "all_locales": "Toutes les langues",
                "locale": "Langue"
            },
            "actions": {
                "update": {
                    "success": "Mise \u00e0 jour de la traduction",
                    "failed": "Impossible de mettre \u00e0 jour la traduction"
                }
            }
        },
        "user": {
            "user": "Utilisateur",
            "users": "Utilisateurs",
            "user_count": ":count utilisateur|:count utilisateurs",
            "demo_user": "Utilisateur d\u00e9mo",
            "demo_user_not_allowed": "Jouer en tant qu'utilisateur d\u00e9mo n'est pas activ\u00e9",
            "demo_user_not_possible": "Jouer en tant qu'utilisateur d\u00e9mo n'est pas possible pour le moment",
            "demo_user_notice": "Vous jouez en tant qu'utilisateur d\u00e9mo. Allez dans votre \"Compte\" pour modifier votre profil si vous souhaitez conserver votre progression.",
            "demo_user_notice_no_upgrade": "Vous jouez en tant qu'utilisateur d\u00e9mo. Demandez \u00e0 votre professeur de vous ouvrir un compte pour suivre vos progr\u00e8s.",
            "administrator": "Administrateur",
            "administrator_description": "An administrator is allowed to manage the whole app. Make sure you only assign this rights when required!",
            "manager": "Manager",
            "manager_description": "Un manager est autoris\u00e9 \u00e0 g\u00e9rer les utilisateurs de l'organisation.",
            "name": "Nom",
            "email": "Adresse e-mail",
            "password": "Mot de passe",
            "password_create": "Laissez le mot de passe vide pour en g\u00e9n\u00e9rer un automatiquement.",
            "password_edit": "Laissez le mot de passe vide pour ne pas le modifier.",
            "password_confirm": "Confirmer le mot de passe",
            "expires_at": "Expire \u00e0",
            "language": "Langue",
            "language_description": "Ajoutez vos langues et classez-les par pr\u00e9f\u00e9rence. Si une organisation \u00e0 laquelle vous appartenez ne prend en charge aucune de ces langues, le site sera affich\u00e9 dans la langue par d\u00e9faut de l'organisation.",
            "add_preferred_language": "Ajouter une langue pr\u00e9f\u00e9r\u00e9e",
            "tags": "\u00c9tiquettes",
            "permissions": "Permissions",
            "edit_user_roles": "Edit user roles",
            "select_placeholder": "S\u00e9lectionnez les utilisateurs",
            "is_manager": "Est gestionnaire",
            "is_administrator": "Est administrateur",
            "is_anonymous": "Est utilisateur d\u00e9mo",
            "added_at": "Ajout\u00e9 \u00e0",
            "modified_at": "Modifi\u00e9 \u00e0",
            "user_added": "Utilisateur ajout\u00e9",
            "last_modified": "Dernier modifi\u00e9",
            "unable_to_create": "Impossible de cr\u00e9er l'utilisateur",
            "unable_to_create_membership": "Impossible de cr\u00e9er l'adh\u00e9sion de l'utilisateur \u00e0 l'organisation",
            "invite_sent": "Invitation envoy\u00e9e",
            "unable_to_sent_invite": "Impossible d'envoyer l'invitation",
            "invite_sent_again": "Invitation envoy\u00e9e \u00e0 nouveau",
            "invite_accepted": "Invitation accept\u00e9e. Bienvenue dans l' :app",
            "invite_removed": "Invitation retir\u00e9e",
            "unable_to_remove_invite": "Impossible de supprimer l'invitation",
            "create": "Cr\u00e9ation d'un utilisateur",
            "created": "Utilisateur cr\u00e9\u00e9",
            "created_without_rights": "Utilisateur cr\u00e9\u00e9 mais incapable de d\u00e9finir les droits",
            "created_without_membership": "Utilisateur cr\u00e9\u00e9 mais incapable de rejoindre l'organisation actuelle",
            "created_with_password": "Utilisateur cr\u00e9\u00e9 avec le mot de passe <code>:password<\/code>.",
            "updated": "Utilisateur mis \u00e0 jour",
            "updated_without_rights": "Utilisateur mis \u00e0 jour mais impossible de mettre \u00e0 jour les droits",
            "unable_to_update": "Impossible de mettre \u00e0 jour l'utilisateur",
            "remove": "Supprimer l'utilisateur",
            "remove_confirmation": "L'utilisateur sera supprim\u00e9 de cette organisation et perdra imm\u00e9diatement son acc\u00e8s. Etes-vous s\u00fbr de vouloir continuer ?",
            "removed": "Utilisateur supprim\u00e9",
            "unable_to_remove": "Impossible de supprimer l'utilisateur",
            "invalid_email_address": "Adresse e-mail non valide",
            "invalid_password": "Le mot de passe ne correspond pas aux exigences",
            "invalid_language": "La langue n'est pas valide",
            "tag_does_not_exist": "La balise \":tag\" ne peut pas \u00eatre ajout\u00e9e car elle n'existe pas",
            "email_or_name_required": "Il faut au moins une adresse e-mail ou un nom",
            "invites": "Invitations",
            "invite": "Inviter",
            "accept_invite": "Accepter l'invitation",
            "accept_invite_description": "Pour terminer votre inscription, nous avons besoin de quelques informations suppl\u00e9mentaires.",
            "invalid_invite": "Invitation invalide",
            "invalid_invite_description": "D\u00e9sol\u00e9, mais le jeton n'est pas valide ou l'invitation a expir\u00e9. Demandez une nouvelle invitation \u00e0 votre instructeur.",
            "revoke_invite": "R\u00e9voquer l'invitation",
            "revoke_invite_description": "En r\u00e9voquant l'invitation, le destinataire n'est plus en mesure d'accepter l'invitation. \u00cates-vous s\u00fbr de vouloir r\u00e9voquer l'invitation ?",
            "send_invite": "Envoyer l'invitation",
            "invite_description": "L'adresse e-mail fournie recevra une invitation par courrier pour cette organisation.",
            "invite_email_exists": "L'adresse e-mail fournie ne doit pas d\u00e9j\u00e0 avoir un utilisateur existant.",
            "import": "Importer",
            "import_file": "Fichier source",
            "import_file_select": "S\u00e9lectionnez le fichier source",
            "import_file_description": "Le fichier doit \u00eatre un fichier CSV ou Excel et il n'est pas n\u00e9cessaire qu'il ait une structure sp\u00e9cifique. Dans les \u00e9tapes suivantes, vous pourrez d\u00e9terminer les colonnes.",
            "import_file_description_existing_user": "Lorsqu'un utilisateur poss\u00e8de d\u00e9j\u00e0 un compte pour l'application :app, le compte sera ajout\u00e9 \u00e0 cette organisation.",
            "import_users": "Importer des utilisateurs",
            "imported_users": "Utilisateurs import\u00e9s",
            "import_determine_columns": "D\u00e9terminer les colonnes",
            "import_results": "R\u00e9sultats",
            "import_select_file": "S\u00e9lectionner le fichier",
            "import_existing_user": "Utilisateur existant",
            "import_message": "Message",
            "import_column": "Colonne",
            "import_ignore_column": "Ignorer la colonne",
            "import_skip_first_row": "Sauter la premi\u00e8re ligne",
            "import_skip_first_row_description": "Useful when the first row contains a header.",
            "import_preview_stats": "There are <code>:rows<\/code> rows found and there are <code>:preview<\/code> rows shown as preview.",
            "user_profile": "Profil de l'utilisateur",
            "add_user": "Ajouter un utilisateur",
            "edit_user": "Modifier l'utilisateur",
            "user_role": "R\u00f4le d'utilisateur",
            "user_roles": "R\u00f4les d'utilisateur",
            "account_settings": "Account settings",
            "personal_details": "D\u00e9tails personnels",
            "phonenumber": "Num\u00e9ro de t\u00e9l\u00e9phone",
            "import_user_not_imported": "Utilisateur non import\u00e9",
            "import_user_imported_with_warnings": "Utilisateur import\u00e9 avec des avertissements",
            "import_user_imported": "Utilisateur import\u00e9",
            "import_only_existing_tags": "Seuls les <a href=\":manage_labels\">\u00e9tiquettes<\/a> existants seront ajout\u00e9s aux utilisateurs. Veuillez vous assurer que toutes les \u00e9tiquettes que vous souhaitez importer existent avant de proc\u00e9der \u00e0 l'importation.",
            "validations": {
                "must_be_part_of_organisation": "L'utilisateur doit \u00eatre membre de l'organisation",
                "must_not_be_part_of_organisation": "L'utilisateur ne doit pas \u00eatre membre de l'organisation"
            },
            "invitation": {
                "subject": "Votre invitation \u00e0 rejoindre l'application Fittar",
                "intro": "Rejoignez Fittar d\u00e8s aujourd'hui !",
                "text": "Nous sommes ravis de vous inviter \u00e0 vous inscrire \u00e0 l'application Fittar !Acceptez l'invitation, inscrivez-vous et commencez tout de suite.",
                "valid_until": "<b>Remarque:<\/b>  Cette invitation est valable jusqu'au :expires_at.",
                "tip": "<b>Astuce!<\/b> Pour une exp\u00e9rience de suivi optimale : Assurez-vous que votre t\u00e9l\u00e9phone est positionn\u00e9 aussi droit que possible. <a href=\"https:\/\/www.betaalbarehoesjes.nl\/standaard-speciaal-ontworpen-voor-fittar-zwart-cop.html\" target=\"_blank\">D\u00e9couvrez notre support t\u00e9l\u00e9phonique<\/a> recommand\u00e9 pour une meilleure exp\u00e9rience!",
                "need_help": "Besoin d'aide ?",
                "need_help_bullet_1": "Regardez notre <a href=\"https:\/\/www.youtube.com\/watch?v=tz0BEvsfbzM\" target=\"_blank\">vid\u00e9o explicative<\/a> pour une introduction rapide.",
                "need_help_bullet_2": "Visitez notre site web pour des <a href=\"https:\/\/fittar.eu\/user-tips\/\" target=\"_blank\">conseils d'utilisation<\/a> et une <a href=\"https:\/\/fittar.eu\/faq\/\" target=\"_blank\">FAQ<\/a>.",
                "need_help_bullet_3": "<a href=\"https:\/\/outlook.office.com\/bookwithme\/user\/7fccc4c542224f75813993b7b3da121e@fittar.eu\/meetingtype\/gIW6zZ-tkEWXBojJN8CY2g2?anonymous&ep=mCardFromTile\" target=\"_blank\">Demandez une d\u00e9monstration de 30 minutes.<\/a>.",
                "enjoy": "Nous avons h\u00e2te de vous accueillir chez Fittar!",
                "accept": "Accepter l'invitation",
                "copy_link": "Si vous rencontrez un probl\u00e8me avec le bouton, copiez le lien suivant dans un navigateur:"
            },
            "actions": {
                "delete": {
                    "action": "Supprimer le profil",
                    "confirm": "Lorsque vous supprimerez votre profil, vous ne pourrez plus jouer. Si vous vous \u00eates connect\u00e9 avec votre compte d'entreprise, la prochaine fois que vous vous connecterez, vous n'aurez plus aucune progression. Es-tu sur de vouloir continuer?",
                    "success": "Profil supprim\u00e9",
                    "failed": "Impossible de supprimer votre profil",
                    "warning": "La suppression de votre compte est irr\u00e9versible"
                }
            },
            "not_visible_by_demo_user": "Non visible pour les utilisateurs de d\u00e9monstration",
            "cannot_be_admin_because_sso": "Cet utilisateur a des identit\u00e9s SSO connect\u00e9es et ne peut pas \u00eatre administrateur pour des raisons de s\u00e9curit\u00e9.",
            "sso_user": "Utilisateur SSO",
            "password_change_not_possible": "Il n'est pas possible de modifier le mot de passe de cet utilisateur.",
            "roles_change_not_possible": "Il n'est pas possible de modifier les r\u00f4les de cet utilisateur."
        },
        "validation": {
            "accepted": "The :attribute must be accepted.",
            "accepted_if": "The :attribute must be accepted when :other is :value.",
            "active_url": "The :attribute is not a valid URL.",
            "after": "The :attribute must be a date after :date.",
            "after_or_equal": "The :attribute must be a date after or equal to :date.",
            "alpha": "The :attribute must only contain letters.",
            "alpha_dash": "The :attribute must only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The :attribute must only contain letters and numbers.",
            "array": "The :attribute must be an array.",
            "ascii": "Le champ :attribute ne doit contenir que des caract\u00e8res alphanum\u00e9riques et des symboles cod\u00e9s sur un octet.",
            "before": "The :attribute must be a date before :date.",
            "before_or_equal": "The :attribute must be a date before or equal to :date.",
            "between": {
                "numeric": "The :attribute must be between :min and :max.",
                "file": "The :attribute must be between :min and :max kilobytes.",
                "string": "The :attribute must be between :min and :max characters.",
                "array": "The :attribute must have between :min and :max items."
            },
            "boolean": "Le champ :attribute doit \u00eatre vrai ou faux.",
            "can": "Le champ :attribute contient une valeur non autoris\u00e9e.",
            "confirmed": "The :attribute confirmation does not match.",
            "current_password": "Le mot de passe est incorrect.",
            "date": "L'attribut :n'est pas une date valide.",
            "date_equals": "L'attribut :doit \u00eatre une date \u00e9gale \u00e0 :date.",
            "date_format": "L'attribut :ne correspond pas au format :format.",
            "decimal": "Le champ :attribute doit comporter :decimal d\u00e9cimales.",
            "declined": "L'attribut :doit \u00eatre refus\u00e9.",
            "declined_if": "L'attribut :attribute doit \u00eatre refus\u00e9 lorsque :other est :value.",
            "different": "L'attribut :et :other doivent \u00eatre diff\u00e9rents.",
            "digits": "L'attribut :doit \u00eatre :digits digits.",
            "digits_between": "L'attribut :doit \u00eatre compris entre :min et :max chiffres.",
            "dimensions": "Les dimensions de l'image de l'attribut :attribute ne sont pas valides.",
            "distinct": "Le champ :attribute a une valeur en double.",
            "doesnt_end_with": "Le champ :attribute ne doit pas finir avec une des valeurs suivantes : :values.",
            "doesnt_start_with": "Le champ :attribute ne doit pas commencer avec une des valeurs suivantes : :values.",
            "email": "L'attribut :doit \u00eatre une adresse \u00e9lectronique valide.",
            "ends_with": "L'attribut :doit se terminer par l'un des \u00e9l\u00e9ments suivants : :values.",
            "enum": "L'attribut :s\u00e9lectionn\u00e9 n'est pas valide.",
            "exists": "L'attribut :s\u00e9lectionn\u00e9 n'est pas valide.",
            "file": "L'attribut :doit \u00eatre un fichier.",
            "filled": "Le champ :attribute doit avoir une valeur.",
            "gt": {
                "numeric": "L'attribut :doit \u00eatre sup\u00e9rieur \u00e0 :value.",
                "file": "La valeur de l'attribut :attribute doit \u00eatre sup\u00e9rieure \u00e0 celle de :value (kilo-octets).",
                "string": "La valeur de l'attribut :attribute doit \u00eatre sup\u00e9rieure \u00e0 celle de :value (caract\u00e8res).",
                "array": "La valeur de l'attribut :attribute doit \u00eatre sup\u00e9rieure \u00e0 :value items."
            },
            "gte": {
                "numeric": "L'attribut :attribute doit \u00eatre sup\u00e9rieur ou \u00e9gal \u00e0 :value.",
                "file": "L'attribut :doit \u00eatre sup\u00e9rieur ou \u00e9gal \u00e0 :value kilo-octets.",
                "string": "L'attribut :doit avoir une valeur sup\u00e9rieure ou \u00e9gale \u00e0 :value caract\u00e8res.",
                "array": "La valeur de l'attribut :attribute doit \u00eatre sup\u00e9rieure ou \u00e9gale \u00e0 :value items."
            },
            "image": "L'attribut :value doit \u00eatre une image.",
            "in": "L'attribut :s\u00e9lectionn\u00e9 n'est pas valide.",
            "in_array": "Le champ :attribute n'existe pas dans :other.",
            "integer": "L'attribut :attribute doit \u00eatre un nombre entier.",
            "ip": "L'attribut :doit \u00eatre une adresse IP valide.",
            "ipv4": "L'attribut :doit \u00eatre une adresse IPv4 valide.",
            "ipv6": "L'attribut :doit \u00eatre une adresse IPv6 valide.",
            "mac_address": "L'attribut :doit \u00eatre une adresse MAC valide.",
            "json": "L'attribut :doit \u00eatre une cha\u00eene JSON valide.",
            "lowercase": "Le champ :attribute doit \u00eatre en minuscules.",
            "lt": {
                "numeric": "L'attribut :doit \u00eatre inf\u00e9rieur \u00e0 :value.",
                "file": "L'attribut :attribute doit \u00eatre inf\u00e9rieur \u00e0 :value kilobytes.",
                "string": "L'attribut :doit avoir moins de caract\u00e8res que :value.",
                "array": "L'attribut :doit avoir moins de :value items."
            },
            "lte": {
                "numeric": "La valeur de l'attribut :attribute doit \u00eatre inf\u00e9rieure ou \u00e9gale \u00e0 :value.",
                "file": "L'attribut :doit \u00eatre inf\u00e9rieur ou \u00e9gal \u00e0 :value kilo-octets.",
                "string": "L'attribut :value doit \u00eatre inf\u00e9rieur ou \u00e9gal \u00e0 :value caract\u00e8res.",
                "array": "L'attribut :ne doit pas comporter plus d'\u00e9l\u00e9ments que :value."
            },
            "max": {
                "numeric": "L'attribut :ne doit pas \u00eatre sup\u00e9rieur \u00e0 :max.",
                "file": "L'attribut :ne doit pas \u00eatre sup\u00e9rieur \u00e0 :max kilo-octets.",
                "string": "L'attribut :ne doit pas \u00eatre sup\u00e9rieur \u00e0 :max caract\u00e8res.",
                "array": "L'attribut :ne doit pas comporter plus de :max \u00e9l\u00e9ments."
            },
            "max_digits": "Le champ :attribute ne doit pas avoir plus de :max chiffres.",
            "mimes": "L'attribut :doit \u00eatre un fichier de type : :values.",
            "mimetypes": "L'attribut :doit \u00eatre un fichier de type :values.",
            "min": {
                "numeric": "L'attribut :doit \u00eatre au moins \u00e9gal \u00e0 :min.",
                "file": "L'attribut :doit avoir une taille minimale de :min kilo-octets.",
                "string": "L'attribut :doit avoir au moins :min caract\u00e8res.",
                "array": "L'attribut :doit avoir au moins :min items."
            },
            "min_digits": "Le champ :attribute doit avoir au moins :min chiffres.",
            "multiple_of": "L'attribut :doit \u00eatre un multiple de :value.",
            "missing": "Le champ :attribute doit \u00eatre manquant.",
            "missing_if": "Le champ :attribute doit \u00eatre manquant quand :other a la valeur :value.",
            "missing_unless": "Le champ :attribute doit \u00eatre manquant sauf si :other a la valeur :value.",
            "missing_with": "Le champ :attribute doit \u00eatre manquant quand :values est pr\u00e9sent.",
            "missing_with_all": "Le champ :attribute doit \u00eatre manquant quand :values sont pr\u00e9sents.",
            "not_in": "L'attribut :s\u00e9lectionn\u00e9 n'est pas valide.",
            "not_regex": "Le format de l':attribute n'est pas valide.",
            "numeric": "L'attribut :doit \u00eatre un nombre.",
            "password": {
                "letters": "Le champ :attribute doit contenir au moins une lettre.",
                "mixed": "Le champ :attribute doit contenir au moins une majuscule et une minuscule.",
                "numbers": "Le champ :attribute doit contenir au moins un chiffre.",
                "symbols": "Le champ :attribute doit contenir au moins un symbole.",
                "uncompromised": "La valeur du champ :attribute est apparue dans une fuite de donn\u00e9es. Veuillez choisir une valeur diff\u00e9rente."
            },
            "present": "Le champ :attribute doit \u00eatre pr\u00e9sent.",
            "prohibited": "Le champ :attribute est interdit.",
            "prohibited_if": "Le champ :attribute est interdit lorsque :other est :value.",
            "prohibited_unless": "Le champ :attribute est interdit \u00e0 moins que :other ne soit dans :values.",
            "prohibits": "Le champ :attribute interdit la pr\u00e9sence de :other.",
            "regex": "Le format de l'attribut :attribute n'est pas valide.",
            "required": "Le champ :attribute est obligatoire.",
            "required_array_keys": ":Attribut doit contenir des valeurs pour :values.",
            "required_field": "Ce champ est obligatoire.",
            "required_if": "Le champ :attribute est obligatoire lorsque :other est :value.",
            "required_if_accepted": "Le champ :attribute est obligatoire quand le champ :other a \u00e9t\u00e9 accept\u00e9.",
            "required_unless": "Le champ :attribute est obligatoire sauf si :other est dans :values.",
            "required_with": "Le champ :attribute est obligatoire lorsque :values est pr\u00e9sent.",
            "required_with_all": "Le champ :attribute est obligatoire lorsque :values est pr\u00e9sent.",
            "required_without": "Le champ :attribute est obligatoire lorsque :values n'est pas pr\u00e9sent.",
            "required_without_all": "Le champ :attribute est obligatoire si aucune des valeurs :values n'est pr\u00e9sente.",
            "rgba_color": "Le champ :attribute doit contenir une couleur Rgba valide",
            "rgba_color_white": "Le champ :attribute ne peut pas \u00eatre blanc",
            "same": "Les champs :attribute et :other doivent correspondre.",
            "size": {
                "numeric": "L'attribut :attribute doit \u00eatre :size.",
                "file": "L'attribut :attribute doit \u00eatre :size kilobytes.",
                "string": "L'attribut :attribute doit \u00eatre :size characters.",
                "array": "L'attribut :doit contenir des \u00e9l\u00e9ments :size."
            },
            "starts_with": "L'attribut :doit commencer par l'un des \u00e9l\u00e9ments suivants : :values.",
            "string": "L'attribut :doit \u00eatre une cha\u00eene de caract\u00e8res.",
            "timezone": "L'attribut :doit \u00eatre un fuseau horaire valide.",
            "unique": "L'attribut :a d\u00e9j\u00e0 \u00e9t\u00e9 utilis\u00e9.",
            "uploaded": "Le t\u00e9l\u00e9chargement de l'attribut :a \u00e9chou\u00e9.",
            "ulid": "Le champ :attribute doit \u00eatre un ULID valide.",
            "uppercase": "Le champ :attribute doit \u00eatre en majuscules.",
            "url": "L'attribut :doit \u00eatre une URL valide.",
            "uuid": "L'attribut :doit \u00eatre un UUID valide.",
            "youtube_video_url": "L'attribut :doit contenir l'URL d'une vid\u00e9o YouTube valide.",
            "vimeo_video_url": "L'attribut :doit contenir l'URL d'une vid\u00e9o Vimeo valide.",
            "custom": {
                "attribute-name": {
                    "rule-name": "message personnalis\u00e9"
                }
            },
            "attributes": {
                "primary_color": "Couleur primaire",
                "secondary_color": "Couleur secondaire",
                "primary_font_color": "Couleur de police principale",
                "secondary_font_color": "Couleur de police secondaire",
                "primary_font_family": "Famille de police principale",
                "secondary_font_family": "Famille de police secondaire",
                "available_languages": "Langues disponibles",
                "is_global": "Est global",
                "organisations": "Organisations",
                "start_date": "Date de d\u00e9but",
                "end_date": "Date de fin",
                "confirm": "Confirmer",
                "total_questions_used": "Nombre de questions utilis\u00e9es",
                "file": "Fichier"
            }
        },
        "webhook": {
            "webhooks": "Webhooks",
            "trigger": "D\u00e9clencher un webhook",
            "description": "Envoyer des webhooks pour les \u00e9v\u00e9nements pass\u00e9s.",
            "events": "\u00c9v\u00e9nements",
            "select": {
                "organisation": "S\u00e9lectionnez une organisation",
                "event": "S\u00e9lectionnez un \u00e9v\u00e9nement"
            },
            "properties": {
                "start_date": "Date de d\u00e9but",
                "end_date": "Date de fin"
            },
            "events_sent_successfully": "Les \u00e9v\u00e9nements Webhook envoy\u00e9s entre :startDate et :endDate sont \u00e0 nouveau envoy\u00e9s",
            "amount_of_calls": "Nombre d'appels webhook"
        }
    },
    "nl": {
        "achievement": {
            "achievement": "Achievement",
            "achievements": "Achievements",
            "overview_description": "Overzicht van alle beschikbare achievements of all available achievements",
            "select_campaign": "Selecteer campagne",
            "go_to_achievements": "Ga naar achievements",
            "properties": {
                "name": "Naam",
                "once": "Eenmalig",
                "score": "Score",
                "award": "Bonus"
            },
            "time": {
                "today": "vandaag",
                "yesterday": "gisteren",
                "two_days_ago": "eergisteren",
                "this_week": "deze week",
                "last_week": "vorige week",
                "two_weeks_ago": "twee weken geleden",
                "three_weeks_ago": "drie weken geleden",
                "four_weeks_ago": "vier weken geleden",
                "five_weeks_ago": "vijf weken geleden"
            },
            "status": {
                "status": "Status",
                "playing": "Lopend",
                "completed": "Behaald",
                "not_completed": "Verzamel alle achievements!",
                "last_achievement": "Laatste achievement",
                "no_last_achievement": "U heeft nog geen achievement gehaald"
            },
            "actions": {
                "grant": {
                    "failed": "Het is niet gelukt om de achievement uit te reiken"
                }
            },
            "validations": {
                "not_found": "Achievement niet gevonden"
            }
        },
        "answer": {
            "answer": "Antwoord",
            "answers": "Antwoorden",
            "properties": {
                "correct": "Correct",
                "correct_answer": "Correct antwoord",
                "correct_answers": "Correcte antwoorden",
                "correct_answer_description": "Dit is het correcte antwoord op de vraag",
                "possible_answers": "Mogelijke antwoorden",
                "provided_answer": "Gegeven antwoord"
            },
            "actions": {
                "create": {
                    "action": "Antwoord toevoegen",
                    "success": "Antwoord toegevoegd",
                    "failed": "Kan het antwoord niet toevoegen"
                },
                "update": {
                    "action": "Antwoord wijzigen",
                    "success": "Antwoord gewijzigd",
                    "failed": "Kan het antwoord niet wijzigen"
                },
                "delete": {
                    "action": "Antwoord verwijderen",
                    "confirm": "Wanneer je het antwoord verwijderd, zal deze niet meer worden gegeven bij de vraag. Weet je zeker dat je het antwoord wilt verwijderen?",
                    "success": "Antwoord verwijderd",
                    "failed": "Kan het antwoord niet verwijderen"
                },
                "restore": {
                    "action": "Antwoord herstellen",
                    "confirm": "Wanneer u het antwoord herstelt, zal het antwoord onmiddellijk zichtbaar zijn. Weet u zeker dat u door wilt gaan?",
                    "success": "Antwoord hersteld",
                    "failed": "Kan het antwoord niet herstellen"
                }
            },
            "validations": {
                "invalid_answer_provided": "Ongeldig antwoord gegeven"
            }
        },
        "api_token": {
            "api_tokens": "API tokens",
            "api_token": "API token",
            "overview_description": "Beheer de API tokens van verbonden applicaties",
            "not_expiring": "Geen vervaldatum",
            "none_assigned": "Er zijn geen toegewezen API-tokens.",
            "properties": {
                "name": "Naam",
                "expires_at": "Vervalt op",
                "created_by": "Gemaakt door",
                "is_global": "Globaal token",
                "is_global_description": "Een globaal token kan worden gebruikt om toegang te krijgen tot de data van alle organisaties.",
                "organisations": "Organisaties"
            },
            "actions": {
                "create": {
                    "success": "API token toegevoegd",
                    "failed": "Kan de API token niet toevoegen"
                },
                "update": {
                    "action": "Wijzig API token",
                    "success": "API token gewijzigd",
                    "failed": "Kan de API token niet wijzigen"
                },
                "delete": {
                    "action": "API token verwijderen",
                    "confirm": "Wanneer de API token wordt verwijderd zal de app die deze API token gebruikt direct toegang verliezen. Weet je zeker dat je de API token wilt verwijderen?",
                    "success": "API token verwijderd",
                    "failed": "Kan de API token niet verwijderen"
                },
                "show": {
                    "failed": "Kan de API token niet tonen"
                },
                "generate": {
                    "failed": "Kan de API token niet genereren"
                },
                "sync": {
                    "action": "Wijzig organisaties",
                    "success": "Organisaties van de API token gewijzigd",
                    "is_global": "Organisaties van een globaal API-token kunnen niet worden gewijzigd"
                }
            }
        },
        "app_score": {
            "actions": {
                "create": {
                    "failed": "Kan de app score niet bijwerken"
                }
            },
            "scores_filled_in": "beide scores zijn al ingevuld",
            "score": "SCORE",
            "finished": {
                "start_again": "Opnieuw beginnen",
                "finish": "Afronden",
                "score_achieved": "Score behaald",
                "text": "Uitmuntende inspanning! Ben je klaar voor de volgende training of wil je je score overtreffen?"
            },
            "battle": {
                "try_again": "Probeer het nog eens",
                "submit_your_score": "Dien uw score in",
                "submit_and_see_who_won": "Dien in en kijk wie er heeft gewonnen",
                "text": "Uitzonderlijke inspanning! Soumettez votre score et voyez qui a gagn\u00e9!"
            }
        },
        "auth": {
            "email": "E-mail adres",
            "password_field": "Wachtwoord",
            "register": {
                "register": "Registreren",
                "description": "Maak een account voor :app. Door het aanmaken van een account zal je voortgang worden bewaard en overal beschikbaar zijn.",
                "no_account": "Geen account?",
                "no_account_description": "Wanneer je nog geen account hebt, klik op deze <a href=\":link\">link<\/a>.",
                "already_has_account": "Heb je al een account?",
                "not_allowed": "Registratie niet toegestaan",
                "not_allowed_description": "Sorry, maar deze organisatie heeft de registratie uitgeschakeld. Vraag je instructeur om een uitnodiging.",
                "register_not_allowed": "Registreren niet toegestaan",
                "register_not_allowed_description": "Sorry, maar deze organisation heeft registreren uitgezet. Vraag je instructeur om een uitnodiging."
            },
            "phonenumber_field": "Telefoonnummer",
            "reseller": {
                "not_allowed": "Organisatie is geen reseller",
                "not_allowed_description": "Sorry, maar deze organisatie is geen reseller. Neem contact op met je accountmanager voor reseller toegang."
            },
            "demo": {
                "play": "Speel als demo-gebruiker",
                "description": "In plaats van je te registreren, kun je ook als demo-gebruiker spelen. De voortgang wordt bijgehouden, maar op andere apparaten of wanneer u uw browsergeschiedenis wist, raakt u uw voortgang kwijt. Als je als demo-gebruiker speelt, kun je nog steeds je account opslaan.",
                "description_no_registration": "In plaats van je te registreren, kun je ook als demo-gebruiker spelen. De voortgang wordt bijgehouden, maar op andere apparaten of wanneer u uw browsergeschiedenis wist, raakt u uw voortgang kwijt."
            },
            "login": {
                "login": "Inloggen",
                "remember_me": "Onthouden",
                "required": "Je moet ingelogd zijn om deze actie te kunnen uitvoeren"
            },
            "logout": {
                "logout": "Uitloggen"
            },
            "forgotten": {
                "password_instructions": "Vul de gegevens in om je wachtwoord te wijzigen.",
                "change_password": "Wijzig wachtwoord",
                "reset_link_sent": "Wanneer je e-mail adres is gevonden zal je hierop instructies ontvangen. Controleer je e-mail en klik op de link in de e-mail om je wachtwoord te wijzigen.",
                "reset_link_not_sent": "Helaas is het niet gelukt om de e-mail met instructies te versturen. Neem contact op met je instructeur voor hulp.",
                "send_instructions": "Stuur instructies",
                "confirm_password": "Bevestig wachtwoord",
                "confirm_password_description": "Bevestig je wachtwoord om door te gaan.",
                "forgot_password": "Wachtwoord vergeten",
                "forgot_password_description": "Wanneer je je wachtwoord bent vergeten, vul dan hier je e-mail adres in. Daarna ontvang je een e-mail met instructies hoe je je wachtwoord kunt veranderen.",
                "forgot_your_password": "Wachtwoord vergeten?",
                "check_spam_folder": "Als je de e-mail niet binnen een paar minuten ziet, controleer dan de map \"ongewenste e-mail\" of \"spam\"."
            },
            "verify": {
                "verify": "Bevestig je e-mail adres",
                "click_below": "Klik op de onderstaande knop om je e-mailadres te verifi\u00ebren.",
                "check_email": "Er is een verificatielink naar uw e-mailadres gestuurd met een link om uw registratie te voltooien.",
                "resent": "Een nieuwe verificatie link is verstuurd naar je e-mail adres.",
                "before": "Voordat je verder gaat, check je e-mail om je account te bevestigen.",
                "not_received": "Wanneer je geen e-mail hebt ontvangen",
                "request": "klik hier om de e-mail nogmaals te verzenden",
                "not_requested": "Als u geen account heeft aangemaakt, hoeft u verder niets te doen."
            },
            "account_exists": {
                "exists": "Je hebt je geprobeerd te registeren maar je hebt al een account.",
                "forgot_password": "Als je je wachtwoord bent vergeten, kun je deze opnieuw instellen via \"Wachtwoord vergeten\"."
            },
            "device_flow": {
                "start": {
                    "failed": "Het is niet gelukt de apparaat login procedure te starten"
                },
                "invalid": {
                    "title": "Aanvraag ongeldig",
                    "description": "De aanvraag is ongeldig. Scan de QR-code of gebruik de juiste link om de login procedure te starten"
                },
                "expired": {
                    "title": "Aanvraag verlopen",
                    "description": "De aanvraag is beperkt geldig en is nu verlopen. Start de aanvraag opnieuw."
                },
                "organisations": {
                    "select": "Selecteer organisatie",
                    "none": "Dit account is geen lid van een organisatie. Vraag je instructeur om je toe te voegen aan de organisatie."
                },
                "finish": {
                    "title": "Ingelogd",
                    "description": "Je bent nu ingelogd en kan verder spelen op het andere apparaat"
                },
                "no_organisations": {
                    "title": "Geen organisaties beschikbaar",
                    "description": "De applicatie waar je mee inlogt heeft geen toegang tot organisaties waar jij toegang toe hebt."
                }
            },
            "delete": {
                "verify": "Bevestig account verwijdering",
                "click_below": "Klik op de onderstaande knop om te bevestigen dat je je account wilt verwijderen.",
                "not_requested": "Als je geen account verwijdering hebt aangevraagd, hoef je verder niets te doen.",
                "mail_sent": "Als dit e-mailadres bestaat, ontvangt u een e-mail. Klik op de link in de e-mail om te bevestigen dat u uw account wilt verwijderen.",
                "confirm": "Ik weet wat de gevolgen zijn, en ik weet zeker dat ik mijn account wil verwijderen"
            },
            "sso": {
                "generic": "Sorry, er is iets misgegaan bij het inloggen met single sign-on. Probeer het opnieuw.",
                "no_id": ":configuration: geen unieke identifier verstrekt door provider.",
                "no_email": ":configuration: geen e-mailadres verstrekt door provider.",
                "prohibited": "Inloggen via SSO is verboden voor deze gebruiker.",
                "not_a_member": "Je moet zijn uitgenodigd voor deze organisatie voordat je kunt inloggen.",
                "user_data_request_error": ":configuration: provider reageerde met foutcode :code. Probeer het opnieuw en neem contact op met support als de fout zich blijft voordoen."
            },
            "failed": "Deze combinatie van e-mailadres en wachtwoord is niet geldig.",
            "password": "Het opgegeven wachtwoord is onjuist.",
            "throttle": "Te veel mislukte aanmeldpogingen. Probeer het over nog eens over :seconds seconden.",
            "pending_invitation": "Accepteer je uitnodiging voordat je inlogt.",
            "get_mobile_app": {
                "title": "Installeer de mobiele app",
                "description": "Installeer onze mobiele app voor een betere ervaring.",
                "download_app_store": "Download in de App Store",
                "download_play_store": "Ontdek het op Google Play"
            }
        },
        "battle": {
            "battle": "Battle",
            "battles": "Battles",
            "battle_leaderboard": "Battle scorebord",
            "battle_arena": "Battle Arena",
            "properties": {
                "name": "Naam",
                "description": "Omschrijving",
                "win_score": "Winst bonus (50% bij verlies)",
                "score_factor": "Score factor bij winst op hoger gerankte speler",
                "response_time": "Reactietijd",
                "daily_limit": "Daglimiet",
                "available": "Beschikbaar",
                "available_from": "Beschikbaar vanaf",
                "available_till": "Beschikbaar tot",
                "no_limit": "Geen limiet",
                "hours": "uur",
                "simultaneous_open_sessions": "Gelijktijdig open sessies",
                "simultaneous_open_sessions_unlimited": "Onbeperkt"
            },
            "insights": {
                "wins": "Gewonnen",
                "count_completed_sessions": "# voltooide sessies",
                "count_unaccepted_sessions": "# niet geaccepteerde sessies",
                "average_score": "Gemiddelde score",
                "count_unique_initiators": "# unieke uitdagers",
                "count_unique_opponents": "# unieke tegenstanders",
                "percentage_of_sessions_where_opponent_wins": "% van de voltooide sessies waarin de tegenstander won",
                "average_time_to_complete_micro_game": "Gemiddelde tijd om micro game te voltooien",
                "average_time_to_accept_invitation": "Gemiddelde tijd dat een uitnodiging open staat",
                "average_time_to_complete_session": "Gemiddelde tijd voor een sessie om voltooid te worden"
            },
            "actions": {
                "create": {
                    "action": "Battle toevoegen",
                    "success": "Battle toegevoegd",
                    "failed": "Kan de battle niet toevoegen"
                },
                "update": {
                    "action": "Battle wijzigen",
                    "success": "Battle gewijzigd",
                    "failed": "Kan de battle niet wijzigen"
                },
                "delete": {
                    "action": "Battle verwijderen",
                    "confirm": "Wanneer een battle wordt verwijderd, is deze direct niet meer toegankelijk voor de spelers. Weet je zeker dat je deze battle wilt verwijderen?",
                    "success": "Battle verwijderd",
                    "failed": "Kan de battle niet verwijderen"
                },
                "stop": {
                    "action": "Battle stoppen",
                    "confirm": "Wanneer een battle wordt gestopt, is deze direct niet meer toegankelijk voor de spelers. Weet je zeker dat je deze battle wilt stoppen?",
                    "success": "Battle gestopt",
                    "failed": "Kan de battle niet stoppen"
                }
            },
            "filter": {
                "select_campaign": "Selecteer campagne"
            },
            "validations": {
                "not_owned": "De battle is niet van de huidige organisatie",
                "already_played": "Deze battle is al gespeeld door sommige gebruikers.",
                "overlaps": "Battle kan niet overlappen met andere battles.",
                "no_micro_games": "Deze campagne heeft geen micro game modules.",
                "outside_tournament": "Deze waarde ligt buiten de tijden van het toernooi."
            },
            "session": {
                "sessions": "Sessies",
                "date": "Datum",
                "initiator": "Uitdager",
                "opponent": "Tegenstander",
                "bonus": "Bonus",
                "not_found": "Battle sessie niet gevonden"
            },
            "profile": {
                "select_friend_to_challenge": "Selecteer vriend om uit te dagen",
                "text": "Selecteer de gebruiker die je wilt uitdagen voor deze game",
                "battle_against_friends": "Strijd Tegen Vrienden"
            },
            "score": {
                "text": "Uitstekende inspanning! Geef je score door en kijk wie er heeft gewonnen!"
            },
            "picked_randomly": "willekeurig gekozen",
            "pick_random_microgame": "Kies een willekeurige micro game uit de campagne",
            "expired": "Battle is verlopen",
            "not_found": "Battle niet gevonden",
            "no_active": "Er is op dit moment geen actieve battle.",
            "not_allowed": "Je mag niet nog een battle starten vandaag probeer het morgen nog een keer",
            "did_not_lose": "Je kan geen revanche nemen als je niet hebt verloren.",
            "already_completed": "Je hebt deze battle al gespeeld.",
            "win": "gewonnen",
            "wins": ":count gewonnen",
            "challenge": "Uitdagen",
            "revanche": "Revanche",
            "challenges_you": ":name daagt je uit",
            "start": "Start battle",
            "battle_masters": "Battle masters",
            "battle_masters_popup": "Kies een tegenstander",
            "search_opponent": "Tegenstander opzoeken",
            "challengers": "Uitdagers",
            "yourself": "Je kan jezelf niet uitdagen",
            "wait_for_initiator": "Wacht tot er een score is gezet door de uitdager",
            "no_invitations": "Je bent nog niet uitgedaagd door een medespeler.",
            "no_history": "Je hebt nog geen battles gespeeld.",
            "too_many": "Je hebt al te veel actieve battles.",
            "campaign_is_tournament": "Deze campagne is in toernooimodus en kan alleen gespeeld worden tussen :dates. De battle moet ook binnen dat tijdsbestek plaatsvinden.",
            "game_anonymous": "Campagne is alleen toegankelijk voor anonieme gebruikers",
            "summary": {
                "header": {
                    "winner": "Winnaar",
                    "loser": "Verloren",
                    "tied": "Gelijkspel"
                },
                "text": {
                    "score": "Uitslag"
                },
                "battle_score": "Battle score",
                "score": {
                    "win": "Battle gewonnen",
                    "lost": "Battle verloren",
                    "tied": "Battle gelijkspel"
                },
                "earned": "Totaal verdiend",
                "waiting_for_the_opponent": "Wachten op de tegenstander",
                "battle_again": "Opnieuw strijden"
            }
        },
        "battleground": {
            "battleground": "Battleground",
            "challenges": "Uitdagingen",
            "start_new_battle": "Start nieuwe gevecht",
            "active_battles": "Actieve Battles",
            "past_battles": "Verleden Battles",
            "you_won": "Jij hebt gewonnen",
            "you_lost": "Jij hebt verloren",
            "tied": "Gelijk",
            "no_active_battles": "Geen actieve gevechten",
            "no_past_battles": "Geen vorige gevechten",
            "text": "Om gevechten te starten, ga naar het detailscherm van games of uitdagingen en begin een gevecht met je vrienden.",
            "text_down": "Hier kun je de voortgang van de strijd volgen",
            "waiting_for_opponent": "Wachten op tegenstander",
            "waiting_for_you": "Ik wacht op jou",
            "challenged_by": "Uitgedaagd door",
            "challenged": "Uitgedaagd",
            "hours_left": "uur over",
            "you": "Jij"
        },
        "campaign": {
            "campaign": "Programma",
            "campaigns": "Programma's",
            "programs": "Programma's",
            "program": "Programma",
            "new_campaign": "Nieuwe programma",
            "view_campaign": "Programma bekijken",
            "management": {
                "description": "Een programma bestaat uit een verzameling van challenges en is te vergelijken met een boek waarbij de challenges de hoofdstukken zijn."
            },
            "insights": "Inzichten",
            "to_campaign": "Naar programma",
            "already_played": "Deze programma is al gespeeld door :amount spelers. Het wijzigen van deze programma heeft gevolgen voor de voortgang van de spelers.",
            "transfer_requests": "Kopieerverzoeken",
            "copy_title": "Kopieer programma",
            "copy": "Kopieer programma naar andere organisatie",
            "copy_button": "Kopieerverzoek versturen",
            "copy_description": "De ontvangende organisatie zal een verzoek ontvangen om de programma te kopi\u00ebren. Wanneer deze het verzoek hebben geaccepteerd, zal de programma worden gekopieerd.",
            "copyable_campaigns": "Kopieerbare programmas",
            "copy_howto": "Om een programma te kopi\u00ebren, ga naar het programma overzicht en klik op het kopieer icoon naast de programma.",
            "copy_accept": "Kopieer de programma",
            "copy_accept_confirmation": "Kopieer de programma naar jouw organisatie. Na het kopi\u00ebren kan je de programmas aanpassen naar jouw wensen. Weet je zeker dat je de programma wilt kopi\u00ebren?",
            "copy_deny": "Verwijder verzoek",
            "copy_deny_confirmation": "Verwijder het verzoek om de programma te kopi\u00ebren. Na het verwijderen van het verzoek is het niet langer mogelijk om de programma te kopi\u00ebren naar jouw organisatie. Weet je zeker dat je dit verzoek wilt verwijderen?",
            "duplicate": "Dupliceer programma binnen eigen organisatie",
            "duplicate_button": "Dupliceer programma",
            "duplicate_description": "De programma met alle onderliggende challenges en modules zal binnen je eigen organisatie gedupliceerd worden.",
            "outgoing_requests": "Kopieerverzoeken",
            "copy_revoke": "Trek kopieerverzoek in",
            "copy_revoke_description": "Wanneer je het kopieerverzoek intrekt, zal de ontvangende organisatie niet langer in staat zijn om de programma te kopi\u00ebren. Weet je zeker dat je dit verzoek wilt intrekken?",
            "copy_to_subdomain_description": "Vul het subdomein van de organisatie in waar de programma naar gekopieerd mag worden.",
            "leaderboard": "Scorebord",
            "no_player": "Geen speler",
            "completed": "Voltooid!",
            "percentage_completed": "van de programma voltooid",
            "progress": "Voortgang",
            "available_modules": "Beschikbaar",
            "completed_modules": "Voltooid",
            "stars": "Sterren",
            "battle_xp": "Battle :xp",
            "total_xp": "Totaal :xp",
            "status": {
                "scheduled": "Gepland",
                "in_progress": "Lopend",
                "done": "Be\u00ebindigd",
                "archived": "Gearchiveerd"
            },
            "properties": {
                "name": "Naam",
                "title": "Titel",
                "finished_by": "Be\u00ebindigd door",
                "finish_date": "Einddatum",
                "run_time": "Looptijd",
                "description": "Omschrijving",
                "image": "Afbeelding",
                "image_select": "Selecteer afbeelding",
                "icon": "Icoon",
                "icon_select": "Selecteer icoon",
                "score": "Score",
                "bonus": "Bonus",
                "modules_completed": "modules voltooid",
                "owned_by": "Eigenaar",
                "shared_with": "Gedeeld met",
                "hide_leaderboard": "Verberg scorebord",
                "access": "Toegang",
                "access_tags": "Enkel gebruikers met een tag",
                "access_tags_placeholder": "Alle geregistreerde gebruikers",
                "tournament": "Toernooi",
                "enable_tournament": "Toernooimodus inschakelen",
                "tournament_start_at": "Toernooi begint op",
                "tournament_duration": "Toernooiduur",
                "tournament_status": "Toernooi status",
                "tournament_end_at": "Toernooi eindigt op",
                "leagues": "Leagues",
                "leagues_description": "Wanneer leagues zijn ingeschakeld, zal het leaderboard gebaseerd zijn op poules met promotie en degradatie.",
                "league_enabled": "Leagues aanzetten",
                "league_ideal_poule_size": "Ideale poule grootte",
                "league_switch_day": "Weekdag",
                "league_switch_time": "Tijd",
                "league_promote_from_bronze": "Promoveert van Brons naar Zilver",
                "league_relegate_from_silver": "Degradeert van Zilver naar Brons",
                "league_promote_from_silver": "Promoveert van Zilver naar Goud",
                "league_relegate_from_gold": "Degradeert van Goud naar Zilver"
            },
            "access_options": {
                "all": "Iedereen",
                "anonymous": "Anonieme gebruikers",
                "registered": "Geregistreerde gebruikers"
            },
            "actions": {
                "create": {
                    "action": "Programma toevoegen",
                    "success": "Programma toegevoegd",
                    "failed": "Kan de programma niet toevoegen"
                },
                "update": {
                    "action": "Programma wijzigen",
                    "success": "Programma gewijzigd",
                    "failed": "Kan de programma niet wijzigen"
                },
                "delete": {
                    "action": "Programma verwijderen",
                    "confirm": "Wanneer een programma wordt verwijderd, is deze direct niet meer toegankelijk voor de spelers. Weet je zeker dat je deze programma wilt verwijderen?",
                    "success": "Programma verwijderd",
                    "failed": "Kan de programma niet verwijderen"
                },
                "restore": {
                    "action": "Herstel programma",
                    "confirm": "Wanneer een programma wordt hersteld, is deze direct weer toegankelijk. Weet je zeker dat je deze programma wilt herstellen?",
                    "success": "Programma hersteld",
                    "failed": "Kan de programma niet herstellen"
                },
                "order": {
                    "action": "Sorteer programmas",
                    "success": "Volgorde van programmas aangepast",
                    "error": "Kan de volgorde van de programmas niet bijwerken"
                },
                "transfer_request_create": {
                    "create": "Kopieerverzoek aanmaken",
                    "success": "Kopieerverzoek verzonden",
                    "failed": "Kan het kopieerverzoek niet verzenden"
                },
                "transfer_request_delete": {
                    "success": "Kopieerverzoek verwijderd",
                    "failed": "Kan het kopieerverzoek niet verwijderen"
                },
                "transfer": {
                    "success": "Kopieerverzoek verwerkt",
                    "failed": "Kan het kopieerverzoek niet verwerken",
                    "skip_missing_microgames": "Micro games zonder toegang overslaan"
                },
                "duplicate": {
                    "success": "Programma gedupliceerd"
                }
            },
            "validations": {
                "not_owned": "De programma is niet van de huidige organisatie",
                "no_access": "De huidige organisatie heeft geen toegang tot de programma",
                "no_longer_available": "De programma of het onderdeel van de programma is niet langer beschikbaar",
                "not_accessible": "Je hebt geen toegang tot deze programma",
                "transfer_already_sent": "Kopieerverzoek is reeds verzonden",
                "transfer_no_access": "De huidige organisatie heeft geen toegang om het kopieerverzoek te verwerken",
                "no_access_to_microgames": "De organisatie heeft geen toegang tot \u00e9\u00e9n of meerdere microgames. Neem contact op met jouw account-manager voor toegang. De programma kan nog steeds worden gekopieerd, maar de module(s) met de volgende microgame(s) worden overgeslagen:",
                "tournament_has_ended": "Het toernooi van deze programma is afgelopen en kan niet meer worden gespeeld",
                "battle_outside_tournament": "Deze programma heeft battles die volledig buiten het toernooi vallen. Verwijder deze voordat je de toernooimodus configureert."
            },
            "tournament": {
                "warn_existing_battles": "Deze programma heeft actieve of aankomende battles. Als een battle gedeeltelijk overlapt met het toernooi, worden de tijden aangepast."
            }
        },
        "challenge": {
            "challenge": "Day",
            "challenges": "Days",
            "challenge_description": "Een dag bestaat uit een verzameling modules en kan worden vergeleken met een hoofdstuk uit een boek.",
            "challenge_completed_at": "Dag voltooid op",
            "challenge_play": "Speel de dag om je score te verbeteren",
            "challenge_not_playable": "De dag kan niet worden gespeeld",
            "challenge_not_playable_no_modules": "De dag heeft 0 modules en kan daarom niet worden gespeeld. Neem contact op met je instructeur.",
            "challenge_completed": "Dag voltooid",
            "challenge_completed_name": "Dag :challenge voltooid",
            "challenge_completed_description": "Goed gedaan! Je hebt de dag voltooid!",
            "challenge_not_completed": "Dag niet voltooid",
            "challenge_not_completed_description": "Helaas is de dag niet voltooid. Maar... geen probleem! Probeer het gewoon opnieuw!",
            "try_again": "Speel opnieuw",
            "back_to_campaign": "Terug naar programma",
            "next_challenge": "Volgende dag starten",
            "progress": "Voortgang",
            "start": "Begin",
            "properties": {
                "name": "Naam",
                "description": "Omschrijving",
                "image": "Afbeelding",
                "image_select": "Selecteer afbeelding"
            },
            "actions": {
                "create": {
                    "action": "Dag toevoegen",
                    "success": "Dag toegevoegd",
                    "failed": "Kan de dag niet toevoegen"
                },
                "update": {
                    "action": "Dag wijzigen",
                    "success": "Dag gewijzigd",
                    "failed": "Kan de dag niet wijzigen"
                },
                "delete": {
                    "action": "Dag verwijderen",
                    "confirm": "De dag zal worden verwijderd uit de programma. Dit zorgt ervoor dat spelers de dag niet meer kunnen spelen en bekijken. Weet je zeker dat je de dag wilt verwijderen?",
                    "success": "Dag verwijderd",
                    "failed": "Kan de dag niet verwijderen"
                },
                "restore": {
                    "action": "Dag herstellen",
                    "confirm": "Na het herstellen van een dag is deze direct toegankelijk voor spelers. Weet je zeker dat je de dag wilt verwijderen?",
                    "success": "Dag hersteld",
                    "failed": "Kan de dag niet herstellen"
                },
                "order": {
                    "success": "Volgorde van dagen is gewijzigd",
                    "error": "Kan de volgorde van dagen niet wijzigen"
                }
            },
            "validations": {
                "not_owned": "De dag behoort niet tot jouw organisatie",
                "must_be_part_of_organisation": "De dag moet voor de organisatie zijn",
                "no_modules": "De dag heeft 0 modules en kan dus niet worden gespeeld."
            }
        },
        "challenge_session": {
            "actions": {
                "update": {
                    "failed": "Kan de module sessie niet wijzigen"
                }
            },
            "validations": {
                "must_be_part_of_organisation": "De challenge sessie moet tot een challenge behoren van de organisatie",
                "not_owned": "De challenge sessie is niet van jou. Start de challenge vanuit je eigen account",
                "too_old": "De challenge sessie is ouder dan 8 uur. Start de challenge opnieuw"
            }
        },
        "custom_tiles": {
            "custom_tile": "Aangepaste tegel",
            "custom_tiles": "Aangepaste tegels",
            "yes": "Ja",
            "no": "Nee",
            "properties": {
                "name": "Naam",
                "title": "Titel",
                "image": "Afbeelding",
                "url": "URL",
                "identifier": "Identificatie",
                "image_select": "Selecteer afbeelding",
                "enabled": "Ingeschakeld"
            },
            "filter": {
                "identifier": "Selecteer identificatie"
            },
            "actions": {
                "create": {
                    "action": "Nieuwe aangepaste tegel",
                    "success": "Aangepaste tegel aangemaakt",
                    "failed": "Kan aangepaste tegel niet aanmaken"
                },
                "update": {
                    "title": "Bewerk :type aangepaste tegel",
                    "success": "Aangepaste tegel bijgewerkt",
                    "failed": "Kan aangepaste tegel niet bijwerken"
                }
            }
        },
        "dashboard": {
            "switch_account": "Wissel van account",
            "current_program": "huidig programma",
            "personal-progress": "Persoonlijke vooruitgang",
            "to-receive-certificate": "Om certificaat te halen",
            "highscores": "Topscores",
            "retry_last_performance": "Laatste uitvoering herhalen",
            "no_last_performance": "U heeft aan geen enkele campagne deelgenomen",
            "to_fittar_app": "Fittar",
            "to_fittar_app_description": "Spellen en oefeningen",
            "battle_mode": "Gevechtsmodus",
            "battleground": "Battleground",
            "programs": "Programma's",
            "exergames": "Exergames",
            "interactive_workouts": "Interactieve trainingen",
            "fitness_video": "Fitness video's",
            "leaderboard": "Scorebord",
            "community": "Community",
            "support": "Ondersteuning",
            "interactive_challenges": "Challenges",
            "videos": "Video's",
            "privacy_policy": "Privacybeleid",
            "faq": "FAQ",
            "user_tips": "Gebruiker Tips",
            "terms_and_conditions": "Algemene voorwaarden",
            "tournament": "Toernooi",
            "challenges": "Challenges",
            "battle_await": "Battle openstaand"
        },
        "direct_play_micro_game": {
            "micro_games": "Direct-play micro games",
            "explanation": "De campagnes die hier worden weergegeven zijn alleen voor de context, omdat ze voor elke gebruiker kunnen verschillen, afhankelijk van de campagnes waartoe ze toegang hebben. De micro games worden altijd getoond op de positie in deze lijst.",
            "properties": {
                "name": "Naam",
                "description": "Omschrijving",
                "image": "Afbeelding",
                "image_select": "Selecteer afbeelding",
                "type": "Type",
                "hide_high_score": "High score verbergen"
            },
            "actions": {
                "create": {
                    "action": "Direct-play micro game toevoegen",
                    "success": "Direct-play micro game toegevoegd",
                    "failed": "Kan de direct-play micro game niet toevoegen"
                },
                "update": {
                    "action": "Direct-play micro game wijzigen",
                    "success": "Direct-play micro game gewijzigd",
                    "failed": "Kan de direct-play micro game niet wijzigen"
                },
                "order": {
                    "success": "Volgorde van direct-play micro games aangepast"
                },
                "delete": {
                    "action": "Direct-play micro game verwijderen",
                    "confirm": "Wanneer een direct-play micro game wordt verwijderd, is deze direct niet meer toegankelijk voor de spelers. Weet je zeker dat je deze direct-play micro game wilt verwijderen?",
                    "success": "Direct-play micro game verwijderd",
                    "failed": "Kan de direct-play micro game niet verwijderen"
                }
            },
            "validations": {
                "not_owned": "De direct-play micro game is niet van de huidige organisatie"
            }
        },
        "domains": {
            "domains": "Domeinen",
            "domain": "Domein",
            "properties": {
                "domain": "Domein"
            },
            "actions": {
                "create": {
                    "action": "Domein toevoegen",
                    "success": "Domein gemaakt",
                    "failed": "Kan het domein niet aanmaken"
                },
                "update": {
                    "action": "Domein bewerken",
                    "success": "Domein bijgewerkt",
                    "failed": "Kan het domein niet bijwerken"
                },
                "delete": {
                    "action": "Domein verwijderen",
                    "confirm": "Weet u zeker dat u door wilt gaan?",
                    "success": "Domein verwijderd",
                    "failed": "Kan het domein niet verwijderen"
                }
            }
        },
        "exception": {
            "one_time_login_token_invalid": "Ongeldige eenmalige login token",
            "one_time_login_token_expired": "Eenmalige login token is verlopen",
            "one_time_login_token_not_yet_valid": "Eenmalige login token is nog niet geldig",
            "one_time_login_token_consumed": "Eenmalige login token is al gebruikt",
            "one_time_login_token_not_for_organisation": "Eenmalige login token is niet geldig voor deze organisatie",
            "route_not_found": "Geen route gevonden voor dit verzoek",
            "feature_only_available_playground_landscape": "Dit kenmerk is alleen beschikbaar in het PlayGround-thema.",
            "feature_only_available_fittar": "Dit kenmerk is alleen beschikbaar in het Fittar-thema."
        },
        "gamified_video": {
            "gamified_video": "Gamified video",
            "gamified_videos": "Gamified video's",
            "overview_description": "Overzicht van alle ge\u00efmporteerde gamified video's.",
            "description": "Een gamified video is een interactieve video van HiHaHo. De beschikbare video's worden automatisch ingelezen uit HiHaHo.",
            "select_available_video": "Selecteer een beschikbare video",
            "preview": "voorbeeld",
            "properties": {
                "name": "Naam",
                "folder": "Map",
                "link": "Link",
                "external_id": "Externe ID",
                "embed_url": "Embed URL",
                "total": "Totaal",
                "created": "Aangemaakt",
                "existing": "Bestaand"
            },
            "actions": {
                "play": {
                    "action": "Speel de video hieronder en ga dan door."
                },
                "import": {
                    "action": "Importeer Gamified videos",
                    "description": "Deze actie zal alle beschikbare gamified video's ophalen uit HiHaHo. Dit kan even duren en dient alleen te worden gedaan wanneer gamified video's ontbreken. Weet je zeker dat je het proces wilt starten?",
                    "results": "Resultaten import"
                }
            },
            "play_first": "Speel de video eerst",
            "play_first_description": "Speel de video voordat je door kan gaan",
            "unable_to_retrieve_progress": "Kan de voortgang van de video niet opslaan. De developers zijn hierover ge\u00efnformeerd."
        },
        "gamified_video_folder": {
            "gamified_video_folders": "Gamified video mappen",
            "overview_description": "Overzicht van alle mappen van de Gamified video's",
            "select_placeholder": "Selecteer gamified videomap(pen)",
            "none_assigned": "Er zijn geen toegewezen gamified videomappen.",
            "properties": {
                "name": "Naam",
                "external_id": "Externe ID"
            },
            "actions": {
                "update": {
                    "success": "Toegang tot de gamified video mappen is gewijzigd"
                }
            },
            "filter": {
                "folder": "Mappen",
                "all_folders": "Alle mappen"
            }
        },
        "general": {
            "start": "Start",
            "start_workout": "Start workout",
            "start_video": "Video starten",
            "play_now": "Nu spelen",
            "quit": "Afsluiten",
            "data": "Data",
            "data_tools": "Data & Tools",
            "dashboard": "Dashboard",
            "home": "Home",
            "welcome": "Welkom",
            "welcome_description": "Start met spelen door in te loggen",
            "required": "Verplicht",
            "toggle_navigation": "Navigatie openen\/sluiten",
            "insights": "Inzichten",
            "back_to_dashboard": "Terug naar dashboard",
            "back_to_campaigns": "Terug naar campagnes",
            "back_to_exergames": "Terug naar exergames",
            "back_to_interactive_workouts": "Terug naar interactieve workouts",
            "back_to_leaderboards": "Terug naar scorebord",
            "control_panel": "Control panel",
            "no_avatar": "Geen avatar",
            "search": "Zoeken",
            "search_placeholder": "Zoeken...",
            "status": "Status",
            "active": "Actief",
            "inactive": "Inactief",
            "archived": "Gearchiveerd",
            "clear_filter": "Filter wissen",
            "filter_results": "<strong>:start<\/strong> tot <strong>:end<\/strong> van de <strong>:total<\/strong> resultaten",
            "results": "resultaten",
            "access_denied": "Geen toegang",
            "access_denied_description": "Sorry, maar je hebt niet de juiste permissies voor deze functionaliteit.",
            "unable_to_store_file": "Kan het bestand niet opslaan",
            "unable_to_process_file": "Kan het bestand niet verwerken",
            "upload_error": "Er ging iets fout tijdens het uploaden",
            "invalid_file": "Ongeldig bestand aangeleverd",
            "file_too_large": "De bestandsgrootte van het aangeleverd bestand moet maximaal :size Mb zijn. Verklein het bestand om deze te gebruiken",
            "import": "Importeren",
            "add": "Toevoegen",
            "create": "Toevoegen",
            "edit": "Wijzigen",
            "filter": "Filter",
            "update": "Wijzigen",
            "manage": "Beheren",
            "delete": "Verwijderen",
            "restore": "Herstellen",
            "remove": "Verwijderen",
            "assign": "Toekennen",
            "revoke": "Intrekken",
            "failed": "Mislukt",
            "order": "Volgorde",
            "save": "Opslaan",
            "save_order": "Volgorde opslaan",
            "properties": "Eigenschappen",
            "export": "Exporteren",
            "oops": "Oeps...",
            "text": "Tekst",
            "header": "Kop",
            "confirm": "Bevestigen",
            "send": "Versturen",
            "cancel": "Annuleren",
            "minute": "minuut",
            "minutes": "minuten",
            "minutes_short": "mins",
            "back": "Terug",
            "finish": "Afronden",
            "next": "Volgende",
            "summary": "Samenvatting",
            "play_again": "Speel opnieuw",
            "qr_code": "QR code",
            "qr_code_description": "Gebruik deze QR code om spelers direct te laten spelen.",
            "qr_code_start": "Direct spelen.",
            "download": "Download",
            "download_svg": "Download SVG",
            "download_png": "Download PNG",
            "or_go_to": "of ga naar",
            "logout": "Uitloggen",
            "profile": "Profiel",
            "add_field": "Veld toevoegen",
            "select_file": "Selecteer bestand",
            "settings": "Instellingen",
            "no_results": "Geen resultaten gevonden",
            "loading": "Laden...",
            "close": "Sluiten",
            "optional": "Optioneel",
            "is": "is",
            "seconds": "seconden",
            "selected": "geselecteerd",
            "language_unavailable_in_organisation": "niet beschikbaar voor :organisation",
            "points": "Punten",
            "score": "Score",
            "read_more": "Meer lezen",
            "high_score": "High score",
            "everything": "Alles",
            "this_field": "Dit veld",
            "reset": "Reset",
            "tournament": "TOERNOOI",
            "score_not_set": "Score niet gezet",
            "image_cannot_be_loaded": "Afbeelding kan niet geladen worden"
        },
        "interactive_workouts": {
            "no_available_interactive_workouts_in_category": "Geen beschikbare workouts in deze categorie",
            "tailored_workout_plans": "Op maat gemaakte trainingsschema's"
        },
        "leaderboard": {
            "leaderboard": "Leaderboard",
            "tournament": "Toernooi",
            "challenges": "Challenges",
            "games": "Games",
            "properties": {
                "rank": "Rang",
                "total": "Totaal",
                "player": "Speler",
                "score": "Score",
                "bonus": "Bonus"
            },
            "league": {
                "levels": {
                    "bronze": "Brons league",
                    "silver": "Zilver league",
                    "gold": "Goud league"
                },
                "poule": "Poule",
                "promotion_zone": "Promotiezone",
                "relegation_zone": "Degradatiezone",
                "user_promotion_zone": "Je zit in de promotiezone",
                "user_relegation_zone": "Je zit in de degradatiezone",
                "xp_ahead": ":value :xp voor om door te gaan naar de volgende league",
                "xp_to_maintain": ":value :xp nodig om te handhaven"
            }
        },
        "micro_game": {
            "micro_game": "Micro game",
            "micro_games": "Micro games",
            "your_latest_highscore": "Je laatste topscore",
            "play": "Spelen",
            "management": {
                "title": "Micro games",
                "description": "Beheer de beschikbare micro games.",
                "groups": {
                    "group": "Micro game groep",
                    "groups": "Micro game groepen",
                    "overview": "Beheer de beschikbare micro game groepen."
                }
            },
            "properties": {
                "name": "Naam",
                "identifier": "Identificatie",
                "description": "Omschrijving",
                "image": "Afbeelding",
                "image_select": "Selecteer afbeelding",
                "group": "Groep",
                "is_global": "Globale Micro Game",
                "is_global_description": "Een globale micro game kan gebruikt worden door alle organisaties.",
                "organisations": "Organisaties",
                "points": "Punten",
                "stars": "Sterren",
                "stars_threshold": "Sterren waarde",
                "build": "Build",
                "webgl_location": "WebGL locatie",
                "custom_data": "Custom data",
                "key": "Naam",
                "value": "Waarde",
                "categories": "Categorie\u00ebn",
                "category": "Categorie"
            },
            "actions": {
                "bulk": {
                    "update": {
                        "success": "Micro games gewijzigd",
                        "failed": "Kan de micro games niet wijzigen"
                    }
                },
                "create": {
                    "action": "Micro game toevoegen",
                    "success": "Micro game toegevoegd",
                    "failed": "Kan de micro game niet toevoegen"
                },
                "update": {
                    "action": "Micro game wijzigen",
                    "success": "Micro game gewijzigd",
                    "failed": "Kan de micro game niet wijzigen"
                },
                "delete": {
                    "action": "Micro game verwijderen",
                    "confirm": "Door het verwijderen van de micro game, kunnen spelers deze niet meer spelen. Weet je zeker dat je door wilt gaan?",
                    "success": "Micro game verwijderd",
                    "failed": "Kan de micro game niet verwijderen"
                },
                "sync": {
                    "action": "Wijzig organisaties",
                    "success": "Organisaties van de micro game gewijzigd",
                    "is_global": "Organisaties van een globale micro game kunnen niet worden gewijzigd"
                }
            },
            "filter": {
                "all_groups": "Alle groepen",
                "all_categories": "Alle categorie\u00ebn",
                "select_micro_game": "Selecteer micro game",
                "select_micro_game_of_group": "Selecteer :group",
                "select_micro_game_group": "Selecteer groep"
            },
            "validations": {
                "organisation_must_have_access": "The organisation does not have access to this micro game."
            },
            "done_with_playing": "Klaar met spelen",
            "ends": "loopt af"
        },
        "micro_game_group": {
            "group": "Micro game groep",
            "groups": "Micro game groepen",
            "management": {
                "title": "Micro game groepen",
                "description": "Beheer de beschikbare micro game groepen."
            },
            "properties": {
                "name": "Naam",
                "identifier": "Identificatie",
                "image": "Afbeelding",
                "image_select": "Selecteer afbeelding",
                "build": "Build",
                "custom_data": "Custom data",
                "webgl_location": "WebGL locatie",
                "type": "Type",
                "categories": "Categorie\u00ebn"
            },
            "types": {
                "micro_game": "Micro game",
                "fitness_content": "Fitness content",
                "exergame": "Exergame",
                "interactive_workout": "Interactieve workout",
                "challenges": "uitdagingen"
            },
            "interactive_workout": {
                "categories": {
                    "upper_body": "Upper Body",
                    "lower_body": "Lower Body",
                    "full_body": "Full Body",
                    "cardio": "Cardio"
                },
                "exercise_time": "Oefeningstijd (minuten)"
            },
            "videos": {
                "categories": {
                    "office": "Kantoor",
                    "endurance": "Uithoudingsvermogen",
                    "strength": "Kracht",
                    "dance": "Dans",
                    "yoga": "Yoga"
                },
                "exercise_time": "Video Exercise Time (minutes)",
                "no_available_video_in_category": "Geen beschikbare video in deze categorie"
            },
            "filter": {
                "all_types": "Alle types",
                "select_type": "Selecteer type",
                "select_category": "selecteer categorie"
            },
            "actions": {
                "create": {
                    "action": "Micro game groep toevoegen",
                    "success": "Micro game groep toegevoegd",
                    "failed": "Kan de micro game groep niet toevoegen"
                },
                "update": {
                    "action": "Micro game groep wijzigen",
                    "success": "Micro game groep gewijzigd",
                    "failed": "Kan de micro game groep niet wijzigen"
                },
                "delete": {
                    "action": "Micro game groep verwijderen",
                    "confirm": "Weet je zeker dat je door wilt gaan?",
                    "success": "Micro game groep verwijderd",
                    "failed": "Kan de micro game groep niet verwijderen",
                    "prohibited": "Het is niet mogelijk een micro game groep te verwijderen waaraan micro games zijn toegekend"
                }
            }
        },
        "module": {
            "module": "Module",
            "module_type": "Type",
            "module_skills": "Vaardigheden",
            "modules": "Modules",
            "modules_completed": "Modules voltooid",
            "module_completed_at": "Module voltooid op",
            "module_play": "Speel de module en behaal de hoogste score",
            "proceed_with_challenge": "Klik op volgende om door te gaan met de challenge.",
            "properties": {
                "name": "Naam",
                "description": "Omschrijving",
                "threshold": "Drempel",
                "threshold_description": "De drempel bepaald of de speler de module succesvol heeft voltooid.",
                "threshold_description_value": "De drempel is een percentage van het aantal goed beantwoorde vragen. Bijv. de drempel is 75 en er zijn 4 vragen, de speler moet dan minimaal 3 vragen goed beantwoorden.",
                "reading_time": "Leestijd",
                "viewed_video": "Ik heb de video bekeken of al eerder gezien.",
                "factor": "Factor",
                "factor_description": "De factor bepaald hoeveel punten er verkregen kunnen worden. Standaard kan de speler :default_score punten halen wanneer een module is voltooid. Door de factor aan te passen kan je het verkregen aantal punten verlagen of verhogen.",
                "image": "Afbeelding",
                "image_select": "Selecteer afbeelding",
                "content": "Content",
                "video": "Video",
                "video_url": "Video URL",
                "video_description": "Gebruik de link naar de video (vanuit de adresbalk van je browser). Dat hoeft geen speciale link te vinden, de applicatie handelt dat af.",
                "text": "Tekst",
                "text_description": "Een tekst module bevat een korte toelichting of introductie en een afbeelding die bij de tekst hoort wanneer je de module speelt.",
                "question_time": "Tijd per vraag",
                "question_time_description": "De maximale tijd die per vraag beschikbaar is.",
                "total_questions_used": "Aantal te tonen vragen",
                "total_questions_used_description": "Het aantal vragen dat aan de spelers wordt getoond (leeg = alle vragen). Random selectie indien meer vragen dan aantal te tonen."
            },
            "actions": {
                "create": {
                    "title": "Nieuwe :type module",
                    "success": "Module toegevoegd",
                    "failed": "Kan de module niet toevoegen"
                },
                "update": {
                    "title": ":type module bewerken",
                    "success": "Module gewijzigd",
                    "failed": "Kan de module niet wijzigen"
                },
                "delete": {
                    "action": "Module verwijderen",
                    "confirm": "Het verwijderen van de module uit de challenge resulteert er in dat geen enkele speler deze module meer ziet of kan spelen. Weet je zeker dat je deze module wilt verwijderen?",
                    "success": "Module verwijderd",
                    "failed": "Kan de module niet verwijderen",
                    "failed_battle": "Kan de module niet verwijderen omdat er een battle is waarbij willekeurig een microgame uit deze campagne wordt gekozen, en dit is de laatste microgame in deze campagne."
                },
                "restore": {
                    "action": "Module herstellen",
                    "confirm": "Het herstellen van de module in de challenge resulteert er in dat spelers direct deze module weer zien en kunnen spelen. Weet je zeker dat je deze module wilt herstellen?",
                    "success": "Module hersteld",
                    "failed": "Kan de module niet herstellen"
                },
                "order": {
                    "success": "Volgorde van de modules is gewijzigd",
                    "failed": "Kan de volgorde van de modules niet wijzigen"
                }
            },
            "filter": {
                "all_types": "Alle types"
            },
            "validations": {
                "must_be_part_of_organisation": "De module moet voor de organisatie zijn",
                "invalid_properties": "Deze module type vereist een configuratie die ontbreekt, bijv. wanneer een gerelateerd object is verwijderd. Pas deze module aan of verwijder deze."
            },
            "already_played": "Je hebt deze module al gespeeld. Klik op 'Volgende' om door te gaan met de challenge."
        },
        "module_session": {
            "actions": {
                "create": {
                    "failed": "Kan de module sessie niet starten"
                },
                "update": {
                    "failed": "Kan de module sessie niet wijzigen"
                }
            },
            "validations": {
                "not_owned": "Je kan alleen je eigen module sessies wijzigen"
            }
        },
        "organisation": {
            "organisation": "Organisatie",
            "organisations": "Organisaties",
            "crud_description": "Het subdomein van de organisatie moet uniek zijn en bestaan uit letters (a-z), getallen (0-9) en\/of een streepje (-)",
            "select_placeholder": "Selecteer organisatie(s)",
            "universal_authentication_enabled": "Universele authenticatie ingeschakeld",
            "universal_authentication_enabled_description": "Wanneer ingeschakeld, gebruikt de organisatie de universele authenticatiestroom",
            "logo": "Logo",
            "validations": {
                "not_found": "Organisatie niet gevonden",
                "not_a_member": "Geen toegang tot de organisatie"
            },
            "properties": {
                "customer": "Klant",
                "name": "Naam",
                "subdomain": "Subdomein",
                "url": "Url",
                "languages": "Taalinstellingen",
                "default_language": "Standaard taal",
                "available_languages": "Beschikbare talen",
                "available_languages_warning": "Wanneer je een taal weghaalt, gaat er data voor die taal verloren bij het bewerken van een item.",
                "manage_translations": "Aangepaste vertalingen beheren",
                "reseller": "Reseller",
                "gamified_video_folders": "Gamified videomappen",
                "gamified_video_folders_description": "Selecteer de gamified videomappen die door de organisatie kunnen worden gebruikt.",
                "social": "Sociaal",
                "social_description": "Voeg een <a href=\"https:\/\/www.freecodecamp.org\/news\/what-is-open-graph-and-how-can-i-use-it-for-my-website\" target=\"_blank\">open graph<\/a> afbeelding en beschrijving toe.",
                "customization": "Aanpassen",
                "customization_description": "De applicatie kan worden aangepast voor de organisatie qua look and feel.",
                "logo": "Logo",
                "logo_requirements": "Max 4Mb",
                "logo_select": "Selecteer logo",
                "open_graph_image": "Open graph afbeelding",
                "open_graph_image_requirements": "Minimaal 640\u00d7320px, max 4Mb",
                "open_graph_image_select": "Selecteer afbeelding",
                "open_graph_description": "Open graph beschrijving",
                "theme_setup": "Thema configuratie",
                "theme_look_and_feel": "Look and feel",
                "theme_select": "Selecteer thema",
                "manage_theme": "Beheer eigen thema",
                "background": "Achtergrond",
                "background_mobile": "Achtergrond (mobiel)",
                "background_tablet": "Achtergrond (tablet)",
                "background_desktop": "Achtergrond (desktop)",
                "background_requirements": "Max 4Mb",
                "background_select": "Selecteer achtergrond",
                "primary_color": "Primaire kleur",
                "secondary_color": "Secondaire kleur",
                "accent_color": "Accent kleur",
                "card_backdrop": "Kaartachtergrond",
                "background_color": "Achtergrondkleur",
                "background_gradient_bottom": "Achtergrondverloop onderaan",
                "background_gradient_top": "Achtergrondverloop bovenaan",
                "card_background_color": "Kaart achtergrondkleur",
                "module_shadow_color": "Module shaduwkleur",
                "primary_font_color": "Primaire lettertype kleur",
                "secondary_font_color": "Secondaire lettertype kleur",
                "primary_font_family": "Primaire lettertype",
                "primary_font_family_select": "Selecteer primaire lettertype...",
                "secondary_font_family": "Secondaire lettertype",
                "secondary_font_family_select": "Selecteer secondaire lettertype...",
                "preview_fonts": "Lettertypes kunnen hier worden bekeken :url",
                "card_border_radius": "Kaartrandradius",
                "welcome_text": "Welkom tekst",
                "welcome_text_description": "Definieert de tekst die wordt weergegeven op het inlogscherm",
                "configuration": "Configuratie",
                "configuration_description": "Bepaal welke features voor deze organisatie beschikbaar zijn",
                "registration_allowed": "Registreren toegestaan",
                "registration_allowed_header": "Registreren<br>toegestaan",
                "registration_description": "Spelers kunnen zich registreren zonder uitnodiging",
                "global_content": "Globale content",
                "global_content_description": "Sta organisaties toe om globale content te gebruiken",
                "demo_user_allowed": "Spelen als demo gebruiker toegestaan",
                "demo_user_allowed_header": "Demo gebruikers<br>toegestaan",
                "demo_user_description": "Spelers kunnen spelen zonder account. Let op, er wordt dan <strong>geen voortgang<\/strong> bijgehouden",
                "allow_upgrade_to_registered_user": "Upgrade naar geregistreerde gebruiker toestaan",
                "allow_upgrade_to_registered_user_description": "Laat demo-gebruikers upgraden naar een geregistreerde gebruiker door hun e-mailadres toe te voegen en te bevestigen.",
                "reseller_allowed": "Organisatie is reseller",
                "reseller_allowed_header": "Organisatie<br>reseller",
                "reseller_description": "Een reseller mag extra organisaties toevoegen voor hun klanten",
                "webhook_url": "Webhook URL",
                "webhook_url_description": "Er is de mogelijkheid om de Gamification Player bij bepaalde evenementen een <a href=\":url\" target=\"_blank\">webhook<\/a> te laten aanroepen. De gamification-speler zal verschillende gebeurtenissen aanroepen met een <code>POST<\/code> request naar de webhook.",
                "webhook_secret": "Webhook geheim",
                "webhook_secret_description": "Omdat de gamification-speler op een cluster wordt gehost, is er geen vast IP-adres beschikbaar. Je moet naast de webhook-URL een <a href=\":url\" target=\"_blank\">geheim\/token<\/a> opgeven om de veiligheid ervan te garanderen. Het geheim\/token kan alles zijn wat je wil en wordt geleverd in de <code>X-Webhook-Token<\/code> header.",
                "webhook_events": "Webhook events",
                "webhook_events_description": "Selecteer alle webhook events die je wilt ontvangen om onnodige webhook events te voorkomen.",
                "webhook_events_select": "Alle events ontvangen",
                "ios_app_url": "iOS app URL",
                "android_app_url": "Android app URL",
                "branchio_url": "Branch.io URL",
                "sso_configurations": ":count configuratie|:count configuraties",
                "domains": ":count domein|:count domeinen",
                "permissions": "Rechten",
                "timezone": "Tijdzone",
                "default_avatar": "Standaard profielfoto",
                "default_avatar_select": "Selecteer standaard profielfoto",
                "default_avatar_requirements": "Max 4Mb"
            },
            "actions": {
                "create": {
                    "success": "Organisatie toegevoegd",
                    "failed": "Kan de organisatie niet toevoegen"
                },
                "update": {
                    "success": "Organisatie gewijzigd",
                    "failed": "Kan de organisatie niet wijzigen"
                },
                "delete": {
                    "action": "Organisatie verwijderen",
                    "confirm": "Bij het verwijderen van een organisatie verliest deze direct alle toegang. Weet je zeker dat je deze organisatie wilt verwijderen?",
                    "success": "Organisatie verwijderd",
                    "failed": "Kan de organisatie niet verwijderen"
                },
                "restore": {
                    "action": "Organisatie herstellen",
                    "confirm": "Bij het herstellen van een organisatie heeft deze direct weer toegang. Weet je zeker dat je deze organisatie wilt herstellen?",
                    "success": "Organisatie hersteld",
                    "failed": "Kan de organisatie niet herstellen"
                }
            },
            "customer_of": "Klant van :organisation",
            "embed_code": "Embed code",
            "embed_width": "Breedte",
            "embed_height": "Hoogte"
        },
        "pagination": {
            "next": "Volgende &raquo;",
            "previous": "&laquo; Vorige"
        },
        "passwords": {
            "reset": "Het wachtwoord van uw account is gewijzigd.",
            "sent": "We hebben een e-mail verstuurd met instructies om een nieuw wachtwoord in te stellen.",
            "throttled": "Gelieve even te wachten en het dan opnieuw te proberen.",
            "token": "Dit wachtwoordhersteltoken is niet geldig.",
            "user": "Geen gebruiker bekend met het e-mailadres."
        },
        "profile": {
            "profile": "Profiel",
            "your_profile": "Mijn profiel",
            "back_to_dashboard": "Terug naar dashboard",
            "update_profile": "Profiel wijzigen",
            "edit_profile": "Profiel bewerken",
            "delete_profile": "Profiel verwijderen",
            "properties": {
                "name": "Naam",
                "email": "E-mailadres",
                "password": "Wachtwoord",
                "password_confirmation": "Bevestig wachtwoord",
                "password_requirements": "Geef een nieuw wachtwoord op. Het nieuwe wachtwoord moet voldoen aan:",
                "password_minimal_characters": "Minimaal 8 karakters",
                "password_minimal_uppercase": "Minimaal 1 hoofdletter",
                "password_minimal_lowercase": "Minimaal 1 kleine letter",
                "password_minimal_number": "Minimaal 1 cijfer",
                "password_weak": "Zwak wachtwoord",
                "password_not_bad": "Niet slecht",
                "password_almost": "Je bent er bijna",
                "username": "Gebruikersnaam",
                "no_username": "Geen gebruikersnaam",
                "country": "Land",
                "avatar": "Avatar",
                "choose_avatar": "Kies avatar",
                "upload_own_avatar": "Upload eigen avatar",
                "edit_profile_photo": "Profielfoto bewerken",
                "photo": "Foto",
                "choose_photo": "Kies foto",
                "upload_photo": "Upload foto",
                "choose_language": "Kies taal",
                "change_language": "Taal bewerken",
                "change_password": "Wachtwoord wijzigen",
                "phonenumber": "Telefoonnummer"
            },
            "demo": {
                "not_allowed": "Als demo-gebruiker mag je je profiel niet wijzigen."
            },
            "actions": {
                "update": {
                    "action": "Profiel opslaan",
                    "success": "Profiel opgeslagen",
                    "failed": "Kan het profiel niet wijzigen"
                },
                "update_password": {
                    "action": "Wachtwoord wijzigen"
                }
            },
            "filter": {
                "select_country": "Selecteer land",
                "select_avatar": "Selecteer avatar"
            }
        },
        "question": {
            "question": "Vraag",
            "questions": "Vragen",
            "question_description": "De speler krijgt deze vraag tijdens het spelen. De vragen in een quiz zijn in volgorde dus kunnen in oplopende moeilijkheidsgraad worden gezet.",
            "no_answers": "Geen antwoorden",
            "template": "Template",
            "type": {
                "single": "Enkele keuze",
                "multiple": "Meerkeuze"
            },
            "properties": {
                "type": "Type",
                "feedback_correct": "Feedback goed",
                "feedback_wrong": "Feedback foutief",
                "feedback_correct_answer": "Feedback goed beantwoord",
                "feedback_wrong_answer": "Feedback foutief beantwoord",
                "content": "Content",
                "image": "Afbeelding",
                "image_select": "Selecteer afbeelding",
                "feedback": "Feedback",
                "feedback_edit": "Feedback bewerken",
                "feedback_description": "Na het beantwoorden van de vraag, kan de speler waardevolle feedback worden gegeven. Afhankelijk van het goed of fout beantwoorden van de vraag, kan verschillende feedback worden gegeven. Feedback is niet verplicht, maar kan het leertraject aanzienlijk verbeteren.",
                "excel_file": "Excel bestand",
                "file_select": "Selecteer bestand",
                "file": "Bestand"
            },
            "actions": {
                "create": {
                    "import": "Vragen importeren",
                    "action": "Vraag toevoegen",
                    "success": "Vraag toegevoegd",
                    "failed": "Kan de vraag niet toevoegen"
                },
                "update": {
                    "action": "Vraag wijzigen",
                    "success": "Vraag gewijzigd",
                    "failed": "Kan de vraag niet wijzigen"
                },
                "delete": {
                    "action": "Vraag verwijderen",
                    "confirm": "Het verwijderen van de vraag resulteert er direct in dat deze vraag niet meer wordt gesteld. Weet je zeker dat je deze vraag wilt verwijderen?",
                    "success": "Vraag verwijderd",
                    "failed": "Kan de vraag niet verwijderen"
                },
                "restore": {
                    "action": "Vraag herstellen",
                    "confirm": "Het herstellen van de vraag resulteert er in dat deze vraag direct weer zal worden gesteld aan de spelers. Weet je zeker dat je deze vraag wilt herstellen?",
                    "success": "Vraag hersteld",
                    "failed": "Kan de vraag niet herstellen"
                },
                "order": {
                    "success": "Volgorde van de vragen is gewijzigd"
                },
                "template": {
                    "download": "Template downloaden"
                },
                "import": {
                    "store": "Kan geen import uitvoeren wanneer er al vragen bestaan",
                    "success": "Vragen toegevoegd"
                }
            },
            "validations": {
                "check_answer_first": "Controleer de antwoorden voordat je naar de volgende vraag gaat",
                "unable_check_answer": "Kan de antwoorden niet controleren",
                "provide_at_least_one_answer": "Geef minimaal 1 antwoord",
                "no_correct_answers": "Geen goed antwoord of alle antwoorden zijn goed"
            }
        },
        "quiz": {
            "quiz": "Quiz",
            "properties": {
                "question_image": "Afbeelding bij de vraag"
            },
            "done": "De quiz is volledig beantwoord in deze sessie. Speel de sessie opnieuw om de quiz nogmaals te spelen.",
            "check_answer": "Controleer antwoord",
            "next_question": "Volgende vraag",
            "time_left": "Tijd over",
            "could_not_be_loaded": "De quiz kon niet geladen worden. Probeer het later opnieuw."
        },
        "reseller": {
            "customer": "Klant",
            "customers": "Klanten",
            "actions": {
                "create": {
                    "action": "Klant toevoegen",
                    "success": "Klant toegevoegd",
                    "failed": "Kan de klant niet toevoegen"
                },
                "update": {
                    "action": "Klant wijzigen",
                    "success": "Klant gewijzigd",
                    "failed": "Kan de klant niet wijzigen"
                },
                "delete": {
                    "action": "Klant verwijderen",
                    "confirm": "Na het verwijderen van de klant verliest deze direct de toegang. Weet je zeker dat je deze klant wilt verwijderen?",
                    "success": "Klant verwijderd",
                    "failed": "Kan de klant niet verwijderen"
                },
                "restore": {
                    "action": "Klant herstellen",
                    "confirm": "Na het herstellen van de klant heeft deze direct weer toegang. Weet je zeker dat je deze klant wilt herstellen?",
                    "success": "Klant hersteld",
                    "failed": "Kan de klant niet herstellen"
                }
            },
            "validations": {
                "no_access": "Jouw organisatie is niet de reseller van deze klant"
            }
        },
        "skill": {
            "skill": "Vaardigheid",
            "skills": "Vaardigheden",
            "select_placeholder": "Selecteer vaardigheden",
            "management": {
                "description": "Een vaardigheid kan worden toegevoegd aan een module."
            },
            "properties": {
                "name": "Naam",
                "description": "Beschrijving",
                "show_on_graph": "Op grafiek laten zien"
            },
            "actions": {
                "create": {
                    "action": "Vaardigheid toevoegen",
                    "success": "Vaardigheid toegevoegd",
                    "failed": "Kan de vaardigheid niet toevoegen"
                },
                "update": {
                    "action": "Vaardigheid wijzigen",
                    "success": "Vaardigheid gewijzigd",
                    "failed": "Kan de vaardigheid niet wijzigen"
                },
                "delete": {
                    "action": "Vaardigheid verwijderen",
                    "confirm": "De vaardigheid zal worden verwijderd uit de campagne. Dit zorgt ervoor dat spelers de vaardigheid niet meer kunnen spelen en bekijken. Weet je zeker dat je de vaardigheid wilt verwijderen?",
                    "success": "Vaardigheid verwijderd",
                    "failed": "Kan de vaardigheid niet verwijderen"
                },
                "restore": {
                    "action": "Vaardigheid herstellen",
                    "confirm": "Na het herstellen van een vaardigheid is deze direct toegankelijk voor spelers. Weet je zeker dat je de vaardigheid wilt verwijderen?",
                    "success": "Vaardigheid hersteld",
                    "failed": "Kan de vaardigheid niet herstellen"
                }
            },
            "user_distribution": "Gebruikersverdeling",
            "validations": {
                "not_owned": "De vaardigheid is niet van de huidige organisatie",
                "unique": "De vaardigheid moet uniek zijn."
            }
        },
        "sso": {
            "sso": "Single Sign On",
            "properties": {
                "name": "Knoptekst",
                "provider": "Provider",
                "login_url": "Login URL"
            },
            "sections": {
                "appearance": {
                    "title": "Verschijning",
                    "description": "Configureer hoe deze Single Sign On optie wordt getoond aan uw gebruikers op de loginpagina."
                },
                "configuration": {
                    "title": "Configuratie"
                }
            },
            "providers": {
                "google": {
                    "driver": "Google Workspace",
                    "properties": {
                        "client_id": "App ID",
                        "client_secret": "Client secret",
                        "domain": "Google Workspace domein"
                    },
                    "placeholders": {
                        "client_id": "*****.apps.googleusercontent.com",
                        "client_secret": "********"
                    }
                },
                "azure": {
                    "driver": "Azure AD",
                    "properties": {
                        "client_id": "Application (client) ID",
                        "client_secret": "Application secret",
                        "tenant": "Directory (tenant) ID"
                    },
                    "placeholders": {
                        "client_id": "00000000-0000-0000-0000-000000000000",
                        "client_secret": "********"
                    }
                },
                "oidc": {
                    "driver": "Generieke OIDC",
                    "description": "De <strong>:authorization_endpoint<\/strong>, <strong>:token_endpoint<\/strong> en <strong>:userinfo_endpoint<\/strong> zijn vereist indien <strong>:discovery_endpoint<\/strong> leeg is. Indien beide worden verstrekt, hebben de expliciet gedefinieerde eindpunten voorrang.",
                    "properties": {
                        "client_id": "App ID",
                        "client_secret": "Client secret",
                        "discovery_endpoint": "URL voor configuratiedetectie",
                        "authorization_endpoint": "Autorisatie endpoint",
                        "token_endpoint": "Token endpoint",
                        "userinfo_endpoint": "Gebruikersinformatie endpoint",
                        "id_key": "Uniek identifier attribuut op het user object"
                    },
                    "placeholders": {
                        "client_id": "",
                        "client_secret": ""
                    }
                },
                "adfs": {
                    "driver": "Active Directory Federation Services",
                    "description": "De <strong>:authorization_endpoint<\/strong>, <strong>:token_endpoint<\/strong> en <strong>:jwks_uri<\/strong> zijn vereist indien <strong>:discovery_endpoint<\/strong> leeg is. Indien beide worden verstrekt, hebben de expliciet gedefinieerde eindpunten voorrang.",
                    "properties": {
                        "client_id": "App ID",
                        "client_secret": "Gedeelde sleutel",
                        "discovery_endpoint": "URL voor configuratiedetectie",
                        "authorization_endpoint": "Autorisatie endpoint",
                        "token_endpoint": "Token endpoint",
                        "jwks_uri": "URL voor JSON Web Key Sets (JWKS)"
                    },
                    "placeholders": {
                        "client_id": "",
                        "client_secret": ""
                    }
                }
            },
            "actions": {
                "create": {
                    "action": "SSO-configuratie toevoegen",
                    "success": "SSO-configuratie gemaakt",
                    "failed": "Kan de SSO-configuratie niet aanmaken"
                },
                "update": {
                    "action": "SSO-configuratie bewerken",
                    "success": "SSO-configuratie bijgewerkt",
                    "failed": "Kan de SSO-configuratie niet bijwerken"
                },
                "delete": {
                    "action": "SSO-configuratie verwijderen",
                    "confirm": "Wanneer u een SSO-configuratie verwijdert, kan deze niet meer gebruikt worden om in te loggen met onmiddellijke ingang. Weet u zeker dat u door wilt gaan?",
                    "success": "SSO-configuratie verwijderd",
                    "failed": "Kan de SSO-configuratie niet verwijderen"
                }
            }
        },
        "stats": {
            "status": "Status",
            "playing": "Spelen",
            "completed": "Voltooid",
            "you": "Jij",
            "average_player": "Gemiddelde speler",
            "hours_play_time": "Speeltijd in uren",
            "modules_played": "Modules gespeeld",
            "experience": "Ervaring",
            "xp": "XP",
            "rewards": "Beloningen",
            "achievements": "Prestaties",
            "badges": "Insignes",
            "certificates": "Certificaten",
            "campaign_stats": "Campagne statistieken",
            "personal_stats": "Persoonlijke statistieken",
            "overal_stats": "Algemene statistieken",
            "average_score": "Gemiddelde score",
            "not_enough_data": "niet genoeg data",
            "xp_per_month": ":xp per maand",
            "xp_per_week": ":xp per week",
            "weekly": "Wekelijks",
            "monthly": "Maandelijks",
            "experience_points": "Ervaringspunten",
            "weeks": "Weken",
            "stats": "Statistieken",
            "xp_graph": "XP grafiek",
            "active_days": "Actieve dagen",
            "total_time_spent": "Totale tijd besteed",
            "challenges": "Challenges",
            "workouts": "Workouts",
            "games": "Games",
            "videos": "Video's"
        },
        "survey": {
            "survey": "Survey",
            "surveys": "Surveys",
            "view_survey": "Survey bekijken",
            "insight_description": "Hier kan je de antwoorden per survey onderdeel bekijken. Daarnaast staat het aantal keer dat het antwoord is gegeven. De data kan worden ge\u00ebxporteerd via de knop bovenin.",
            "part_of_challenge": "Onderdeel van challenge",
            "part_of_campaign": "Onderdeel van campagne",
            "sessions": "Sessies",
            "type_descriptive": "Vraag\/Opdracht\/Statement",
            "options": "Opties",
            "provide_answer": "Geef je antwoord of reactie hieronder",
            "order": "Volgorde",
            "type": "Type",
            "question": "Vraag",
            "provided_answer": "Gegeven antwoord",
            "provided_amount": "Aantal keer gegeven",
            "no_data": "Voor deze survey konden geen gegevens worden gevonden.",
            "properties": {
                "reaction": "Reactie",
                "reactions": "Reacties",
                "totally_disagree": "Totaal oneens",
                "disagree": "Oneens",
                "agree": "Eens",
                "totally_agree": "Totaal eens",
                "pdf_text": "PDF tekst",
                "pdf_text_description": "Deze tekst wordt gebruikt in de PDF die wordt gegenereerd van de survey resultaten."
            },
            "validations": {
                "ensure_single_choice": "Minimaal 1 optie is verplicht",
                "ensure_multiple_choice": "Er zijn minimaal 2 opties verplicht"
            }
        },
        "survey_entry": {
            "survey_entry": "Survey onderdeel",
            "survey_entries": "Survey onderdelen",
            "survey_entry_description": "De speler krijgt dit onderdeel te zien tijdens de survey.",
            "statement": "Stelling",
            "question_or_assignment": "Vraag\/Opdracht",
            "reaction_or_answer": "Reactie\/Antwoord",
            "specification": "Specificatie",
            "single_choice_description": "De speler kan een enkele reactie of antwoord geven op de vraag\/opdracht. Er moet minimaal 1 optie zijn.",
            "multiple_choice_description": "De speler kan meerdere reacties of antwoorden geven op de vraag\/opdracht. Er moeten minimaal 2 opties zijn.",
            "slider_description": "Bij een slider is er een minimale en maximale waardering. De slider heeft altijd een nauwkeurigheid van 1. Hoe groter het verschil, hoe meer nauwkeurig de speler antwoord kan geven.",
            "statement_description": "Een speler kan reageren op een statement. De minimale waardering zegt dat de speler het er absoluut oneens mee is, de maximale waardering dat deze het er absoluut mee eens is. Hoe groter het verschil, hoe meer nauwkeurig de speler antwoord kan geven.",
            "optional_description": "Als de vraag als optioneel is gemarkeerd kan de speler het antwoord leeg laten.",
            "properties": {
                "minimal_valuation": "Minimale waardering",
                "maximal_valuation": "Maximale waardering",
                "min_text": "Min tekst",
                "max_text": "Max tekst"
            },
            "actions": {
                "create": {
                    "action": "Survey onderdeel toevoegen",
                    "success": "Survey onderdeel toegevoegd",
                    "failed": "Kan het survey onderdeel niet toevoegen"
                },
                "update": {
                    "action": "Survey onderdeel wijzigen",
                    "success": "Survey onderdeel gewijzigd",
                    "failed": "Kan het survey onderdeel niet wijzigen"
                },
                "delete": {
                    "action": "Survey onderdeel verwijderen",
                    "confirm": "Na het verwijderen van dit survey onderdeel wordt deze direct niet meer aangeboden aan de spelers. Weet je zeker dat je dit survey onderdeel wilt verwijderen?",
                    "success": "Survey onderdeel verwijderd",
                    "failed": "Kan het survey onderdeel niet verwijderen"
                },
                "restore": {
                    "action": "Survey onderdeel herstellen",
                    "confirm": "Na het herstellen van dit survey onderdeel wordt deze direct weer aangeboden aan de spelers. Weet je zeker dat je dit survey onderdeel wilt herstellen?",
                    "success": "Survey onderdeel hersteld",
                    "failed": "Kan het survey onderdeel niet herstellen"
                },
                "order": {
                    "success": "De volgorde van de survey onderdelen is gewijzigd",
                    "failed": "Kan de volgorde van de survey onderdelen niet wijzigen"
                }
            }
        },
        "tag": {
            "tag": "Label",
            "tags": "Labels",
            "edit_tags": "Labels bewerken",
            "select_placeholder": "Selecteer label",
            "select_all": "Alle labels",
            "management": {
                "description": "Een label kan worden toegevoegd aan een gebruiker."
            },
            "properties": {
                "name": "Naam",
                "description": "Beschrijving"
            },
            "actions": {
                "create": {
                    "action": "Label toevoegen",
                    "success": "Label toegevoegd",
                    "failed": "Kan de label niet toevoegen"
                },
                "update": {
                    "action": "Label wijzigen",
                    "success": "Label gewijzigd",
                    "failed": "Kan de label niet wijzigen"
                },
                "delete": {
                    "action": "Label verwijderen",
                    "confirm": "De label zal worden verwijderd uit de campagne. Weet je zeker dat je de label wilt verwijderen?",
                    "success": "Label verwijderd",
                    "failed": "Kan de label niet verwijderen"
                },
                "restore": {
                    "action": "Label herstellen",
                    "confirm": "Na het herstellen van een label is deze direct toegankelijk voor spelers. Weet je zeker dat je de label wilt verwijderen?",
                    "success": "Label hersteld",
                    "failed": "Kan de label niet herstellen"
                },
                "bulk": {
                    "action": "Bulk labels",
                    "success_assign": "Label toegekend aan gebruikers",
                    "success_revoke": "Label verwijderd van gebruikers"
                }
            },
            "validations": {
                "not_owned": "De label is niet van de huidige organisatie"
            }
        },
        "theme": {
            "themes": "Thema's",
            "manage": "Beheren",
            "manage_organisation_theme": "Beheer organisatie thema",
            "fonts": "Lettertypes",
            "font_description": "Dit zorgt ervoor dat het thema de klant zijn lettertype gebruikt.",
            "primary_font": "Primaire lettertype",
            "secondary_font": "Secondaire lettertype",
            "colors": "Kleuren",
            "color_description": "Dit zorgt ervoor dat het thema de klant zijn kleuren gebruikt.",
            "primary_color": "Primaire kleur",
            "secondary_color": "Secondaire kleur",
            "accent_color": "Accent kleur",
            "card_style": "Kaart stijl",
            "card_style_description": "Dit zorgt ervoor dat het thema past bij de huisstijl van de klant.",
            "border_radius": "Rand ronding",
            "edit_save_button": "Wijzigingen opslaan"
        },
        "translation": {
            "translations": "Vertalingen",
            "translation": "Vertaling",
            "properties": {
                "key": "Systeemsleutel",
                "message": "Tekst"
            },
            "filter": {
                "all_locales": "Alle talen",
                "locale": "Taal"
            },
            "actions": {
                "update": {
                    "success": "Vertaling bijgewerkt",
                    "failed": "Kan de vertaling niet bijwerken"
                }
            }
        },
        "user": {
            "user": "Gebruiker",
            "users": "Gebruikers",
            "user_count": ":count gebruiker|:count gebruikers",
            "demo_user": "Demo-gebruiker",
            "demo_user_not_allowed": "Spelen als demo-gebruiker is niet ingeschakeld",
            "demo_user_not_possible": "Spelen als demo-gebruiker is momenteel niet mogelijk",
            "demo_user_notice": "Je speelt als demo-gebruiker. Ga naar uw \"Account\" om uw profiel te wijzigen als u uw voortgang wilt opslaan.",
            "demo_user_notice_no_upgrade": "Je speelt als demo-gebruiker. Vraag je instructeur om een account om je voortgang bij te houden.",
            "administrator": "Administrator",
            "administrator_description": "Een administrator mag de gehele applicatie beheren. Ken deze rol alleen toe als je het zeker weet!",
            "manager": "Manager",
            "manager_description": "Een manager mag de gebruikers en campagnes van de organisatie beheren.",
            "name": "Naam",
            "email": "E-mail adres",
            "password": "Wachtwoord",
            "password_create": "Laat het wachtwoord leeg om automatisch een wachtwoord te genereren.",
            "password_edit": "Laat het wachtwoord leeg om deze niet te wijzigen.",
            "password_confirm": "Bevestig wachtwoord",
            "expires_at": "Verloopt op",
            "language": "Voorkeurstalen",
            "language_description": "Voeg je talen toe en sorteer ze op voorkeur. Mocht een organisatie waar jij lid van bent geen van deze talen ondersteunen, dan wordt de site weergegeven in de standaardtaal van de organisatie.",
            "add_preferred_language": "Voorkeurstaal toevoegen",
            "tags": "Labels",
            "permissions": "Permissies",
            "edit_user_roles": "Rollen bewerken",
            "select_placeholder": "Selecteer gebruikers",
            "is_manager": "Is manager",
            "is_administrator": "Is administrator",
            "is_anonymous": "Is demo-gebruiker",
            "added_at": "Toegevoegd op",
            "user_added": "Gebruiker toegevoegd",
            "modified_at": "Gewijzigd op",
            "last_modified": "Laatst gewijzigd",
            "unable_to_create": "Kan de gebruiker niet toevoegen",
            "unable_to_create_membership": "Kan de gebruiker niet toevoegen aan de organisatie",
            "invite_sent": "Uitnodiging verstuurd",
            "unable_to_sent_invite": "Kan de uitnodiging niet versturen",
            "invite_sent_again": "Uitnodiging opnieuw verstuurd",
            "invite_accepted": "Uitnodiging geaccepteerd! Welkom bij :app",
            "invite_removed": "Uitnodiging verwijderd",
            "unable_to_remove_invite": "Kan de uitnodiging niet verwijderen",
            "create": "Gebruiker toevoegen",
            "created": "Gebruiker toegevoegd",
            "created_without_rights": "Gebruiker toegevoegd maar kan de rechten niet opslaan",
            "created_without_membership": "Gebruiker toegevoegd maar kan de gebruiker niet toevoegen aan de organisatie",
            "created_with_password": "Gebruiker toegevoegd met het wachtwoord <code>:password<\/code>",
            "updated": "Gebruiker gewijzigd",
            "updated_without_rights": "Gebruiker gewijzigd maar kan de rechten niet opslaan",
            "unable_to_update": "Kan de gebruiker niet wijzigen",
            "remove": "Gebruiker verwijderen",
            "remove_confirmation": "De gebruiker wordt verwijderd uit de organisatie en verliest direct de toegang. Weet je zeker dat je de gebruiker wilt verwijderen?",
            "removed": "Gebruiker verwijderd",
            "unable_to_remove": "Kan de gebruiker niet verwijderen",
            "invalid_email_address": "Ongeldig e-mail adres",
            "invalid_password": "Wachtwoord voldoet niet aan de gestelde voorwaarden",
            "invalid_language": "Taal is ongeldig",
            "tag_does_not_exist": "De tag \":tag\" kan niet worden toegevoegd omdat deze niet bestaat",
            "email_or_name_required": "Een e-mail adres of naam is verplicht",
            "invites": "Uitnodigingen",
            "invite": "Uitnodigen",
            "accept_invite": "Accepteer uitnodiging",
            "accept_invite_description": "Om je registratie te voltooien, hebben we nog wat informatie nodig.",
            "invalid_invite": "Ongeldige uitnodiging",
            "invalid_invite_description": "Sorry, maar de token is ongeldig of de uitnodiging is verlopen. Vraag je instructeur om een nieuwe uitnodiging.",
            "revoke_invite": "Uitnodiging intrekken",
            "revoke_invite_description": "Na het intrekken van de uitnodiging is de ontvanger niet meer in staat om de uitnodiging te accepteren. Weet je zeker dat je de uitnodiging wilt intrekken?",
            "send_invite": "Verstuur uitnodiging",
            "invite_description": "Het opgegeven e-mail adres zal een uitnodiging voor deze organisatie ontvangen per e-mail.",
            "invite_email_exists": "Het opgegeven e-mail adres mag nog geen account hebben.",
            "import": "Importeren",
            "import_file": "Bronbestand",
            "import_file_select": "Selecteer bronbestand",
            "import_file_description": "Het bestand moet een CSV of Excel bestand zijn en hoeft niet te voldoen aan een bepaalde structuur. In de volgende stap kan je bepalen welke informatie in welke kolommen staat.",
            "import_file_description_existing_user": "Wanneer een gebruiker al een account heeft voor de :app, zal het account worden toegevoegd aan deze organisatie.",
            "import_users": "Importeer gebruikers",
            "imported_users": "Gebruikers ge\u00efmporteerd",
            "import_determine_columns": "Bepaal kolommen",
            "import_results": "Resultaten",
            "import_select_file": "Selecteer bestaand",
            "import_existing_user": "Bestaande gebruiker",
            "import_message": "Bericht",
            "import_column": "Kolom",
            "import_ignore_column": "Negeer kolom",
            "import_skip_first_row": "Sla eerste regel over",
            "import_skip_first_row_description": "Handig voor wanneer de eerste regel een header bevat.",
            "import_preview_stats": "Er zijn <code>:rows<\/code> regels gevonden en er worden <code>:preview<\/code> regels weergegeven in het voorbeeld.",
            "user_profile": "Gebruikersprofiel",
            "add_user": "Gebruiker toevoegen",
            "edit_user": "Gebruiker bewerken",
            "user_role": "Gebruikersrol",
            "user_roles": "Gebruikersrollen",
            "account_settings": "Account instellingen",
            "personal_details": "Pesoonlijke details",
            "phonenumber": "Telefoonnummer",
            "import_user_not_imported": "Gebruiker niet ge\u00efmporteerd",
            "import_user_imported_with_warnings": "Gebruiker ge\u00efmporteerd met waarschuwingen",
            "import_user_imported": "Gebruiker ge\u00efmporteerd",
            "import_only_existing_tags": "Alleen <a href=\":manage_labels\">labels<\/a> die bestaan worden toegevoegd aan gebruikers. Zorg ervoor dat alle labels die u wilt importeren bestaan voordat u importeert.",
            "validations": {
                "must_be_part_of_organisation": "De gebruiker moet onderdeel zijn van de organisatie",
                "must_not_be_part_of_organisation": "De gebruiker mag geen onderdeel zijn van de organisatie"
            },
            "invitation": {
                "subject": "Je Uitnodiging om de Fittar App te Gebruiken",
                "intro": "Word vandaag nog lid van Fittar!",
                "text": "We zijn enthousiast om je uit te nodigen om je te registreren voor de Fittar app! Accepteer de uitnodiging, meld je aan en begin direct.",
                "valid_until": "<b>Let op:<\/b> Deze uitnodiging is geldig tot :expires_at.",
                "tip": "<b>Tip!<\/b> Voor de beste trackingervaring: Zorg ervoor dat je telefoon zo rechtop mogelijk staat. <a href=\"https:\/\/www.betaalbarehoesjes.nl\/standaard-speciaal-ontworpen-voor-fittar-zwart-cop.html\" target=\"_blank\">Bekijk onze aanbevolen telefoonhouder<\/a> voor de beste ervaring!",
                "need_help": "Hulp nodig?",
                "need_help_bullet_1": "Bekijk onze <a href=\"https:\/\/www.youtube.com\/watch?v=IEBAqVb1nI0\" target=\"_blank\">walkthroughvideo<\/a> voor een korte introductie.",
                "need_help_bullet_2": "Bezoek onze website voor <a href=\"https:\/\/fittar.eu\/user-tips\/\" target=\"_blank\">gebruikerstips <\/a> en <a href=\"https:\/\/fittar.eu\/faq\/\" target=\"_blank\">veelgestelde vragen (FAQ)<\/a>.",
                "need_help_bullet_3": "<a href=\"https:\/\/outlook.office.com\/bookwithme\/user\/7fccc4c542224f75813993b7b3da121e@fittar.eu\/meetingtype\/gIW6zZ-tkEWXBojJN8CY2g2?anonymous&ep=mCardFromTile\" target=\"_blank\">Vraag een gratis 30 minuten demo aan<\/a>.",
                "enjoy": "We kijken ernaar uit je te verwelkomen bij Fittar!",
                "accept": "Accepteer uitnodiging",
                "copy_link": "Heb je problemen met de knop? Kopieer dan de volgende link in een browser:"
            },
            "actions": {
                "delete": {
                    "action": "Verwijder profiel",
                    "confirm": "Als je je profiel verwijdert, kun je niet meer spelen. Als je bent ingelogd met je bedrijfsaccount, heb je de volgende keer dat je inlogt geen voortgang meer. Weet je zeker dat je door wilt gaan?",
                    "success": "Profiel verwijderd",
                    "failed": "Kan je profiel niet verwijderen",
                    "warning": "Het verwijderen van je profiel is definitief"
                }
            },
            "not_visible_by_demo_user": "Niet zichtbaar voor demo gebruikers",
            "cannot_be_admin_because_sso": "Deze gebruiker heeft gekoppelde SSO identiteiten en mag dus geen administrator zijn uit veiligheidsoverwegingen.",
            "sso_user": "SSO gebruiker",
            "password_change_not_possible": "Het is niet mogelijk om het wachtwoord van deze gebruiker aan te passen.",
            "roles_change_not_possible": "Het is niet mogelijk om de rollen van deze gebruiker aan te passen."
        },
        "validation": {
            "accepted": ":Attribute moet worden geaccepteerd.",
            "accepted_if": ":Attribute moet worden geaccepteerd als :other :value is.",
            "active_url": ":Attribute is geen geldige URL.",
            "after": ":Attribute moet een datum na :date zijn.",
            "after_or_equal": ":Attribute moet een datum na of gelijk aan :date zijn.",
            "alpha": ":Attribute mag alleen letters bevatten.",
            "alpha_dash": ":Attribute mag alleen letters, nummers, underscores (_) en streepjes (-) bevatten.",
            "alpha_num": ":Attribute mag alleen letters en nummers bevatten.",
            "array": ":Attribute moet geselecteerde elementen bevatten.",
            "ascii": "De :attribute mag alleen alfanumerieke tekens en symbolen van \u00e9\u00e9n byte bevatten.",
            "before": ":Attribute moet een datum v\u00f3\u00f3r :date zijn.",
            "before_or_equal": ":Attribute moet een datum v\u00f3\u00f3r of gelijk aan :date zijn.",
            "between": {
                "array": ":Attribute moet tussen :min en :max waardes bevatten.",
                "file": ":Attribute moet tussen :min en :max kilobytes zijn.",
                "numeric": ":Attribute moet tussen :min en :max zijn.",
                "string": ":Attribute moet tussen :min en :max karakters zijn."
            },
            "boolean": ":Attribute moet ja of nee zijn.",
            "can": "Het veld :attribute bevat een niet-geautoriseerde waarde.",
            "confirmed": "Bevestiging van :attribute komt niet overeen.",
            "current_password": "Huidig wachtwoord is onjuist.",
            "date": ":Attribute moet een datum bevatten.",
            "date_equals": ":Attribute moet een datum gelijk aan :date zijn.",
            "date_format": ":Attribute voldoet niet aan het formaat :format.",
            "decimal": "De :attribute moet :decimal decimalen hebben.",
            "declined": ":Attribute moet afgewezen worden.",
            "declined_if": ":Attribute moet afgewezen worden wanneer :other gelijk is aan :value.",
            "different": ":Attribute en :other moeten verschillend zijn.",
            "digits": ":Attribute moet bestaan uit :digits cijfers.",
            "digits_between": ":Attribute moet bestaan uit minimaal :min en maximaal :max cijfers.",
            "dimensions": ":Attribute heeft geen geldige afmetingen voor afbeeldingen.",
            "distinct": ":Attribute heeft een dubbele waarde.",
            "doesnt_end_with": ":Attribute mag niet eindigen met \u00e9\u00e9n van de volgende waarden: :values.",
            "doesnt_start_with": ":Attribute mag niet beginnen met \u00e9\u00e9n van de volgende waarden: :values.",
            "email": ":Attribute is geen geldig e-mailadres.",
            "ends_with": ":Attribute moet met \u00e9\u00e9n van de volgende waarden eindigen: :values.",
            "enum": "Gekozen :attribute is ongeldig.",
            "exists": ":Attribute bestaat niet.",
            "file": ":Attribute moet een bestand zijn.",
            "filled": ":Attribute is verplicht.",
            "gt": {
                "array": ":Attribute moet meer dan :value waardes bevatten.",
                "file": ":Attribute moet groter zijn dan :value kilobytes.",
                "numeric": ":Attribute moet groter zijn dan :value.",
                "string": ":Attribute moet meer dan :value tekens bevatten."
            },
            "gte": {
                "array": ":Attribute moet :value of meer waardes bevatten.",
                "file": ":Attribute moet groter of gelijk zijn aan :value kilobytes.",
                "numeric": ":Attribute moet groter of gelijk zijn aan :value.",
                "string": ":Attribute moet minimaal :value tekens bevatten."
            },
            "image": ":Attribute moet een afbeelding zijn.",
            "in": ":Attribute is ongeldig.",
            "in_array": ":Attribute bestaat niet in :other.",
            "integer": ":Attribute moet een getal zijn.",
            "ip": ":Attribute moet een geldig IP-adres zijn.",
            "ipv4": ":Attribute moet een geldig IPv4-adres zijn.",
            "ipv6": ":Attribute moet een geldig IPv6-adres zijn.",
            "json": ":Attribute moet een geldige JSON-string zijn.",
            "lowercase": ":Attribute mag alleen kleine letters bevatten.",
            "lt": {
                "array": ":Attribute moet minder dan :value waardes bevatten.",
                "file": ":Attribute moet kleiner zijn dan :value kilobytes.",
                "numeric": ":Attribute moet kleiner zijn dan :value.",
                "string": ":Attribute moet minder dan :value tekens bevatten."
            },
            "lte": {
                "array": ":Attribute moet :value of minder waardes bevatten.",
                "file": ":Attribute moet kleiner of gelijk zijn aan :value kilobytes.",
                "numeric": ":Attribute moet kleiner of gelijk zijn aan :value.",
                "string": ":Attribute moet maximaal :value tekens bevatten."
            },
            "mac_address": ":Attribute moet een geldig MAC-adres zijn.",
            "max": {
                "array": ":Attribute mag niet meer dan :max waardes bevatten.",
                "file": ":Attribute mag niet meer dan :max kilobytes zijn.",
                "numeric": ":Attribute mag niet hoger dan :max zijn.",
                "string": ":Attribute mag niet uit meer dan :max tekens bestaan."
            },
            "max_digits": ":Attribute mag niet uit meer dan :max cijfers bestaan.",
            "mimes": ":Attribute moet een bestand zijn van het bestandstype :values.",
            "mimetypes": ":Attribute moet een bestand zijn van het bestandstype :values.",
            "min": {
                "array": ":Attribute moet minimaal :min waardes bevatten.",
                "file": ":Attribute moet minimaal :min kilobytes zijn.",
                "numeric": ":Attribute moet minimaal :min zijn.",
                "string": ":Attribute moet minimaal :min tekens zijn."
            },
            "min_digits": ":Attribute moet minimaal uit :min cijfers bestaan.",
            "missing": "Het veld :attribute moet ontbreken.",
            "missing_if": "Het veld :attribute moet ontbreken als :other :value is.",
            "missing_unless": "Het veld :attribute moet ontbreken, tenzij :other :value is",
            "missing_with": "Het veld :attribute moet ontbreken wanneer :values aanwezig is.",
            "missing_with_all": "Het veld :attribute moet ontbreken wanneer er :values aanwezig zijn.",
            "multiple_of": ":Attribute moet een veelvoud van :value zijn.",
            "not_in": ":Attribute is ongeldig.",
            "not_regex": "Het formaat van :attribute is ongeldig.",
            "numeric": ":Attribute moet een getal zijn.",
            "password": {
                "letters": ":Attribute moet minimaal \u00e9\u00e9n letter bevatten.",
                "mixed": ":Attribute moet minimaal \u00e9\u00e9n kleine letter en \u00e9\u00e9n hoofdletter bevatten.",
                "numbers": ":Attribute moet minimaal \u00e9\u00e9n cijfer bevatten.",
                "symbols": ":Attribute moet minimaal \u00e9\u00e9n vreemd teken bevatten.",
                "uncompromised": "Het opgegeven :attribute komt voor in een datalek. Kies een ander :attribute."
            },
            "present": ":Attribute moet aanwezig zijn.",
            "prohibited": ":Attribute is niet toegestaan.",
            "prohibited_if": ":Attribute is niet toegestaan indien :other gelijk is aan :value.",
            "prohibited_unless": ":Attribute is niet toegestaan tenzij :other gelijk is aan :values.",
            "prohibits": ":Attribute is niet toegestaan in combinatie met :other.",
            "regex": "Het formaat van :attribute is ongeldig.",
            "required": ":Attribute is verplicht.",
            "required_array_keys": ":Attribute moet waardes bevatten voor :values.",
            "required_field": "Dit veld is verplicht.",
            "required_if": ":Attribute is verplicht indien :other gelijk is aan :value.",
            "required_if_accepted": ":Attribute is verplicht indien :other is geaccepteerd.",
            "required_unless": ":Attribute is verplicht tenzij :other gelijk is aan :values.",
            "required_with": ":Attribute is verplicht in combinatie met :values.",
            "required_with_all": ":Attribute is verplicht in combinatie met :values.",
            "required_without": ":Attribute is verplicht als :values niet ingevuld is.",
            "required_without_all": ":Attribute is verplicht als :values niet ingevuld zijn.",
            "rgba_color": "Het veld :attribute moet een geldige Rgba kleur bevatten",
            "rgba_color_white": "Het veld :attribute mag niet wit zijn",
            "same": ":Attribute en :other moeten overeenkomen.",
            "size": {
                "array": ":Attribute moet :size waardes bevatten.",
                "file": ":Attribute moet :size kilobytes groot zijn.",
                "numeric": ":Attribute moet :size zijn.",
                "string": ":Attribute moet :size tekens zijn."
            },
            "starts_with": ":Attribute moet beginnen met een van de volgende: :values.",
            "string": ":Attribute moet een tekst zijn.",
            "timezone": ":Attribute moet een geldige tijdzone zijn.",
            "ulid": "De :attribute moet een geldige ULID zijn.",
            "unique": ":Attribute is al in gebruik.",
            "uploaded": "Het uploaden van :attribute is mislukt.",
            "uppercase": ":Attribute mag alleen hoofdletters bevatten.",
            "url": ":Attribute moet een geldige URL zijn.",
            "uuid": ":Attribute moet een geldige UUID zijn.",
            "youtube_video_url": ":Attribute moet een geldige YouTube video URL bevatten.",
            "vimeo_video_url": ":Attribute moet een geldige Vimeo video URL bevatten.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": {
                "primary_color": "Primaire kleur",
                "secondary_color": "Secondaire kleur",
                "primary_font_color": "Primaire lettertype kleur",
                "secondary_font_color": "Secondaire lettertype kleur",
                "primary_font_family": "Primaire lettertype",
                "secondary_font_family": "Secondaire lettertype",
                "available_languages": "Beschikbare talen",
                "is_global": "Globale Micro Game",
                "organisations": "Organisaties",
                "start_date": "Startdatum",
                "end_date": "Einddatum",
                "confirm": "Bevestiging",
                "total_questions_used": "Aantal te tonen vragen",
                "file": "Bestand"
            }
        },
        "webhook": {
            "webhooks": "Webhooks",
            "trigger": "Trigger webhook",
            "description": "Verstuur webhooks voor events uit het verleden.",
            "events": "Events",
            "select": {
                "organisation": "Selecteer een organisatie",
                "event": "Selecteer een event"
            },
            "properties": {
                "start_date": "Startdatum",
                "end_date": "Einddatum"
            },
            "events_sent_successfully": "Webhook events die verstuurd zijn tussen :startDate en :endDate zijn opnieuw verstuurd",
            "amount_of_calls": "Aantal webhook calls"
        }
    }
};